/* eslint-disable eqeqeq */
/* eslint-disable default-case */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-concat */
/* eslint-disable no-eval */
/* eslint-disable no-useless-escape */
import $, { Deferred } from "jquery";
import moment, { relativeTimeRounding } from "moment";
import admin, { lockTable, unlockTable, getTableMate, getFeature, getMyStatus, getPickupTableNumber, getHomeDeliveryTableNumber, selectTableOccupationSelected, selectTableNumberSelected, isHomeDelivery, hasRole } from "./admin";
import { update, updateTableMates, states, getTableOccupation, getTable, getDuration, simpleChangeStateByTableAndMenuItem, tmplparams, playNewAcceptedOrderSound, getTableName, getOrdersByTableNumber } from "./order-list-util";
import {
  resetPreSelection,
  updateTableOccupationsAndSelect,
  showEditTable,
  tableMatePaid,
  markTableMateForPayment,
  selectNewOrders,
  getAmountsToPay,
  getAmountsPaid,
  getStateIndex,
  updateRightPane,
  showMap,
  initEditTable,
} from "./tables-overview";
import auth, { select, ajaxCallStart, ajaxCallEnd, getSetting, choiceDialog2, isElementInViewport, messageDialog, _floatTableHead, featureEnabled, put, post, get, clickHandler123, resetLockTimeout, getInputDialog, _log, patch } from "./auth";
import { I18n } from "react-redux-i18n";
import orderListUtil from "./order-list-util";
import { _preProcessOrders, alltimings } from "./order-grouping";
import SortedMap from "sortedmap";
import { createTree } from "jquery.fancytree";
import TableReservationComponent from "../main/tableReservations/TableReservationComponent";
import { createSvgIcon } from "@material-ui/core";
import { featureGroup } from "leaflet";
import { split } from "lodash";
import EatWithMeActions, { resetMyStatus } from "../actions/EatWithMeActions";
import { store } from "..";
import { RestaurantRounded } from "@material-ui/icons";

var nextState = { cancelled: null, ordered: "accepted", accepted: "delivered", producing: null, ready: "delivered", delivering: "delivered", delivered: null, paid: null };
const tableLayout = {
  tableMap: new Map(),
  tables: null,
  table_edit_mode: false,
  editModeTableStrokeWidth: 6,
  editModeTableStrokeColor: "#ff5a00",
  editModeCornerRadius: 7,
  editModeCornerFill: "#ff5a00",
  editModeCornerStroke: "#ffffff",
  editModeResizeEdgePx: 10,
  editModeResizeCornerHitPx: 2,
  contextmenu: false,
  roomView: false,
  showSeats: false,
  dragHelperTableId: null,
  suppressNextSelectionClick: false,
  panelPositions: {},
  reset: () => {
    tableLayout.showSeats = auth.device.platform === "browser" || auth.device.model && auth.device.model.indexOf("iPad") >= 0 || auth.device.model && auth.device.model.indexOf("SM-X") >= 0;
    delete localStorage.roomView;
    tableLayout.platformOpenUpdated = false;
    tableLayout.svgs = {};
    delete tableLayout.div;
    tableLayout.initTemplates();
    tableLayout.width = null;
    tableLayout.height = null;
    tableLayout.tableOccupationsCache = {};
    tableLayout.tableDecorationCache = {}
    tableLayout.table_edit_mode = false;
    tableLayout.dragHelperTableId = null;
    tableLayout.panelPositions = {};
    tableLayout.roomView = false;
    $("#table-layout-mode-controls").remove();
    $("#table-layout-create-controls").remove();
    if (tableLayout.SVG) {
      if (tableLayout.SVG.parent() != null) {
        tableLayout.SVG.parent().remove();
      }
      tableLayout.SVG = null;
      if (tableLayout.rotatedSVG != null) {
        if (tableLayout.rotatedSVG.parent() != null) tableLayout.rotatedSVG.parent().remove();
        tableLayout.rotatedSVG = null;
      }
    }
  },
  bookingListTimeout: null,
  constuctor: function () {
    $("#bookingList button.cancel").click(() => {
      var data = tableLayout.bookingList.getActiveNode().data;
      admin.unbookTable(data.tableOccupation.id, -1, true, function (data) {
        update(data);
      });
    });

    $("#bookingList button.activate").click(() => {
      var data = tableLayout.bookingList.getActiveNode().data;
      admin.activateBooking(data.tableOccupation.id, -1, function (data) {
        update(data);
      });
    });

    tableLayout.bookingList = createTree("#bookingList table", {
      checkbox: false,
      titlesTabbable: true, // Add all node titles to TAB chain
      source: [],
      zindex: 1000,
      icon: false,
      extensions: ["table", "gridnav"],
      selectMode: 0,
      table: {
        checkboxColumnIdx: 0,
        nodeColumnIdx: 0
      },
      gridnav: {
        autofocusInput: false, // Focus first embedded input if node
        // gets activated
        handleCursorKeys: true
      },
      activate: function (event, data) {
        // A node was activated: display its title:
        data = data.node.data;
        var deselectedClass = "faded";

        var tables = $("g.eatwithme-table")
          .parent()
          .parent();
        var deselectedClass = "faded";
        tables.addClass(deselectedClass);
        $("line.table-connections").addClass(deselectedClass);

        data.tableOccupation.restaurantTables.forEach(table => {
          var tableNumber = table.restaurantTable.number;
          var tables = $("g#" + tableNumber + ".eatwithme-table");
          tables.parent().parent();
          tables
            .parent()
            .parent()
            .removeClass(deselectedClass);
          tables.addClass("selected");
        });

        $("#bookingList")
          .parent()
          .addClass("active");

        if (tableLayout.bookingListTimeout != null) clearTimeout(tableLayout.bookingListTimeout);

        tableLayout.bookingListTimeout = setTimeout(function () {
          tableLayout.bookingListTimeout = null;
          $(event.currentTarget).removeClass("active");
          var tables = $(".eatwithme-table.selected").removeClass("selected");
          resetPreSelection();
          $("#bookingList")
            .parent()
            .removeClass("active");
        }, 3000);
      },
      renderColumns: function (event, data) {
        var node = data.node,
          $tdList = $(node.tr).find(">td");

        var c = 0;
        $tdList.eq(c).html("<div class='booking-time'><span class='start'>" + moment(node.data.tableOccupation.bookedOccupationStart).format("HH:mm") + "</span><span class='end'>" + moment(node.data.tableOccupation.bookedOccupationEnd).format("HH:mm") + "<span></div>");
        c++;
        if (node.data.tableOccupation.leadCustomerId && getTableMate(node.data.tableOccupation.leadCustomerId).tableMate.name)
          $tdList.eq(c).html("<div class='booking-details'>" + node.data.tableOccupation.bookedProperties.name + " (" + getTableMate(node.data.tableOccupation.leadCustomerId).tableMate.name + ")" + "<br/><small>" + node.data.tableOccupation.bookedProperties.email + "</small>" + "<br/><small>" + node.data.tableOccupation.bookedProperties.phone + "</small></div>");
        else
          $tdList.eq(c).html("<div class='booking-details'>" + node.data.tableOccupation.bookedProperties.name + "<br/><small>" + node.data.tableOccupation.bookedProperties.phone + "</small></div>");
        c++;
        var seats = 0;
        if (node.data.tableOccupation.bookedProperties.seats)
          Object.keys(node.data.tableOccupation.bookedProperties.seats).forEach(s => {
            seats += Number(s);
          });
        $tdList.eq(c).html(seats);
        c++;
        var tables = "";
        node.data.tableOccupation.restaurantTables.forEach(table => {
          if (table.restaurantTable === null) return;
          if (tables != "") tables += ",";
          tables += getTableName(table.restaurantTable.number);
        });
        $tdList.eq(c).html(tables);
      }
    });
  },
  initialize: function () {
    var data = null;
    auth.myStatus.restaurant_floorplans.forEach(floorplan => {
      if (floorplan.id == auth.myStatus.restaurant_active_floorplan) {
        data = floorplan;
      }
    });

    if (tableLayout.SVG != null) {
      //tableLayout.renderSVG(tableLayout.getOrientation());
      return;
    }
    $("#floorplan").css("align-items", "center");
    $("#c").empty();
    tableLayout.floorplan = data;
    $(tableLayout.floorplan).css("display", "none");
    $(tableLayout.floorplan).attr("level", "0");
    $(tableLayout.floorplan).addClass("selectable");
    var div = $("<div/>");
    $("#c").append(div);
    if (tableLayout.floorplan != null) {
      div.append($(tableLayout.floorplan.floorplan));
      $(tableLayout.floorplan).css("display", "unset");
    }

    $("#floorplan").scroll(function () {
      var orientation = tableLayout.getOrientation();
      if (orientation == tableLayout.orientation) {
        if (orientation == "landscape") {
          tableLayout.landscapeScrollPosTop = $(this).scrollTop();
          tableLayout.landscapeScrollPosLeft = $(this).scrollLeft();
        } else {
          tableLayout.portraitScrollPosTop = $(this).scrollTop();
          tableLayout.portraitScrollPosLeft = $(this).scrollLeft();
        }
      }
    });

    var svg = $("#c svg");
    svg.css("display", null);
    if (svg.length == 0) return;
    /*
    svg.attr("width", null);
    svg.attr("height", null);
    svg.css("width", "unset");
    svg.css("height", "unset");
    svg.css("left", "50%");
    svg.css("transform", "translate(-50%, -50%)");
    */
    svg.css("transform", "");
    svg.css("left", "");
    svg.css("width", "");
    svg.css("height", "");
    svg.css("zoom", "");

    var svg = $("#c svg");
    tableLayout.SVG = tableLayout.originalSVG = svg;

    tableLayout.renderSVG(tableLayout.getOrientation());

    svg.mousedown(function (e) {
      tableLayout.mousedown = e.pageX + '-' + e.pageY;
      setTimeout(function () {
        if (tableLayout.mousedown == e.pageX + '-' + e.pageY && !tableLayout.dragging) {
          $(e.target).trigger($.Event('contextmenu', { data: e.data, pageX: e.pageX, pageY: e.pageY }));
        }
      }, 1000);
    });

    svg.dblclick(function (e) {
      var x = e.offsetX;
      var y = e.offsetY;
      var t = this;
      if (window.mobileAndTabletcheck()) {
        setTimeout(function (e) {
          var f = $("#floorplan");
          var width = $(t).attr("style");
          if (width.indexOf("width: 200%") >= 0) {
            $(t).css("width", "100%");
            $(t).css("height", "100%");
            f.scrollLeft(0);
            f.scrollTop(0);
          } else {
            $(t).css("width", "200%");
            $(t).css("height", "200%");
            var fullWidth = f.get(0).scrollWidth;
            var visibleWidth = f.get(0).clientWidth;
            var x1 = Math.max(0, (x * fullWidth) / visibleWidth - visibleWidth / 2);

            var fullHeight = f.get(0).scrollHeight;
            var visibleHeight = f.get(0).clientHeight;
            var y1 = Math.max(0, (y * fullHeight) / visibleHeight - visibleHeight / 2);

            f.scrollLeft(x1);
            f.scrollTop(y1);
          }
        }, 100);
      }
    });
    svg.mouseup(function (event) {
      tableLayout.mousedown = null;
    });

    tableLayout.initTableContextMenu();
    tableLayout.renderLayoutModeControls();
    tableLayout.renderLayoutCreateControls();

    try {
      $.contextMenu("destroy", "#c svg");
    } catch (ex) {
    }

    if (localStorage.roomView && !tableLayout.roomView) {
      $('#c svg[visible="true"] #' + localStorage.roomView + ".eatwithme-room text").click();
    }

  },

  SVG: null,
  rotatedSVG: null,
  width: null,
  height: null,

  landscapeScrollPosTop: 0,
  landscapeScrollPosLeft: 0,
  portraitScrollPosTop: 0,
  portraitScrollPosLeft: 0,
  orientation: null,
  rotatedZoom: 0,

  getOrientation: function () {
    var floorPlan = $("#floorplan").parent();
    var rect = { width: floorPlan.width(), height: floorPlan.height() };
    var viewport = tableLayout.SVG.get(0).viewBox.baseVal;

    var aspectOuter = rect.width / rect.height;
    var aspectInner = viewport.width / viewport.height;

    var orientation = (aspectOuter > 1 && aspectInner > 1) || (aspectOuter < 1 && aspectInner < 1) ? "landscape" : "portrait";
    //var orientation = auth.device.platform != 'browser' ? (window.orientation==0 || window.orientation==180 ? "portrait" : "landscape") : (window.innerWidth>window.innerHeight ? "landscape" : "portrait");
    return orientation;
  },

  getScreenOrientation: function () {
    return auth.device.platform != "browser" ? (window.orientation == 0 || window.orientation == 180 ? "portrait" : "landscape") : window.innerWidth > window.innerHeight ? "landscape" : "portrait";
  },

  getActiveLayout: function () {
    var orientation = tableLayout.getOrientation();
    if (orientation == "portrait") return tableLayout.rotatedSVG;
    else return tableLayout.SVG;
  },

  svgs: {},

  renderSVG: function (originalOrientation) {

    var def = $.Deferred();
    //if (tableLayout.tables==null)
    //	return;
    if (tableLayout.SVG == null) {
      def.resolve();
      return def.promise();
    }
    //$("#c").css("zoom", 1);
    $("#c").css("transform", null);
    //$("#c").css("height", "100%");
    var floorPlan = $("#floorplan");
    var floorPlanMain = floorPlan.parent();
    const room = floorPlan.hasClass("room");
    tableLayout.z = 1;
    var rect = { width: floorPlan.get(0).getBoundingClientRect().width, height: floorPlan.get(0).getBoundingClientRect().height };
    var viewport = tableLayout.SVG.get(0).viewBox.baseVal;

    var orientation = tableLayout.getOrientation();
    if (orientation == tableLayout.orientation && tableLayout.width == rect.width && tableLayout.height == rect.height) {
      def.resolve();
      return def.promise();
    }
    //tableLayout.SVG.css("transform", "translate(-50%, -50%)");
    //if (orientation == "portrait" && (tableLayout.rotatedSVG == null || tableLayout.width != rect.width || tableLayout.height != rect.height)) {
    if (orientation == "portrait" /*&& (tableLayout.rotatedSVG == null || !tableLayout.svgs["svg_" + originalOrientation + "_" + Math.round(viewport.width) + "_" + Math.round(viewport.height)])*/) {

      tableLayout.width = rect.width;
      tableLayout.height = rect.height;
      if (tableLayout.rotatedSVG != null) {
        //tableLayout.rotatedSVG.parent().remove();
        tableLayout.rotatedSVG.hide();
        tableLayout.rotatedSVG.parent().hide();
        tableLayout.rotatedSVG = null;
      }
      //setTimeout(function() {
      if (tableLayout.rotatedSVG != null) return;
      rect = { width: floorPlanMain.width(), height: floorPlanMain.height() };
      orientation = tableLayout.getOrientation();
      tableLayout.SVG.show();

      //tableLayout.SVG.css("height", "100%");

      tableLayout.rotatedSVG = tableLayout.SVG.clone();
      tableLayout.tableDecorationCache = {}
      //tableLayout.rotatedSVG.css("transform", "translate(-50%,-50%)");

      tableLayout.SVG.hide();
      tableLayout.SVG.attr("visible", null);
      var div;
      if (!tableLayout.div) {
        div = tableLayout.div = $("<div/>");
        $("#c").append(div);
      } else {
        div = tableLayout.div;
      }

      var rotatedSVG = $(tableLayout.rotatedSVG);
      var width, height, rect, x, y, width1, height1;
      var viewport = rotatedSVG.get(0).viewBox.baseVal;
      floorPlan.attr("visible", true);
      floorPlan.attr("variant", "");
      tableLayout.SVG.attr("visible", null);
      if (viewport.width > viewport.height)
        var z = (tableLayout.z = Math.min(viewport.width / viewport.height, rect.height / rect.width));
      else
        var z = (tableLayout.z = Math.min(viewport.height / viewport.width, rect.width / rect.height));
      tableLayout.rotatedZoom = z;
      var transform = "rotate(90deg) scale(" + z + "," + z + ")";
      rotatedSVG.css("transform", transform);
      rotatedSVG.css("display", null);
      rotatedSVG.attr("visible", true);
      div.append(tableLayout.rotatedSVG);
      div.show();
      rotatedSVG
        .find("tspan.eatwithme-tableNumber")
        .parent()
        .each(function (ind, item) {
          var transform = $(item).attr("transform_old");
          if (!transform) transform = $(item).attr("transform");
          else $(item).attr("transform", transform);
          var rect = $(item).parent().get(0).getBBox();

          $(item).attr("width1", rect.width);
          $(item).attr("transform_old", transform);

          const g = tableLayout.makeSVG("g", { "transform": "rotate(-90 " + (rect.x + rect.width / 2) + " " + (rect.y + rect.height / 2) + ")" });
          $(item).parent().append(g);
          $(item).appendTo(g);

        });


      div.hide();

      div.hide();
      tableLayout.rotatedSVG.find("g.eatwithme-table").unbind("click");
      tableLayout.rotatedSVG.find("g.eatwithme-table").click(tableLayout.tableClickHandler);

      /*
      tableLayout.rotatedSVG.find("g.eatwithme-table").each(function (ind, t) {
        t.addEventListener("click", tableLayout.tableClickHandler, true);
      });
      */

      tableLayout.registerRoomClickHandlers(tableLayout.rotatedSVG);

      //$('text.eatwithme-roomName').each(function(ind, t) { t.addEventListener("touchend", tableLayout.roomClickHandler, true)});
      $("#c").css("-moz-transform-origin", "0 0");
      /*
        if (orientation=='landscape') {
          tableLayout.SVG.css('height', '100%');
          tableLayout.SVG.css('width', 'unset');
          $('#floorplan').css('display','unset');
        } else {
          tableLayout.rotatedSVG.css('width', '100%');
          tableLayout.rotatedSVG.css('height', 'unset');
          tableLayout.rotatedSVG.css('left', 'unset');
          $('#floorplan').css('display','flex');
        }
        */
      //$("#c").css("height", "unset");
      tableLayout.rotatedSVG.css("width", "");
      tableLayout.rotatedSVG.css("height", "");
      var aspectOuter = floorPlanMain.width() / floorPlanMain.height();
      var viewport = tableLayout.rotatedSVG.get(0).viewBox.baseVal;
      var aspectInner = viewport.height / viewport.width;
      if ((aspectOuter <= 1 && aspectInner <= 1) || (aspectOuter >= 1 && aspectInner >= 1)) {
        if (aspectOuter > aspectInner) {
          if (room === true) {
            tableLayout.rotatedSVG.css("width", floorPlanMain.height() / z + "px");
          } else {
            tableLayout.rotatedSVG.css("width", floorPlanMain.height() / z + "px");
          }
          floorPlan.attr("aspect", 1);
          if (aspectOuter <= 1 && aspectInner <= 1) {
            tableLayout.rotatedSVG.css("height", ((floorPlanMain.width() / z) * aspectInner) / aspectOuter + "px");
            floorPlan.attr("variant", 1);
          } else {
            tableLayout.rotatedSVG.css("height", ((floorPlanMain.width() / z) * aspectInner) / aspectOuter + "px");
            floorPlan.attr("variant", 2);
          }
          floorPlan.attr("orientation", "portrait");
        } else {
          floorPlan.attr("aspect", 2);
          if (aspectOuter <= 1 && aspectInner <= 1) {
            floorPlan.attr("variant", 1);
            floorPlan.attr("orientation", "portrait");
          } else {
            tableLayout.rotatedSVG.css("height", ((floorPlanMain.width() / z) * aspectInner) / aspectOuter + "px");
            floorPlan.attr("variant", 2);
          }
        }
      } else {
        if (aspectOuter > aspectInner) {
          floorPlan.attr("aspect", 3);
        } else {
          floorPlan.attr("aspect", 4);
        }
        floorPlan.attr("orientation", "portrait");
      }
      tableLayout.rotatedSVG.attr("variant", floorPlan.attr("variant"));
      tableLayout.rotatedSVG.attr("orientation", floorPlan.attr("orientation"));
      tableLayout.rotatedSVG.attr("aspect", floorPlan.attr("aspect"));

      tableLayout.SVG.parent().hide();
      tableLayout.rotatedSVG.parent().show();
      //floorPlan.attr("orientation", "portrait");

      def.resolve();

      if (!originalOrientation)
        console.log("error");

      tableLayout.svgs["svg_" + originalOrientation + "_" + Math.round(viewport.width) + "_" + Math.round(viewport.height)] = tableLayout.rotatedSVG;


      //tableLayout.updateTableOccupations();

      //}, 10);
    } else {
      try {
        const div = tableLayout.SVG.parent();
        tableLayout.SVG.hide();
        tableLayout.SVG.attr("visible", "false");
        tableLayout.SVG = tableLayout.originalSVG.clone();


        div.append(tableLayout.SVG);
        tableLayout.SVG.show();
        tableLayout.SVG.find("g.eatwithme-table").unbind("click");
        tableLayout.SVG.attr("visible", true);
        tableLayout.SVG.find("g.eatwithme-table").click(tableLayout.tableClickHandler);

        /*
        tableLayout.SVG.find("svg[visible = 'true'] g.eatwithme-table").each(function (ind, t) {
          t.addEventListener("click", tableLayout.tableClickHandler, true);
        });
        */

        tableLayout.registerRoomClickHandlers(tableLayout.SVG);

        if (orientation !== tableLayout.orientation)
          tableLayout.tableDecorationCache = {}

        floorPlan.attr("orientation", "landscape");
        tableLayout.SVG.css("width", "");
        tableLayout.SVG.css("height", "");
        if (tableLayout.rotatedSVG !== null) {
          tableLayout.rotatedSVG.parent().hide();
          tableLayout.SVG.parent().show();
          tableLayout.rotatedSVG.parent().hide();
          tableLayout.SVG.show();
          floorPlan.attr("visible", null);
        }
        $("#c").css("-moz-transform-origin", "0 0");

        var aspectOuter = floorPlanMain.width() / floorPlanMain.height();
        floorPlan.attr("variant", "");
        var viewport = tableLayout.SVG.get(0).viewBox.baseVal;
        var aspectInner = viewport.width / viewport.height;
        var z = (tableLayout.z = Math.min(viewport.width / viewport.height, rect.height / rect.width));
        if ((aspectOuter <= 1 && aspectInner <= 1) || (aspectOuter >= 1 && aspectInner >= 1)) {
          if (aspectOuter > aspectInner) {
            floorPlan.attr("aspect", 1);
            if (auth.device.platform == "iOS" || auth.device.model == "Safari") {
              tableLayout.SVG.css("height", floorPlanMain.height() + "px");
            }
            floorPlan.attr("orientation", "portrait");
            if (aspectOuter <= 1 && aspectInner <= 1) {
            } else {
              if (auth.device.platform == "iOS" || auth.device.model == "Safari") {
              } else {
                tableLayout.SVG.css("width", "100%");
              }
            }
          } else {
            //if (auth.device.platform == "iOS" || auth.device.model == "Safari") {
            //$("#c").css("transform", "translate(-50%, 50%)");
            //}
            //}
            //tableLayout.SVG.css("height", (floorPlanMain.height() / aspectInner) * aspectOuter + "px");
            floorPlan.attr("aspect", 2);
            if (aspectOuter <= 1 && aspectInner <= 1) {
              floorPlan.attr("variant", 1);
              floorPlan.attr("orientation", "portrait");
            } else {
              tableLayout.SVG.css("height", "100%")
              //tableLayout.SVG.css("height", ((floorPlanMain.width() / z) * aspectInner) / aspectOuter + "px");
              floorPlan.attr("variant", 2);
            }

          }
          $("#floorplan").css("display", "flex");
          if (auth.device.platform == "iOS" || auth.device.model == "Safari") {
            //$("#c").css("top", "unset");
            //$("#c").css("height", "unset");
          }
          tableLayout.SVG.attr("variant", floorPlan.attr("variant"));
          tableLayout.SVG.attr("aspect", floorPlan.attr("aspect"));
          tableLayout.SVG.attr("orientation", floorPlan.attr("orientation"));
          if (!originalOrientation) {
            console.log("error");
          }

          tableLayout.svgs["svg_" + originalOrientation + "_" + Math.round(viewport.width) + "_" + Math.round(viewport.height)] = tableLayout.SVG;
        }

        def.resolve();
        //tableLayout.updateTableOccupations();
      } catch (ex) {
        console.error(ex);
        //alert(ex);
      }
    }
    tableLayout.orientation = orientation;
    /*
    setTimeout(function() {
      if (tableLayout.orientation == "landscape") {
        floorPlan.scrollTop(tableLayout.landscapeScrollPosTop);
        floorPlan.scrollLeft(tableLayout.landscapeScrollPosLeft);
      } else {
        floorPlan.scrollTop(tableLayout.portraitScrollPosTop);
        floorPlan.scrollLeft(tableLayout.portraitScrollPosLeft);
      }
    }, 100);
    */
    //console.log(orientation, floorPlan.attr('aspect'), floorPlan.attr('variant'));

    return def.promise();
  },

  registerRoomClickHandlers: (svg) => {
    svg.find("text.eatwithme-roomName").unbind("click");
    svg.find("text.eatwithme-roomName").click(tableLayout.roomClickHandler);
    if (!tableLayout.showSeats) {
      svg.find("text.eatwithme-roomName").parent().unbind("click");
      svg.find("text.eatwithme-roomName").parent().click(tableLayout.roomClickHandler);
    }
  },

  roomClickHandler: function (e) {
    if (e)
      e.stopPropagation();
    auth.vibrateOk();
    if (tableLayout.table_edit_mode) return;
    var orientation = tableLayout.getOrientation();

    function reset(svg) {
      if (tableLayout.SVG.get(0).getAttribute("viewBox_bk") !== null) svg.setAttribute("viewBox", tableLayout.SVG.get(0).getAttribute("viewBox_bk"));
      svg.removeAttribute("viewBox_bk");
    }
    function set(svg, x, y, width, height) {
      svg.setAttribute("viewBox_bk", tableLayout.SVG.get(0).getAttribute("viewBox"));
      svg.setAttribute("viewBox", x + " " + y + " " + width + " " + height);
    }

    var svg;
    if (tableLayout.roomView == true) {
      delete localStorage.roomView;
      //console.log("switch to full view");
      //if (tableLayout.rotatedSVG != null) reset(tableLayout.rotatedSVG.get(0));
      //reset(tableLayout.SVG.get(0));
      tableLayout.width = null;
      tableLayout.orientation = null;
      var width = tableLayout.originalSVG.attr("viewBox_bk").split(" ")[2];
      var height = tableLayout.originalSVG.attr("viewBox_bk").split(" ")[3];
      tableLayout.originalSVG.attr("viewBox", tableLayout.originalSVG.attr("viewBox_bk"));
      tableLayout.SVG.hide();
      tableLayout.SVG.parent().hide();
      if (tableLayout.rotatedSVG) {
        tableLayout.rotatedSVG.hide();
        tableLayout.rotatedSVG.parent().hide();
      }
      tableLayout.SVG = tableLayout.originalSVG;
      if (tableLayout.getOrientation() === "landscape") {
        tableLayout.SVG = tableLayout.svgs["svg_" + tableLayout.getOrientation() + "_" + Math.round(width) + "_" + Math.round(height)];
        if (!tableLayout.SVG) {
          tableLayout.SVG = tableLayout.originalSVG;
          tableLayout.renderSVG(tableLayout.getOrientation());
        } else {
          $("#floorplan").attr("variant", tableLayout.SVG.attr("variant"));
          $("#floorplan").attr("aspect", tableLayout.SVG.attr("aspect"));
          $("#floorplan").attr("orientation", tableLayout.SVG.attr("orientation"));
          tableLayout.SVG.show();
          tableLayout.SVG.parent().show();
        }
      } else {
        if (tableLayout.svgs["svg_" + tableLayout.getOrientation() + "_" + Math.round(width) + "_" + Math.round(height)]) {
          tableLayout.rotatedSVG = tableLayout.svgs["svg_" + tableLayout.getOrientation() + "_" + Math.round(width) + "_" + Math.round(height)];

          $("#floorplan").attr("variant", tableLayout.rotatedSVG.attr("variant"));
          $("#floorplan").attr("aspect", tableLayout.rotatedSVG.attr("aspect"));
          $("#floorplan").attr("orientation", tableLayout.rotatedSVG.attr("orientation"));
          tableLayout.rotatedSVG.show();
          tableLayout.rotatedSVG.parent().show();
        } else {
          tableLayout.renderSVG();
        }
      }
      if (orderListUtil.allOrders)
        tableLayout.updateTableOccupations();
      tableLayout.roomView = false;
      //$("#main .movableBox").show();
      $("#floorplan").removeClass("room");
      tableLayout.renderLayoutModeControls();
      tableLayout.renderLayoutCreateControls();
      return;
    }

    var room = $(e.currentTarget).hasClass("eatwithme-room") ? $(e.currentTarget) : $(e.currentTarget).parents(".eatwithme-room");
    localStorage.roomView = room.attr("id");
    room = room.parent();

    //console.log("switch to room view");
    $("#floorplan").addClass("room");
    var width = $(room).find("rect").attr("width");
    var height = $(room).find("rect").attr("height");

    var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec($(room).find("rect").parent().attr("transform"));
    if (matches != null) {
      width *= parseFloat(matches[1]);
      height *= parseFloat(matches[2]);
    }

    var position = $(room).find("rect").get(0).getBoundingClientRect();
    var base = tableLayout.SVG.get(0).viewBox.baseVal;
    var original_transform = room.attr("transform");
    var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(original_transform);
    var floorPlan = $("#floorplan");

    tableLayout.SVG.show();

    orientation = tableLayout.getOrientation();

    if (tableLayout.svgs["svg_" + orientation + "_" + Math.round(width) + "_" + Math.round(height)]) {
      tableLayout.SVG.hide();
      tableLayout.SVG.parent().hide();
      tableLayout.SVG.attr("visible", null);
      if (tableLayout.rotatedSVG) {
        tableLayout.rotatedSVG.hide();
        tableLayout.rotatedSVG.parent().hide();
      }
      if (orientation === "landscape") {
        tableLayout.SVG = tableLayout.svgs["svg_" + orientation + "_" + Math.round(width) + "_" + Math.round(height)];
        tableLayout.SVG.parent().show();
        tableLayout.SVG.show();
        tableLayout.SVG.attr("visible", true)
        floorPlan.attr("variant", tableLayout.SVG.attr("variant"));
        floorPlan.attr("aspect", tableLayout.SVG.attr("aspect"));
        floorPlan.attr("orientation", tableLayout.SVG.attr("orientation"));
      } else {
        tableLayout.rotatedSVG = tableLayout.svgs["svg_" + orientation + "_" + Math.round(width) + "_" + Math.round(height)];
        tableLayout.rotatedSVG.parent().show();
        tableLayout.rotatedSVG.show();
        tableLayout.rotatedSVG.attr("visible", true)
        floorPlan.attr("variant", tableLayout.rotatedSVG.attr("variant"));
        floorPlan.attr("aspect", tableLayout.rotatedSVG.attr("aspect"));
        floorPlan.attr("orientation", tableLayout.rotatedSVG.attr("orientation"));
      }
      floorPlan.attr("visible", true);
    } else {
      tableLayout.SVG.hide();
      tableLayout.SVG = tableLayout.originalSVG;
      set(tableLayout.SVG.get(0), matches[1], matches[2], width, height);
      //if (tableLayout.rotatedSVG != null) set(tableLayout.rotatedSVG.get(0), matches[1], matches[2], width, height);
      tableLayout.width = null;
      tableLayout.orientation = null;
      //var shift = -((matches[1]/.38)+Number(width/2));
      //tableLayout.SVG.data("shiftY", shift);
      tableLayout.renderSVG(orientation);
    }
    if (orderListUtil.allOrders)
      tableLayout.updateTableOccupations();
    tableLayout.roomView = true;

    $("#main .movableBox").hide();
    tableLayout.renderLayoutModeControls();
    tableLayout.renderLayoutCreateControls();
  },
  tableClickHandler: function (e) {
    const now = new Date().getTime();
    var activeBooking = tableLayout.bookingList.getActiveNode();
    if (activeBooking != null) activeBooking.setActive(false);

    if (typeof orderListUtil.ordersCache == "undefined") return;
    resetLockTimeout();
    if (tableLayout.table_edit_mode) return;
    if (e.isDefaultPrevented && e.isDefaultPrevented()) return;

    var $trigger = $(e.currentTarget);
    if (e.currentTarget.nodeName === "tspan") {
      //it is the name of the guest
      $trigger = $trigger.parent().parent().find('.eatwithme-table.selectable')
    }
    if (!$trigger.hasClass("selectable")) {
      $trigger = $($trigger.parents(".selectable")[0]);
    }
    if (!$trigger.hasClass("eatwithme-table")) {
      $trigger = $($trigger.parents(".eatwithme-table")[0]);
    }
    tableLayout.pre_selected_action = $("button.pre-selected-action.active").attr("id");
    if (
      $trigger.parent().parent().hasClass("faded")
    )
      return;
    if ($trigger.hasClass("inactive")) return;
    if ($trigger.hasClass("eatwithme-table")) {
      localStorage.selectNewOrders = false;
      e.preventDefault();
      $("button.pre-selected-action.active").removeClass("active");
      if ($trigger.attr("tableOccupations") == null) {
        // if ($trigger.hasClass('selected')) {
        selectTableNumberSelected($trigger.attr("id"));

        if (auth.device.platform != "browser" && auth.myStatus.restaurant_settings.ordering && auth.myStatus.restaurant_settings.ordering.menuorder && (sessionStorage.tableNumberSelected == getPickupTableNumber() || sessionStorage.tableNumberSelected == getHomeDeliveryTableNumber())) {
          _log("Homedelivery/pickup not opened");
          return;
        }

        const table = getTable(sessionStorage.tableNumberSelected);
        if (!table) {
          console.error("Strange: could not find table " + sessionStorage.tableNumberSelected);
          return;
        }
        const tableNumber = Number(sessionStorage.tableNumberSelected);
        orderListUtil.kioskMode = table.pos;
        const isTakeaway = tableNumber === auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"] || tableNumber === auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"];

        if (tableLayout.pre_selected_action == "pre-lock") {
          lockTable(sessionStorage.tableNumberSelected, 1, updateTableOccupationsAndSelect);
          return;
        } else if (tableLayout.pre_selected_action == "pre-unlock") {
          return;
        }
        updateTableMates().done(function () {
          auth.vibrateOk();
          showEditTable();
          orderListUtil.processOrders(orderListUtil.ordersCache);
          tableLayout.updateTableOccupations();
          if (tableLayout.pre_selected_action == null && !isTakeaway) tableLayout.pre_selected_action = "pre-lock-order";
          if (tableLayout.pre_selected_action == "pre-lock-order") {
            function f(seat = 1) {
              ajaxCallStart("lockTable");
              lockTable(
                sessionStorage.tableNumberSelected,
                Math.max(seat, 1),
                data => {
                  ajaxCallEnd("lockTable");
                  updateTableOccupationsAndSelect(data, true);
                },
                () => {
                  ajaxCallEnd("lockTable");
                }
              );
            }
            if (auth.myStatus.restaurant_settings["tables-overview"].askPersonCount)
              getInputDialog(I18n.t("local.question"), I18n.t("admin_local.person_count"), "", "number").done((choice, seat) => {
                f(seat);
              }).fail(f);
            else
              f();
            return;
          } else if (tableLayout.pre_selected_action == "pre-paid") {
            tableMatePaid();
            return;
          } else {
          }
        });
        // } else {
        // select($trigger);
        // }
        return;
      }
      // if ($trigger.hasClass('selected')) {
      selectTableNumberSelected($trigger.attr("id"));

      const table = getTable(sessionStorage.tableNumberSelected);
      orderListUtil.kioskMode = table.pos;
      updateTableMates().done(function () {
        if (tableLayout.pre_selected_action == "pre-lock") {
          if ($trigger.hasClass("shareable")) lockTable(sessionStorage.tableNumberSelected, updateTableOccupationsAndSelect);
          return;
        } else if (tableLayout.pre_selected_action == "pre-paying" && orderListUtil.occupationsSelected.length == 1) {
          var print = getSetting("tables-overview.pre-paying.print-invoice", true);
          markTableMateForPayment(true, true, print);
          return;
        } else if (tableLayout.pre_selected_action == "pre-no-paying" && orderListUtil.occupationsSelected.length == 1) {
          markTableMateForPayment(false, true, false);
          return;
        } else if (tableLayout.pre_selected_action == "pre-unlock" && orderListUtil.occupationsSelected.length == 1) {
          unlockTable(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, true, function (data) {
            update(data);
          });
          return;
        } else if (tableLayout.pre_selected_action == "pre-paid" && orderListUtil.occupationsSelected.length == 1) {
          tableMatePaid();
          return;
        }
        showEditTable();
        //orderListUtil.statesShown = auth.myStatus.restaurant_settings["tables-overview"].statesShown;
        orderListUtil.processOrders(orderListUtil.ordersCache);
        tableLayout.updateTableOccupations();
        if (isHomeDelivery()) {
          if (auth.showTheMap) {
            showMap(true);
          }
        }

        try {
          if ((sessionStorage.tableOccupationSelected && getTableOccupation(sessionStorage.tableOccupationSelected).tableMates).filter(m => m.active).length > 1) {
            $("#_byCustomer.nav-item span").trigger('click');
          } else {
            $("#_orders.nav-item span").trigger('click');
          }
        } catch (ex) {
          console.error(ex);
        }
        var thereAreNewOrders = false;
        try {
          thereAreNewOrders = getOrdersByTableNumber(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected).filter(o => o.state === "selected" && o.recordState === "ACTIVE").length > 0;
        } catch (ex) {
          console.log(ex);
        }
        if ((table.pos || (tableLayout.pre_selected_action == "pre-lock-order" && orderListUtil.occupationsSelected.length == 1) || thereAreNewOrders) && !(table.homeDelivery || table.pickup)) {
          selectNewOrders();
        }
      });
      /*
       * } else { select($trigger); }
       */

      resetPreSelection();
    }
  },

  selectTable(number) {
    selectTableNumberSelected(number);

    if (auth.device.platform != "browser" && (sessionStorage.tableNumberSelected == getPickupTableNumber() || sessionStorage.tableNumberSelected == getHomeDeliveryTableNumber()) && auth.myStatus.restaurant_settings["enabled-features"].ordering.menuorder)
      return;

    const table = getTable(sessionStorage.tableNumberSelected);
    orderListUtil.kioskMode = table.pos;
    updateTableMates().done(function () {
      if (tableLayout.pre_selected_action == "pre-lock") {
        if (getTable(number).shareable) lockTable(sessionStorage.tableNumberSelected, updateTableOccupationsAndSelect);
        return;
      } else if (tableLayout.pre_selected_action == "pre-paying" && orderListUtil.occupationsSelected.length == 1) {
        var print = getSetting("tables-overview.pre-paying.print-invoice", true);
        markTableMateForPayment(true, true, print);
        return;
      } else if (tableLayout.pre_selected_action == "pre-no-paying" && orderListUtil.occupationsSelected.length == 1) {
        markTableMateForPayment(false, true, false);
        return;
      } else if (tableLayout.pre_selected_action == "pre-unlock" && orderListUtil.occupationsSelected.length == 1) {
        unlockTable(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, true, function (data) {
          update(data);
        });
        return;
      } else if (tableLayout.pre_selected_action == "pre-paid" && orderListUtil.occupationsSelected.length == 1) {
        tableMatePaid();
        return;
      }
      showEditTable();
      //orderListUtil.statesShown = auth.myStatus.restaurant_settings["tables-overview"].statesShown;
      orderListUtil.processOrders(orderListUtil.ordersCache);
      tableLayout.updateTableOccupations();
    })
  },

  tableClickHandler2: function (e) {
    resetLockTimeout();
    if (tableLayout.table_edit_mode) return;
    if (e.isDefaultPrevented()) return;
    e.preventDefault();
    e.stopPropagation();
    var $trigger = $(e.currentTarget);
    if ($(e.currentTarget).hasClass("waiterCalled")) {
      tableLayout.waiterCalled($trigger.attr("tableNumber"), $trigger.attr("tableOccupation"));
      return;
    }
    var state = $trigger.attr("class").split(" ")[1];
    $trigger = $($trigger.parent().find(".eatwithme-table")[0]);
    if (!$trigger.hasClass("selectable")) {
      $trigger = $($trigger.parents(".selectable")[0]);
    }
    if (!$trigger.hasClass("eatwithme-table")) {
      $trigger = $($trigger.parents(".eatwithme-table")[0]);
    }
    tableLayout.pre_selected_action = $("button.pre-selected-action.active").attr("id");
    if (
      $trigger
        .parent()
        .parent()
        .hasClass("faded")
    )
      return;
    if ($trigger.hasClass("paymentRequest")) {
      var print = getSetting("tables-overview.pre-paying.print-invoice", true);
      selectTableNumberSelected($trigger.attr("id"));
      var found = false;
      auth.myStatus.restaurant_payment_methods.forEach(pm => {
        if (pm.id == $trigger.attr("paymentMethod")) {
          found = true;
          $trigger.parent().parent().find("image.svgadded.payment-request").remove();
          choiceDialog2(I18n.t("local.information"), "<img style='margin-right: 2rem;width:5rem' src='" + pm.method.image + "'></img>" + pm.method.name, [I18n.t("admin_local.ok")]).done(function (choice) {
            if (choice == 0) {
              selectTableOccupationSelected($trigger.attr("tableOccupations").split(",")[0]);
              if (pm.method.type != "online") markTableMateForPayment(true, true, print, pm.id);
              else markTableMateForPayment(true, true, false, pm.id);
            }
          });
        }
      });
      if (!found) markTableMateForPayment(true, true, print);
      return;
    }
    if ($trigger.hasClass("eatwithme-table")) {
      $("button.pre-selected-action.active").removeClass("active");

      tableLayout.showSimpleOrder(null, $trigger.attr("id"), [state], true);
    }
  },

  showSimpleOrder: (tableOccupation, tableNumber, state, force, all = false) => {
    if (!force && !tableLayout.showSimpleOrderTimeout)
      return;
    clearTimeout(tableLayout.showSimpleOrderTimeout);
    tableLayout.showSimpleOrderTimeout = undefined;
    selectTableNumberSelected(tableNumber);
    selectTableOccupationSelected(tableOccupation);
    $("div#main div#simpleOrderMain").remove();
    //var stateIndex = state.map(s => states.indexOf(s));

    updateTableMates().done(function () {
      if (!tableOccupation)
        sessionStorage.removeItem("tableOccupationSelected");
      var tbody = $('<tbody id="orderList"/>');
      const orderSequenceNumberss = orderListUtil.ordersCache.filter(o => o.state === "ordered").map(o => o.orderSequenceNumber);
      const statess = state;
      if (state === "ordered")
        statess.unshift("cancelled");
      var orders = _preProcessOrders(orderListUtil.ordersCache, statess, function (order) {
        /*
        if (orderListUtil.statesShown[0] == "selected" && order.state == "ordered" && order.approved) {
          return false;
        }
        if (orderListUtil.statesShown[0] != "selected" && order.state == "ordered" && !order.approved) {
          return false;
        }
        */
        return state.indexOf(order.state) >= 0 || (state === "ordered" && order.state === "cancelled" && orderSequenceNumberss.indexOf(order.orderSequenceNumber) !== -1);
      });
      var orderIds = "";
      var orderSequenceNumbers = "";

      orders.tables.forEach((order, ind) => {
        if (!all && ind > 0) return;
        if (!order.tableOccupation)
          console.error("This is not good", "Really");
        if (!tableOccupation)
          selectTableOccupationSelected(order.tableOccupation);
        //orders.tables.forEach(function (order) {
        //if (orderListUtil.show(order)) {
        const nextS = nextState[state[state.length - 1]];
        $("script#simpleOrdersTemplateAllStates")
          .tmpl({ state: state[0], nextState: nextS, order: order, ...tmplparams(), statesShown: statess, hidePaid: true })
          .appendTo(tbody);
        if (orderIds != "") orderIds += ",";
        orderIds += order.orderIds;
        if (orderSequenceNumbers != "") orderSequenceNumbers += "_";
        orderSequenceNumbers += order.orderSequenceNumber;
        //}
        //});
      });
      $("script#simpleOrderMainTemplate")
        .tmpl({ state: state[0], table: getTableName(tableNumber), orderSequenceNumbers: orderSequenceNumbers, nextState: nextState[state[state.length - 1]], orderIds: orderIds, ...tmplparams(), statesShown: statess, hidePaid: true })
        .appendTo("div#main");
      var orderList = $("div#simpleOrderMain tbody#orderList");
      orderList.replaceWith(tbody);
      $("#simpleOrderMain td.ui-droppable.state").on("click", event => {
        const td = $(event.target);
        const tableOccupationId = td.parent().attr("tableOccupation");
        const orderIds = td.parent().attr("orderid");
        const s = td.attr("state");
        admin.changeStateForOrders(tableOccupationId, orderIds, s, null, (data) => {
          update(data);
          tableLayout.showSimpleOrder(tableOccupationId, tableNumber, [state], true);
        });
      })
      $("div#simpleOrderMain").show();
      $("div#simpleOrderMain").removeClass("hidden");
    });
  },

  quickOrderStateChange: function (state, tableNumber) {
    var stateIndex = states.indexOf(state);
    selectTableNumberSelected(tableNumber);
    $("div#main div#simpleOrderMain").remove();
    updateTableMates().done(function () {
      var tbody = $('<tbody id="orderList"/>');
      var orders = _preProcessOrders(orderListUtil.ordersCache, [states[stateIndex]], function (order) {
        return order.tableNumber == sessionStorage.tableNumberSelected && order.tableNumber == sessionStorage.tableNumberSelected;
      });
      var orderIds = "";
      var orderSequenceNumbers = "";
      orders.tables.forEach(function (order) {
        if (orderListUtil.show(order)) {
          $("script#simpleOrdersTemplateAllStates")
            .tmpl({ statesShown: [state], state: state, nextState: states[stateIndex + 1], order: order, hidePaid: true })
            .appendTo(tbody);
          if (orderIds != "") orderIds += ",";
          orderIds += order.orderIds;
          if (orderSequenceNumbers != "") orderSequenceNumbers += "_";
          orderSequenceNumbers += order.orderSequenceNumber;
        }
      });
      $("script#simpleOrderMainTemplate")
        .tmpl({ statesShown: [state], table: getTableName(tableNumber), state: state, orderSequenceNumbers: orderSequenceNumbers, nextState: nextState[state], hidePaid: true, orderIds: orderIds })
        .appendTo("div#main");
      var orderList = $("div#simpleOrderMain tbody#orderList");
      orderList.replaceWith(tbody);
      $("div#simpleOrderMain").show();
      //_floatTableHead("#simpleOrderMain .simpleOrderListFreezeTable");
    });
  },

  initTableDraggable: function () {
    $("svg[visible='true'] g.eatwithme-table")
      .parent()
      .parent()
      .draggable({
        start: this.svgDragStart,
        drag: this.svgDrag,
        stop: this.svgDragEnd
      });
    $("svg[visible='true'] g.eatwithme-seat").draggable({
      start: this.svgDragStart,
      drag: this.svgDrag,
      stop: this.svgDragEnd
    });
    $("svg[visible='true'] tspan.eatwithme-tableNumber")
      .parent()
      .draggable({
        start: this.svgDragStart,
        drag: this.svgDrag,
        stop: this.svgDragEnd
      });
    $("svg[visible='true'] g.eatwithme-room")
      .parent()
      .draggable({
        start: this.svgDragStart,
        drag: this.svgDrag,
        stop: this.svgDragEnd
      });
    $("svg[visible='true'] .eatwithme-room").removeClass("selectable");
    $("svg[visible='true'] .eatwithme-room").attr("level", null);
    $("svg[visible='true'] .eatwithme-roomName").addClass("selectable");
    $("svg[visible='true'] .eatwithme-roomName").attr("level", 3);
    if (tableLayout.table_edit_mode) {
      tableLayout.applyEditModeTableHandles(true);
    }
  },

  destroyTableDraggable: function () {
    $("g.eatwithme-table")
      .parent()
      .parent()
      .draggable("destroy");
    $("g.eatwithme-seat").draggable("destroy");
    $("tspan.eatwithme-tableNumber")
      .parent()
      .draggable("destroy");
  },

  resolveTableActionTrigger: function ($trigger) {
    if (!$trigger || $trigger.length === 0) return $();
    if ($trigger.hasClass("eatwithme-tableNumber")) {
      var byId = $("#" + $trigger.attr("id") + ".eatwithme-table");
      if (byId.length > 0) return $(byId.get(0));
      return $($trigger.closest("g.eatwithme-table").get(0));
    }
    if ($trigger.hasClass("eatwithme-table")) return $($trigger.get(0));
    return $($trigger.closest("g.eatwithme-table").get(0));
  },

  getTableContextActions: function ($trigger) {
    $trigger = tableLayout.resolveTableActionTrigger($trigger);
    if (!$trigger || $trigger.length === 0) return null;

    var table = tableLayout.tableMap.get(Number($trigger.attr("id")));
    var items = {};

    items["title"] = { name: String.format(I18n.t("admin_local.table_number"), $trigger.attr("id")) };
    items["sep"] = "---------";

    if (table && table.isActive == true) {
      if (!$trigger.hasClass("occupied")) {
        items["deactivate"] = {
          name: I18n.t("admin_local.deactivate"),
          icon: "edit"
        };
      } else {
      }
    } else {
      items["activate"] = {
        name: I18n.t("admin_local.activate"),
        icon: "edit"
      };
    }
    if (table && table.shareable == true)
      items["makeNonShareable"] = {
        name: I18n.t("admin_local.make_unshareable"),
        icon: "edit"
      };
    else
      items["makeShareable"] = {
        name: I18n.t("admin_local.make_shareable"),
        icon: "edit"
      };
    if (table && table.pos == true)
      items["makeNonPOS"] = {
        name: I18n.t("admin_local.make_non_pos"),
        icon: "edit"
      };
    else
      items["makePOS"] = {
        name: I18n.t("admin_local.make_pos"),
        icon: "edit"
      };
    if (table && table.kiosk == true)
      items["makeNonKiosk"] = {
        name: I18n.t("admin_local.make_non_kiosk"),
        icon: "edit"
      };
    else
      items["makeKiosk"] = {
        name: I18n.t("admin_local.make_kiosk"),
        icon: "edit"
      };

    if (table && table.visibleOnline == true)
      items["makeNonVisibleOnline"] = {
        name: I18n.t("admin_local.make_nonVisibleOnline"),
        icon: "edit"
      };
    else
      items["makeVisibleOnline"] = {
        name: I18n.t("admin_local.make_visibleOnline"),
        icon: "edit"
      };

    if (table && table.bookOnline == true)
      items["makeNonBookOnline"] = {
        name: I18n.t("admin_local.make_nonBookOnline"),
        icon: "edit"
      };
    else
      items["makeBookOnline"] = {
        name: I18n.t("admin_local.make_bookOnline"),
        icon: "edit"
      };

    if (tableLayout.table_edit_mode) {
      items["editTable"] = {
        name: I18n.t("admin_local.change_table_number"),
        icon: "edit"
      };
      items["makeBigger"] = {
        name: "Bigger",
        icon: "edit"
      };
      items["makeSmaller"] = {
        name: "Smaller",
        icon: "edit"
      };
      items["rotateLeft"] = {
        name: I18n.t("admin_local.rotate_left"),
        icon: "edit"
      };
      items["rotateRight"] = {
        name: I18n.t("admin_local.rotate_right"),
        icon: "edit"
      };
      items["duplicate"] = {
        name: I18n.t("admin_local.duplicate"),
        icon: "add"
      };
      items["new_seat"] = {
        name: I18n.t("admin_local.seat"),
        items: tableLayout.seatTemplates,
        icon: "add"
      };
      items["deleteTable"] = {
        name: I18n.t("admin_local.delete"),
        icon: "delete"
      };
    } else {
      items["sep2"] = "---------";
      items["editMode"] = {
        name: I18n.t("admin_local.enable_edit_mode"),
        icon: "edit"
      };
    }

    return {
      callback: function (key, options) {
        var shouldRestoreEditMode = !!tableLayout.table_edit_mode;
        var actionTargetTableId = String($trigger.attr("id") || "");
        var recomposeTableActionButtons = function () {
          if (!shouldRestoreEditMode || actionTargetTableId.length === 0) return;

          var attempts = 0;
          var maxAttempts = 10;
          var tryShow = function () {
            attempts += 1;
            if (!tableLayout.table_edit_mode) {
              if (attempts < maxAttempts) {
                setTimeout(tryShow, 80);
              }
              return;
            }

            var $updatedTable = $("svg[visible='true'] g.eatwithme-table#" + actionTargetTableId).first();
            if ($updatedTable.length > 0) {
              $updatedTable.addClass("ui-selected");
              select($updatedTable.get(0));
              tableLayout.showTableActionButtons($updatedTable);
              return;
            }

            if (attempts < maxAttempts) {
              setTimeout(tryShow, 80);
            }
          };

          setTimeout(tryShow, 0);
        };

        var reloadTablesAndRestoreEditMode = function () {
          tableLayout.reloadTables(true, function () {
            if (shouldRestoreEditMode && !tableLayout.table_edit_mode) {
              tableLayout.editMode(true);
            }
          });
        };

        var getRotateCenterInContainer = function ($container) {
          if (!$container || $container.length === 0) return null;

          var $tableNode = $container.find("g.eatwithme-table").first();
          if ($tableNode.length === 0) return null;

          var tableNode = $tableNode.get(0);
          var containerNode = $container.get(0);
          if (!tableNode || !containerNode || !tableNode.getScreenCTM || !containerNode.getScreenCTM) return null;

          var shape = $tableNode.find("rect, ellipse, path").first().get(0);
          if (!shape) return null;

          var shapeBounds = tableLayout.getShapeBoundsInTableCoords($tableNode, shape);
          if (!shapeBounds) return null;

          var tableCTM = tableNode.getScreenCTM();
          var containerCTM = containerNode.getScreenCTM();
          if (!tableCTM || !containerCTM || !containerCTM.inverse) return null;

          var svgRoot = tableNode.ownerSVGElement;
          if (!svgRoot || !svgRoot.createSVGPoint) return null;

          var point = svgRoot.createSVGPoint();
          point.x = Number(shapeBounds.x || 0) + Number(shapeBounds.width || 0) / 2;
          point.y = Number(shapeBounds.y || 0) + Number(shapeBounds.height || 0) / 2;

          var centerInScreen = point.matrixTransform(tableCTM);
          var centerInContainer = centerInScreen.matrixTransform(containerCTM.inverse());
          return { x: centerInContainer.x, y: centerInContainer.y };
        };

        var setContainerRotationAround = function ($container, nextDeg, cx, cy) {
          var rotatePattern = /rotate\(\s*(-?[\d\.]+)(?:[\s,]+-?[\d\.]+[\s,]+-?[\d\.]+)?\s*\)/g;
          var containerTransform = ($container.attr("transform") || "").replace(rotatePattern, "").replace(/\s+/g, " ").trim();
          var rotatePart = "rotate(" + nextDeg + "," + cx + "," + cy + ")";
          $container.attr("transform", (containerTransform ? containerTransform + " " : "") + rotatePart);
        };

        switch (key) {
          case "makeBigger":
            var $selectedTableNumberText = tableLayout.getSelectedTableNumberTextTarget();
            tableLayout.scaleSvgTarget($selectedTableNumberText.length ? $selectedTableNumberText : $trigger, 1.1);
            break;
          case "makeSmaller":
            var $selectedTableNumberText = tableLayout.getSelectedTableNumberTextTarget();
            tableLayout.scaleSvgTarget($selectedTableNumberText.length ? $selectedTableNumberText : $trigger, 0.9);
            break;
          case "deactivate":
            admin.modifyTable(
              {
                ...table,
                active: false
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "activate":
            admin.modifyTable(
              {
                ...table,
                active: true
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "makeShareable":
            admin.modifyTable(
              {
                ...table,
                shareable: true
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "makeNonShareable":
            admin.modifyTable(
              {
                ...table,
                shareable: false
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "makePOS":
            admin.modifyTable(
              {
                ...table,
                pos: true
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "makeNonPOS":
            admin.modifyTable(
              {
                ...table,
                pos: false
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "makeKiosk":
            admin.modifyTable(
              {
                ...table,
                kiosk: true
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode,
              true
            );
            break;
          case "makeNonKiosk":
            admin.modifyTable(
              {
                ...table,
                kiosk: false
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode,
              false
            );
            break;
          case "makeNonVisibleOnline":
            admin.modifyTable(
              {
                ...table,
                visibleOnline: false
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "makeVisibleOnline":
            admin.modifyTable(
              {
                ...table,
                visibleOnline: true
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "makeNonBookOnline":
            admin.modifyTable(
              {
                ...table,
                bookOnline: false
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "makeBookOnline":
            admin.modifyTable(
              {
                ...table,
                bookOnline: true
              },
              table.forStore, table.extentions,
              reloadTablesAndRestoreEditMode
            );
            break;
          case "editMode":
            tableLayout.editMode(true);
            break;
          case "quitEditMode":
            tableLayout.editMode(false);
            break;
          case "saveLayout":
            tableLayout.saveLayout();
            break;
          case "editTable":
            tableLayout.hideTableActionButtons();
            $(".context-menu-active").removeClass("context-menu-active");
            $("div#editTableData.modal").modal("show");
            if (table == undefined) {
              table = {};
            }
            tableLayout.editTable(table, $trigger, function (tableData) {

              var exist = false;
              var tableId = undefined;
              tableLayout.tables.forEach(function (t) {
                if (Number(t.number) == Number(tableData.tableNumber)) {
                  exist = true;
                  tableId = t.id;
                }
              });

              function postAction() {

                const $gg = $($trigger.parents(".ui-draggable#" + tableData.tableNumber + "-number").get(0));
                var $g = $gg.find(">g");
                const layout = $gg.attr("layout");
                if ($gg.length && tableData.layout && tableData.layout != layout) {
                  $gg.attr("layout", tableData.layout);
                  var transform = $gg.attr("transform");
                  var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(transform);

                  const r = $(tableLayout.makeSVG2($(tableLayout.tableTemplates[tableData.layout].svg)));
                  const position1 = $gg.get(0).getBBox();
                  $g.replaceWith(r);
                  $trigger = $gg.find("g.eatwithme-table");

                  const position2 = $gg.get(0).getBBox();
                  transform = transform.replace(/translate\((-?[\d\.]+),(-?[\d\.]+)\)/, "translate(" + (parseFloat(matches[1]) - (position2.x + position2.width / 2 - position1.x - position1.width / 2)) + "," + (parseFloat(matches[2]) - (position2.y + position2.height / 2 - position1.y - position1.height / 2)) + ")");

                  $gg.attr("transform", transform);

                }
                admin.getTables(function (tableLayouts) {
                  auth.myStatus.restaurant_tables = tableLayout.tables = tableLayouts.restaurantTables;
                  tableLayouts.restaurantTables.forEach(function (table) {
                    tableLayout.tableMap.set(Number(table.number), table);
                  });
                  getMyStatus(() => {
                    $("#editTableData").replaceWith($("script#editTableTemplate").tmpl(tmplparams()));
                    initEditTable();
                    recomposeTableActionButtons();
                  });

                });
                $trigger.find("tspan.eatwithme-tableNumber").html(tableData.name != "" ? tableData.name : tableData.tableNumber);
                $trigger.find("tspan.eatwithme-tableNumber").attr("id", tableData.tableNumber + "-number");
                $trigger
                  .parent()
                  .parent()
                  .find(".eatwithme-seat")
                  .each(function (ind, t) {
                    $(t).attr("id", tableData.tableNumber + "-" + (ind + 1));
                  });
                $trigger.attr("id", tableData.tableNumber);
                $trigger.find(".eatwithme-table").attr("id", tableData.tableNumber + "-number");

                $trigger.find(".eatwithme-seat")
                  .each(function (ind, t) {
                    $(t).attr("id", tableData.tableNumber + "-" + (ind + 1));
                    $(t).addClass("selectable");
                    $(t).click(auth.clickHandler);
                  });

                $trigger.parents(".ui-draggable").attr("id", tableData.tableNumber + "-number");

                tableLayout.realignTableVisuals($trigger.parents(".ui-draggable").first());

                select($trigger);
                tableLayout.initTableContextMenu();
                tableLayout.initTableDraggable();
                auth.updateHooks();
              }

              if (!exist) {
                admin.addTable(
                  tableData.room,
                  tableData.tableNumber,
                  tableData.name,
                  tableData.seats,
                  tableData.shareable,
                  tableData.visibleOnline,
                  tableData.bookOnline,
                  tableData.active,
                  tableData.type,
                  tableData.pos,
                  tableData.forStore,
                  tableData.extensions,
                  postAction
                );
              } else {
                admin.modifyTable(
                  {
                    ...tableData,
                    id: tableId
                  },
                  tableData.forStore,
                  tableData.extensions,
                  postAction
                );
              }
            });
            break;
          case "deleteTable":
            var tableIdToDelete = String($trigger.attr("id") || "");
            var $deleteTableContainer = $trigger.closest("g.ui-draggable").filter(function () {
              return $(this).find("g.eatwithme-table").length > 0;
            }).first();
            if (!$deleteTableContainer || $deleteTableContainer.length === 0) {
              $deleteTableContainer = $trigger.parent().parent();
            }
            if (!tableLayout.canKeepLandscapeAfterRemoving($deleteTableContainer)) {
              tableLayout.showLandscapeConstraintMessage();
              break;
            }

            if (tableIdToDelete.length > 0) {
              $("svg[visible='true'] g.eatwithme-seat").filter(function () {
                var seatId = String($(this).attr("id") || "");
                return seatId.indexOf(tableIdToDelete + "-") === 0;
              }).remove();
            }

            $deleteTableContainer.remove();
            break;
          case "rotateRight":
            var $rotateContainer = $trigger.parent();
            var rotatePattern = /rotate\(\s*(-?[\d\.]+)(?:[\s,]+-?[\d\.]+[\s,]+-?[\d\.]+)?\s*\)/;
            var center = getRotateCenterInContainer($rotateContainer);
            var cx = center && Number.isFinite(center.x) ? center.x : 0;
            var cy = center && Number.isFinite(center.y) ? center.y : 0;
            if (!center) {
              var box = null;
              try {
                box = $rotateContainer.get(0) && $rotateContainer.get(0).getBBox ? $rotateContainer.get(0).getBBox() : null;
              } catch (ex) {
                box = null;
              }
              cx = box && Number.isFinite(box.x) && Number.isFinite(box.width) ? (box.x + box.width / 2) : 0;
              cy = box && Number.isFinite(box.y) && Number.isFinite(box.height) ? (box.y + box.height / 2) : 0;
            }

            var currentContainerTransform = $rotateContainer.attr("transform") || "";
            var currentContainerMatch = rotatePattern.exec(currentContainerTransform);
            var currentDeg = currentContainerMatch != null ? parseFloat(currentContainerMatch[1]) : 0;
            setContainerRotationAround($rotateContainer, currentDeg + 45, cx, cy);

            var tableNumberText = $rotateContainer.find("tspan.eatwithme-tableNumber").parent();
            var textTransform = tableNumberText.attr("transform") || "";
            var textMatch = rotatePattern.exec(textTransform);
            if (textMatch != null) {
              var textDeg = parseFloat(textMatch[1]) - 45;
              textTransform = textTransform.replace(rotatePattern, "rotate(" + textDeg + ")");
            } else {
              textTransform = ("rotate(-45) " + textTransform).trim();
            }
            tableNumberText.attr("transform", textTransform);

            var $tableNodeRight = $rotateContainer.find("g.eatwithme-table").first();
            tableLayout.centerTableNumberAfterResize($rotateContainer);
            if ($tableNodeRight.length > 0) {
              var rightNode = $tableNodeRight.get(0);
              tableLayout.clickSelectHandler({
                currentTarget: rightNode,
                target: rightNode,
                stopPropagation: function () {
                }
              });
              setTimeout(function () {
                tableLayout.showTableActionButtons($tableNodeRight);
              }, 0);
            }

            break;
          case "rotateLeft":
            var $rotateContainer = $trigger.parent();
            var rotatePattern = /rotate\(\s*(-?[\d\.]+)(?:[\s,]+-?[\d\.]+[\s,]+-?[\d\.]+)?\s*\)/;
            var center = getRotateCenterInContainer($rotateContainer);
            var cx = center && Number.isFinite(center.x) ? center.x : 0;
            var cy = center && Number.isFinite(center.y) ? center.y : 0;
            if (!center) {
              var box = null;
              try {
                box = $rotateContainer.get(0) && $rotateContainer.get(0).getBBox ? $rotateContainer.get(0).getBBox() : null;
              } catch (ex) {
                box = null;
              }
              cx = box && Number.isFinite(box.x) && Number.isFinite(box.width) ? (box.x + box.width / 2) : 0;
              cy = box && Number.isFinite(box.y) && Number.isFinite(box.height) ? (box.y + box.height / 2) : 0;
            }

            var currentContainerTransform = $rotateContainer.attr("transform") || "";
            var currentContainerMatch = rotatePattern.exec(currentContainerTransform);
            var currentDeg = currentContainerMatch != null ? parseFloat(currentContainerMatch[1]) : 0;
            setContainerRotationAround($rotateContainer, currentDeg - 45, cx, cy);

            var tableNumberText = $rotateContainer.find("tspan.eatwithme-tableNumber").parent();
            var textTransform = tableNumberText.attr("transform") || "";
            var textMatch = rotatePattern.exec(textTransform);
            if (textMatch != null) {
              var textDeg = parseFloat(textMatch[1]) + 45;
              textTransform = textTransform.replace(rotatePattern, "rotate(" + textDeg + ")");
            } else {
              textTransform = ("rotate(45) " + textTransform).trim();
            }
            tableNumberText.attr("transform", textTransform);

            var $tableNodeLeft = $rotateContainer.find("g.eatwithme-table").first();
            tableLayout.centerTableNumberAfterResize($rotateContainer);
            if ($tableNodeLeft.length > 0) {
              var leftNode = $tableNodeLeft.get(0);
              tableLayout.clickSelectHandler({
                currentTarget: leftNode,
                target: leftNode,
                stopPropagation: function () {
                }
              });
              setTimeout(function () {
                tableLayout.showTableActionButtons($tableNodeLeft);
              }, 0);
            }

            break;
          case "duplicate":
            var $new = $trigger
              .parent()
              .parent()
              .clone();
            $new.appendTo(
              $trigger
                .parent()
                .parent()
                .parent()
            );

            var tableId = "0";

            $new.find("tspan.eatwithme-tableNumber").html(tableId);
            $new.attr("id", tableId + "-number");
            let $eatwithmeTable = $new.find(".eatwithme-table");
            $eatwithmeTable.attr("id", tableId);
            $eatwithmeTable.addClass("selectable");
            $eatwithmeTable.click(auth.clickHandler);
            $new.find(".context-menu-active").removeClass("context-menu-active");
            $new.find(".eatwithme-seat").each(function (ind, t) {
              $(t).attr("id", tableId + "-" + (ind + 1));
              $(t).addClass("selectable");
              $(t).click(auth.clickHandler);
            });

            var currentTranslate = tableLayout.getEditTargetTranslate($new);
            var tableWidth = 0;
            try {
              var tableNode = $new.find("g.eatwithme-table").first().get(0);
              var bbox = tableNode && tableNode.getBBox ? tableNode.getBBox() : null;
              tableWidth = bbox && Number.isFinite(bbox.width) ? Number(bbox.width) : 0;
            } catch (ex) {
              tableWidth = 0;
            }
            var shiftRight = tableWidth > 0 ? tableWidth + 24 : 64;
            tableLayout.setEditTargetTranslate($new, currentTranslate.x + shiftRight, currentTranslate.y);

            tableLayout.initTableContextMenu();
            tableLayout.initTableDraggable();

            select($eatwithmeTable.get(0));
            tableLayout.showTableActionButtons($eatwithmeTable);

            setTimeout(function () {
              var editActions = tableLayout.getTableContextActions($eatwithmeTable);
              if (editActions && editActions.callback) {
                editActions.callback("editTable");
              }
            }, 0);
            break;
          default:
            var template = tableLayout.seatTemplates[key];
            var svg = $(tableLayout.makeSVG2($(template.svg)));
            svg.attr("id", table.number + "-" + ($trigger.parent().find(".eatwithme-seat").length + 1));
            svg.addClass("selectable");
            var seats_g = $(
              $trigger
                .parent()
                .find("g > g")
                .get(0)
            );
            $(seats_g).append(svg);
            select(svg);
            svg.click(auth.clickHandler);
            tableLayout.initTableContextMenu();
            tableLayout.initTableDraggable();
            auth.updateHooks();
            break;
        }
      },
      items: items
    };
  },

  getEditTargetTranslate: function ($target) {
    if (!$target || $target.length === 0) return { x: 0, y: 0, hasTranslate: false };
    var transform = $target.attr("transform") || "";
    var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(transform);
    if (!matches) {
      return { x: 0, y: 0, hasTranslate: false };
    }
    return {
      x: parseFloat(matches[1]) || 0,
      y: parseFloat(matches[2]) || 0,
      hasTranslate: true
    };
  },

  setEditTargetTranslate: function ($target, x, y) {
    if (!$target || $target.length === 0) return;
    var transform = $target.attr("transform") || "";
    var nextTranslate = "translate(" + x + "," + y + ")";
    if (/translate\((-?[\d\.]+),(-?[\d\.]+)\)/.test(transform)) {
      $target.attr("transform", transform.replace(/translate\((-?[\d\.]+),(-?[\d\.]+)\)/, nextTranslate));
      return;
    }
    if (transform.length > 0) {
      $target.attr("transform", nextTranslate + " " + transform);
      return;
    }
    $target.attr("transform", nextTranslate);
  },

  keepLayoutLandscapeWithTable: function ($tableContainer, options) {
    if (!$tableContainer || $tableContainer.length === 0) return true;
    var opts = options || {};

    var $container = $tableContainer;
    if (!$container.hasClass("ui-draggable") || $container.find("g.eatwithme-table").length === 0) {
      $container = $tableContainer.closest("g.ui-draggable").filter(function () {
        return $(this).find("g.eatwithme-table").length > 0;
      }).first();
    }
    if (!$container || $container.length === 0) return true;

    var $svg = $("svg[visible='true']").first();
    if (!$svg || $svg.length === 0) return true;

    var root = $svg.find("> g#svg-g").get(0) || $svg.find("> g").get(0);
    if (!root || !root.getBBox) return true;

    var bbox = null;
    try {
      bbox = root.getBBox();
    } catch (ex) {
      bbox = null;
    }
    if (!bbox || !Number.isFinite(bbox.width) || !Number.isFinite(bbox.height)) return true;
    if (bbox.width >= bbox.height) return true;

    if (opts.fallbackTransform != null) {
      $container.attr("transform", opts.fallbackTransform);
    }
    return false;
  },

  showLandscapeConstraintMessage: function () {
    messageDialog(I18n.t("local.information"), I18n.t("admin_local.layout_must_remain_wider_than_tall"));
  },

  canKeepLandscapeAfterAdding: function ($targetContainer) {
    if (!$targetContainer || $targetContainer.length === 0) return true;

    var $container = $targetContainer;
    var $svg = $("svg[visible='true']").first();
    if (!$svg || $svg.length === 0) return true;

    var root = $svg.find("> g#svg-g").get(0) || $svg.find("> g").get(0);
    if (!root || !root.getBBox) return true;

    $(root).append($container);

    var keep = true;
    try {
      var bbox = root.getBBox();
      if (bbox && Number.isFinite(bbox.width) && Number.isFinite(bbox.height)) {
        keep = bbox.width >= bbox.height;
      }
    } catch (ex) {
      keep = true;
    }

    $container.detach();
    return keep;
  },

  canKeepLandscapeAfterRemoving: function ($targetContainer) {
    if (!$targetContainer || $targetContainer.length === 0) return true;

    var $container = $targetContainer;
    if (!$container.hasClass("ui-draggable")) {
      $container = $targetContainer.closest("g.ui-draggable").first();
    }
    if (!$container || $container.length === 0) return true;

    var $svg = $("svg[visible='true']").first();
    if (!$svg || $svg.length === 0) return true;

    var root = $svg.find("> g#svg-g").get(0) || $svg.find("> g").get(0);
    if (!root || !root.getBBox) return true;

    var parent = $container.parent();
    var next = $container.next();
    $container.detach();

    var keep = true;
    try {
      var bbox = root.getBBox();
      if (bbox && Number.isFinite(bbox.width) && Number.isFinite(bbox.height)) {
        keep = bbox.width >= bbox.height;
      }
    } catch (ex) {
      keep = true;
    }

    if (next && next.length > 0) {
      $container.insertBefore(next);
    } else {
      parent.append($container);
    }

    return keep;
  },

  getSelectedTablesForGroupActions: function ($trigger) {
    var $selected = $("svg[visible='true'] g.eatwithme-table.ui-selected");
    var $resolved = tableLayout.resolveTableActionTrigger($trigger);
    if ($resolved && $resolved.length > 0) {
      $selected = $selected.add($resolved);
    }
    return $selected;
  },

  getSelectedRoomsForGroupActions: function ($trigger) {
    var $selected = $("svg[visible='true'] g.eatwithme-room.ui-selected");
    var $resolved = tableLayout.resolveRoomActionTrigger($trigger);
    if ($resolved && $resolved.length > 0) {
      $selected = $selected.add($resolved);
    }
    return $selected;
  },

  syncMultiSelectedTableVisuals: function () {
    var $allTables = $("svg[visible='true'] g.eatwithme-table.selectable");
    if (!$allTables || $allTables.length === 0) return;

    var $multiSelected = $("svg[visible='true'] g.eatwithme-table.ui-selected");
    $allTables.not($multiSelected).removeClass("selected");
    if ($multiSelected.length > 0) {
      $multiSelected.addClass("selected");
    }
  },

  bringRoomToFront: function ($roomTarget) {
    tableLayout.changeRoomZOrder($roomTarget, "top");
  },

  changeRoomZOrder: function ($roomTarget, direction) {
    if (!$roomTarget || $roomTarget.length === 0) return;

    var $room = $roomTarget.hasClass("eatwithme-room") ? $roomTarget : $roomTarget.closest("g.eatwithme-room").first();
    if (!$room || $room.length === 0) return;

    var $container = $room.closest("g.ui-draggable").filter(function () {
      return $(this).find("g.eatwithme-room").length > 0;
    }).first();
    if (!$container || $container.length === 0) {
      $container = $room.parent();
    }
    if (!$container || $container.length === 0) return;

    var $parent = $container.parent();
    if (!$parent || $parent.length === 0) return;

    var $roomContainers = $parent.children("g").filter(function () {
      return $(this).find("g.eatwithme-room").length > 0;
    });
    if ($roomContainers.length < 2) return;

    if (direction === "top") {
      if ($roomContainers.last().get(0) !== $container.get(0)) {
        $container.insertAfter($roomContainers.last());
      }
      return;
    }

    if (direction === "back") {
      if ($roomContainers.first().get(0) !== $container.get(0)) {
        $container.insertBefore($roomContainers.first());
      }
      return;
    }

    if (direction === "forward") {
      var $nextContainer = $container.nextAll("g").filter(function () {
        return $(this).find("g.eatwithme-room").length > 0;
      }).first();
      if ($nextContainer.length > 0) {
        $container.insertAfter($nextContainer);
      }
      return;
    }

    if (direction === "backward") {
      var $prevContainer = $container.prevAll("g").filter(function () {
        return $(this).find("g.eatwithme-room").length > 0;
      }).first();
      if ($prevContainer.length > 0) {
        $container.insertBefore($prevContainer);
      }
    }
  },

  applyTableGroupAlignment: function ($tables, axis) {
    if (!$tables || $tables.length < 2) return;

    var entries = [];
    $tables.each(function (_, tableNode) {
      var $table = $(tableNode);
      var $container = $table.closest("g.ui-draggable");
      if ($container.length === 0) {
        $container = $table.parent().parent();
      }
      if (!$container || $container.length === 0) return;
      var translate = tableLayout.getEditTargetTranslate($container);
      entries.push({
        table: $table,
        container: $container,
        x: translate.x,
        y: translate.y
      });
    });

    if (entries.length < 2) return;

    if (axis === "x") {
      var targetX = entries.reduce(function (sum, e) { return sum + e.x; }, 0) / entries.length;
      entries.forEach(function (entry) {
        tableLayout.setEditTargetTranslate(entry.container, targetX, entry.y);
      });
    } else {
      var targetY = entries.reduce(function (sum, e) { return sum + e.y; }, 0) / entries.length;
      entries.forEach(function (entry) {
        tableLayout.setEditTargetTranslate(entry.container, entry.x, targetY);
      });
    }

    entries.forEach(function (entry) {
      tableLayout.refreshEditModeResizeCorners(entry.container);
    });
  },

  applyTableGroupSpread: function ($tables) {
    if (!$tables || $tables.length < 3) return;

    var entries = [];
    $tables.each(function (_, tableNode) {
      var $table = $(tableNode);
      var $container = $table.closest("g.ui-draggable");
      if ($container.length === 0) {
        $container = $table.parent().parent();
      }
      if (!$container || $container.length === 0) return;
      var translate = tableLayout.getEditTargetTranslate($container);
      entries.push({
        table: $table,
        container: $container,
        x: translate.x,
        y: translate.y
      });
    });

    if (entries.length < 3) return;

    var rangeX = Math.max.apply(null, entries.map(function (e) { return e.x; })) - Math.min.apply(null, entries.map(function (e) { return e.x; }));
    var rangeY = Math.max.apply(null, entries.map(function (e) { return e.y; })) - Math.min.apply(null, entries.map(function (e) { return e.y; }));
    var axis = rangeX >= rangeY ? "x" : "y";

    entries.sort(function (a, b) {
      return axis === "x" ? a.x - b.x : a.y - b.y;
    });

    var minValue = axis === "x" ? entries[0].x : entries[0].y;
    var maxValue = axis === "x" ? entries[entries.length - 1].x : entries[entries.length - 1].y;
    var step = (maxValue - minValue) / (entries.length - 1);

    entries.forEach(function (entry, index) {
      var value = minValue + step * index;
      if (axis === "x") {
        tableLayout.setEditTargetTranslate(entry.container, value, entry.y);
      } else {
        tableLayout.setEditTargetTranslate(entry.container, entry.x, value);
      }
      tableLayout.refreshEditModeResizeCorners(entry.container);
    });
  },

  applyRoomGroupAlignment: function ($rooms, axis) {
    if (!$rooms || $rooms.length < 2) return;

    var entries = [];
    $rooms.each(function (_, roomNode) {
      var $room = $(roomNode);
      var $container = $room.closest("g.ui-draggable");
      if ($container.length === 0) {
        $container = $room.parent().parent();
      }
      if (!$container || $container.length === 0) return;
      var translate = tableLayout.getEditTargetTranslate($container);
      entries.push({
        room: $room,
        container: $container,
        x: translate.x,
        y: translate.y
      });
    });

    if (entries.length < 2) return;

    if (axis === "x") {
      var targetX = entries.reduce(function (sum, e) { return sum + e.x; }, 0) / entries.length;
      entries.forEach(function (entry) {
        tableLayout.setEditTargetTranslate(entry.container, targetX, entry.y);
      });
    } else {
      var targetY = entries.reduce(function (sum, e) { return sum + e.y; }, 0) / entries.length;
      entries.forEach(function (entry) {
        tableLayout.setEditTargetTranslate(entry.container, entry.x, targetY);
      });
    }

    entries.forEach(function (entry) {
      tableLayout.refreshEditModeResizeCorners(entry.container);
    });
  },

  applyRoomGroupSpread: function ($rooms) {
    if (!$rooms || $rooms.length < 3) return;

    var entries = [];
    $rooms.each(function (_, roomNode) {
      var $room = $(roomNode);
      var $container = $room.closest("g.ui-draggable");
      if ($container.length === 0) {
        $container = $room.parent().parent();
      }
      if (!$container || $container.length === 0) return;
      var translate = tableLayout.getEditTargetTranslate($container);
      entries.push({
        room: $room,
        container: $container,
        x: translate.x,
        y: translate.y
      });
    });

    if (entries.length < 3) return;

    var rangeX = Math.max.apply(null, entries.map(function (e) { return e.x; })) - Math.min.apply(null, entries.map(function (e) { return e.x; }));
    var rangeY = Math.max.apply(null, entries.map(function (e) { return e.y; })) - Math.min.apply(null, entries.map(function (e) { return e.y; }));
    var axis = rangeX >= rangeY ? "x" : "y";

    entries.sort(function (a, b) {
      return axis === "x" ? a.x - b.x : a.y - b.y;
    });

    var minValue = axis === "x" ? entries[0].x : entries[0].y;
    var maxValue = axis === "x" ? entries[entries.length - 1].x : entries[entries.length - 1].y;
    var step = (maxValue - minValue) / (entries.length - 1);

    entries.forEach(function (entry, index) {
      var value = minValue + step * index;
      if (axis === "x") {
        tableLayout.setEditTargetTranslate(entry.container, value, entry.y);
      } else {
        tableLayout.setEditTargetTranslate(entry.container, entry.x, value);
      }
      tableLayout.refreshEditModeResizeCorners(entry.container);
    });
  },

  getMultiTableContextActions: function ($trigger) {
    if (!tableLayout.table_edit_mode) return null;
    var $tables = tableLayout.getSelectedTablesForGroupActions($trigger);
    if (!$tables || $tables.length < 2) return null;

    return {
      callback: function (key) {
        var $activeTables = tableLayout.getSelectedTablesForGroupActions($trigger);
        if (!$activeTables || $activeTables.length < 2) return;
        if (key === "alignVertical") {
          tableLayout.applyTableGroupAlignment($activeTables, "x");
        } else if (key === "alignHorizontal") {
          tableLayout.applyTableGroupAlignment($activeTables, "y");
        } else if (key === "spreadEvenly") {
          tableLayout.applyTableGroupSpread($activeTables);
        }
      },
      items: {
        title: { name: I18n.t("admin_local.table") + "s" },
        sep: "---------",
        alignVertical: { name: "Align Vertical", icon: "edit" },
        alignHorizontal: { name: "Align Horizontal", icon: "edit" },
        spreadEvenly: { name: "Spread Evenly", icon: "edit" }
      }
    };
  },

  getMultiRoomContextActions: function ($trigger) {
    if (!tableLayout.table_edit_mode) return null;
    var $rooms = tableLayout.getSelectedRoomsForGroupActions($trigger);
    if (!$rooms || $rooms.length < 2) return null;

    return {
      callback: function (key) {
        var $activeRooms = tableLayout.getSelectedRoomsForGroupActions($trigger);
        if (!$activeRooms || $activeRooms.length < 2) return;
        if (key === "alignVertical") {
          tableLayout.applyRoomGroupAlignment($activeRooms, "x");
        } else if (key === "alignHorizontal") {
          tableLayout.applyRoomGroupAlignment($activeRooms, "y");
        } else if (key === "spreadEvenly") {
          tableLayout.applyRoomGroupSpread($activeRooms);
        }
      },
      items: {
        title: { name: I18n.t("admin_local.room") + "s" },
        sep: "---------",
        alignVertical: { name: "Align Vertical", icon: "edit" },
        alignHorizontal: { name: "Align Horizontal", icon: "edit" },
        spreadEvenly: { name: "Spread Evenly", icon: "edit" }
      }
    };
  },

  enableTableMarqueeSelection: function () {
    tableLayout.disableTableMarqueeSelection();
    var $host = $("#c");
    if ($host.length === 0) return;

    $host.on("mousedown.tableMarqueeSelect", function (event) {
      if (!tableLayout.table_edit_mode) return;
      if (event.which !== 1) return;
      if ($(event.target).closest("#table-layout-create-controls, #table-layout-mode-controls, #table-layout-helper-actions, #seat-layout-helper-actions").length > 0) return;
      if ($(event.target).closest("circle.eatwithme-resize-corner").length > 0) return;
      if ($(event.target).closest("g.eatwithme-table, g.eatwithme-seat, text.eatwithme-roomName, tspan.eatwithme-tableNumber").length > 0) return;

      event.preventDefault();

      var additive = !!(event.shiftKey || event.metaKey || event.ctrlKey);
      var startX = event.pageX;
      var startY = event.pageY;
      var hostOffset = $host.offset() || { left: 0, top: 0 };

      var $box = $("<div id='table-layout-marquee-select-box'/>").css({
        position: "absolute",
        left: (startX - hostOffset.left) + "px",
        top: (startY - hostOffset.top) + "px",
        width: "0px",
        height: "0px",
        border: "1px dashed #0d6efd",
        background: "rgba(13,110,253,0.12)",
        pointerEvents: "none",
        zIndex: 2500
      });
      $host.append($box);

      var updateBox = function (pageX, pageY) {
        var left = Math.min(startX, pageX);
        var top = Math.min(startY, pageY);
        var width = Math.abs(pageX - startX);
        var height = Math.abs(pageY - startY);
        $box.css({
          left: (left - hostOffset.left) + "px",
          top: (top - hostOffset.top) + "px",
          width: width + "px",
          height: height + "px"
        });
      };

      var finish = function (pageX, pageY) {
        updateBox(pageX, pageY);

        var rect = {
          left: Math.min(startX, pageX),
          right: Math.max(startX, pageX),
          top: Math.min(startY, pageY),
          bottom: Math.max(startY, pageY)
        };

        if (!additive) {
          $("svg[visible='true'] g.eatwithme-table.ui-selected").removeClass("ui-selected");
          $("svg[visible='true'] g.eatwithme-room.ui-selected").removeClass("ui-selected");
        }

        var $selectedTables = $();
        $("svg[visible='true'] g.eatwithme-table.selectable").each(function (_, node) {
          var box = node.getBoundingClientRect();
          var nleft = box.left + window.pageXOffset;
          var nright = box.right + window.pageXOffset;
          var ntop = box.top + window.pageYOffset;
          var nbottom = box.bottom + window.pageYOffset;
          var intersects = nleft <= rect.right && nright >= rect.left && ntop <= rect.bottom && nbottom >= rect.top;
          if (intersects) {
            $selectedTables = $selectedTables.add($(node));
          }
        });

        var $selectedRooms = $();
        $("svg[visible='true'] g.eatwithme-room").each(function (_, node) {
          var box = node.getBoundingClientRect();
          var nleft = box.left + window.pageXOffset;
          var nright = box.right + window.pageXOffset;
          var ntop = box.top + window.pageYOffset;
          var nbottom = box.bottom + window.pageYOffset;
          var intersects = nleft <= rect.right && nright >= rect.left && ntop <= rect.bottom && nbottom >= rect.top;
          if (intersects) {
            $selectedRooms = $selectedRooms.add($(node));
          }
        });

        if ($selectedTables.length > 0) {
          $selectedTables.addClass("ui-selected");
          select($selectedTables.first().get(0));
          tableLayout.syncMultiSelectedTableVisuals();
          tableLayout.showTableActionButtons($selectedTables.first());
        } else if ($selectedRooms.length > 0) {
          $selectedRooms.addClass("ui-selected");
          var $roomName = $selectedRooms.first().find("text.eatwithme-roomName").first();
          if ($roomName.length > 0) {
            select($roomName.get(0));
            tableLayout.showRoomActionButtons($roomName);
          }
        } else if (!additive) {
          tableLayout.hideTableActionButtons();
        }

        $box.remove();

        var dragged = Math.abs(pageX - startX) > 3 || Math.abs(pageY - startY) > 3;
        if (dragged) {
          tableLayout.suppressNextSelectionClick = true;
          setTimeout(function () {
            tableLayout.suppressNextSelectionClick = false;
          }, 250);
        }
      };

      $(document).on("mousemove.tableMarqueeSelect", function (moveEvent) {
        updateBox(moveEvent.pageX, moveEvent.pageY);
      });

      $(document).on("mouseup.tableMarqueeSelect", function (upEvent) {
        $(document).off("mousemove.tableMarqueeSelect mouseup.tableMarqueeSelect");
        finish(upEvent.pageX, upEvent.pageY);
      });
    });
  },

  disableTableMarqueeSelection: function () {
    $("#c").off("mousedown.tableMarqueeSelect");
    $(document).off("mousemove.tableMarqueeSelect mouseup.tableMarqueeSelect");
    $("#table-layout-marquee-select-box").remove();
  },

  hideTableActionButtons: function () {
    $("#table-layout-helper-actions").remove();
  },

  hideSeatActionButtons: function () {
    $("#seat-layout-helper-actions").remove();
  },

  makePanelRepositionable: function ($panel, key, options) {
    if (!$panel || $panel.length === 0 || !key) return;
    var opts = options || {};
    if (!tableLayout.panelPositions) {
      tableLayout.panelPositions = {};
    }

    var saved = tableLayout.panelPositions[key];
    if (saved && Number.isFinite(saved.left) && Number.isFinite(saved.top)) {
      $panel.css({ left: saved.left + "px", top: saved.top + "px", right: "", bottom: "" });
    }

    if ($panel.data("ui-draggable")) {
      try {
        $panel.draggable("destroy");
      } catch (ex) {
      }
    }

    $panel.draggable({
      containment: opts.containment || "window",
      handle: opts.handle || undefined,
      scroll: false,
      start: function () {
        $(this).css({ right: "", bottom: "" });
      },
      stop: function (_event, ui) {
        tableLayout.panelPositions[key] = {
          left: ui.position.left,
          top: ui.position.top
        };
      }
    });
  },

  addLayoutRoomFromTemplate: function (templateKey, dropPoint) {
    var template = tableLayout.roomTemplates && tableLayout.roomTemplates[templateKey];
    if (!template || !template.svg) return;

    $("div#editRoom.modal").modal("show");
    tableLayout.editRoom({}, function (room) {
      var $svg = $("svg[visible='true']").first();
      if ($svg.length === 0) return;
      var viewport = $svg.get(0).viewBox.baseVal;
      var centerX = dropPoint && Number.isFinite(dropPoint.x) ? dropPoint.x : viewport.width / 2;
      var centerY = dropPoint && Number.isFinite(dropPoint.y) ? dropPoint.y : viewport.height / 2;
      var tableTemplate = tableLayout.tableMainTemplate.replace("XXX", centerX).replace("YYY", centerY);
      var roomSvg = tableLayout.makeSVG2($(template.svg));
      var table = tableLayout.makeSVG2($(tableTemplate));
      $(table).prepend($(roomSvg));
      var $svgg = $svg.find("> g#svg-g").first();
      if ($svgg.length === 0) {
        $svgg = $svg.find("> g").first();
      }
      $svgg.prepend($(table));
      $(table).find("text.eatwithme-roomName tspan").html(room.room);
      $(table).find("g.eatwithme-room").attr("id", "room_" + room.room);
      $(table).find("text.eatwithme-roomName").attr("id", "roomname_" + room.room);

      var $newRoomName = $(table).find("text.eatwithme-roomName").first();
      $newRoomName.addClass("selectable");
      if (tableLayout.table_edit_mode) {
        $newRoomName.off("click", tableLayout.clickSelectHandler);
        $newRoomName.on("click", tableLayout.clickSelectHandler);
      }

      if (!tableLayout.table_edit_mode) {
        tableLayout.registerRoomClickHandlers($svg);
      }
      tableLayout.initTableContextMenu();
      tableLayout.initTableDraggable();
      auth.updateHooks();
    });
  },

  addLayoutTableFromTemplate: function (templateKey, $trigger, dropPoint) {
    var template = tableLayout.tableTemplates && tableLayout.tableTemplates[templateKey];
    if (!template || !template.svg) return;

    $("div#editTableData.modal").modal("show");
    var $effectiveTrigger = $trigger && $trigger.length ? $trigger : $("svg[visible='true']").first();
    tableLayout.editTable({ seats: template.seats, layout: templateKey, isActive: true }, $effectiveTrigger, function (tableData) {
      var exist = false;
      tableLayout.tables.forEach(function (t) {
        if (t.number == tableData.tableNumber) {
          exist = true;
        }
      });
      var svg = $("#c svg");
      var viewport = svg.get(0).viewBox.baseVal;
      var centerX = dropPoint && Number.isFinite(dropPoint.x) ? dropPoint.x : viewport.width / 2;
      var centerY = dropPoint && Number.isFinite(dropPoint.y) ? dropPoint.y : viewport.height / 2;
      var tableTemplate = tableLayout.tableMainTemplate.replace("XXX", centerX).replace("YYY", centerY);

      var validateSvg = tableLayout.makeSVG2($(template.svg));
      var validateTable = tableLayout.makeSVG2($(tableTemplate));
      $(validateTable).append($(validateSvg));
      $(validateTable).attr("transform", "scale(1,1) translate(" + centerX + "," + centerY + ")");
      if (!tableLayout.canKeepLandscapeAfterAdding($(validateTable))) {
        tableLayout.showLandscapeConstraintMessage();
        return;
      }

      if (!exist) {
        admin.addTable(
          tableData.room,
          tableData.tableNumber,
          tableData.name,
          tableData.seats,
          tableData.shareable,
          tableData.visibleOnline,
          tableData.bookOnline,
          tableData.active,
          tableData.type,
          tableData.pos,
          tableData.forStore,
          tableData.extensions,
          function () {
            var svg = tableLayout.makeSVG2($(template.svg));
            var table = tableLayout.makeSVG2($(tableTemplate));
            $(table).append($(svg));
            var svgg = $("svg[visible='true'] > g");
            svgg.append($(table));
            $(table).attr("transform", "scale(1,1) translate(" + centerX + "," + centerY + ")");

            $(table)
              .find("tspan.eatwithme-tableNumber")
              .html(tableData.name != "" ? tableData.name : tableData.tableNumber);
            $(table).attr("id", tableData.tableNumber + "-number");
            const $eatwithmeTable = $(table).find(".eatwithme-table");
            $eatwithmeTable.attr("id", tableData.tableNumber);
            $(table)
              .find("g.eatwithme-table")
              .addClass("selectable");
            $eatwithmeTable.on("click", tableLayout.clickSelectHandler);
            $(table)
              .find(".eatwithme-seat")
              .each(function (ind, t) {
                $(t).attr("id", tableData.tableNumber + "-" + (ind + 1));
                $(t).addClass("selectable");
                $(t).click(auth.clickHandler);
              });

            tableLayout.realignTableVisuals($(table));

            select($eatwithmeTable);
            tableLayout.initTableContextMenu();
            tableLayout.initTableDraggable();
            auth.updateHooks();
          }
        );
      } else {
        var svg = tableLayout.makeSVG2($(template.svg));
        var table = tableLayout.makeSVG2($(tableTemplate));
        $(table).append($(svg));
        var svgg = $("svg[visible='true'] > g");

        $(table).attr("transform", "scale(1,1) translate(" + centerX + "," + centerY + ")");

        svgg.append($(table));

        $(table)
          .find("tspan.eatwithme-tableNumber")
          .html(tableData.name != "" ? tableData.name : tableData.tableNumber);
        $(table).attr("id", tableData.tableNumber + "-number");
        const $eatwithmeTable = $(table).find(".eatwithme-table");
        $eatwithmeTable.attr("id", tableData.tableNumber);
        $(table)
          .find("g.eatwithme-table")
          .addClass("selectable");
        $eatwithmeTable.on("click", tableLayout.clickSelectHandler);
        $(table)
          .find(".eatwithme-seat")
          .each(function (ind, t) {
            $(t).attr("id", tableData.tableNumber + "-" + (ind + 1));
            $(t).addClass("selectable");
            $(t).click(auth.clickHandler);
          });

        tableLayout.realignTableVisuals($(table));

        select($eatwithmeTable);

        tableLayout.initTableContextMenu();
        tableLayout.initTableDraggable();
        auth.updateHooks();
      }
    });
  },

  renderLayoutModeControls: function () {
    $("#table-layout-mode-controls").remove();

    if (window.mobileAndTabletcheck() || !hasRole("sales.tablesoverview.modify") || tableLayout.roomView || tableLayout.getOrientation() !== "landscape") {
      return;
    }

    var $layoutContainer = $("#c");
    if ($layoutContainer.length === 0) return;
    if ($layoutContainer.css("position") === "static" || !$layoutContainer.css("position")) {
      $layoutContainer.css("position", "relative");
    }

    var $controls = $('<div id="table-layout-mode-controls"/>').css({
      position: "absolute",
      left: "16px",
      bottom: "16px",
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",
      gap: "8px",
      width: "auto",
      height: "auto",
      background: "rgba(255,255,255,0.96)",
      border: "1px solid #d7d7d7",
      borderRadius: "8px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.16)",
      padding: "8px"
    });
    if ($controls.get(0) && $controls.get(0).style) {
      $controls.get(0).style.setProperty("width", "auto", "important");
      $controls.get(0).style.setProperty("height", "auto", "important");
      $controls.get(0).style.setProperty("min-width", "auto", "important");
      $controls.get(0).style.setProperty("min-height", "auto", "important");
      $controls.get(0).style.setProperty("max-width", "max-content", "important");
      $controls.get(0).style.setProperty("max-height", "max-content", "important");
    }

    var makeButton = function (label, iconClass, onClick, buttonClass, iconOnly) {
      var $btn = $('<button type="button" class="btn btn-sm"/>');
      $btn.addClass(buttonClass || "btn-outline-secondary");
      if (iconOnly) {
        $btn.css({
          width: "32px",
          height: "32px",
          minWidth: "32px",
          minHeight: "32px",
          maxWidth: "32px",
          maxHeight: "32px",
          padding: "0",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: "1",
          flex: "0 0 auto"
        });
        if ($btn.get(0) && $btn.get(0).style) {
          $btn.get(0).style.setProperty("width", "32px", "important");
          $btn.get(0).style.setProperty("height", "32px", "important");
          $btn.get(0).style.setProperty("min-width", "32px", "important");
          $btn.get(0).style.setProperty("min-height", "32px", "important");
          $btn.get(0).style.setProperty("max-width", "32px", "important");
          $btn.get(0).style.setProperty("max-height", "32px", "important");
        }
        $btn.append($('<i/>').addClass(iconClass).css({ fontSize: "16px", margin: "0" }));
      } else {
        $btn.append($('<i/>').addClass(iconClass).css({ marginRight: "6px" }));
        $btn.append($("<span/>").text(label));
      }
      $btn.attr("title", label);
      $btn.on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      });
      return $btn;
    };

    if (tableLayout.table_edit_mode) {
      var $modeDragHandle = $('<span class="table-layout-mode-panel-handle" title="Move"/>').css({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "18px",
        minWidth: "18px",
        height: "18px",
        marginRight: "4px",
        color: "#6c757d",
        cursor: "move",
        userSelect: "none"
      });
      $modeDragHandle.append($('<i class="icon icon-menu"/>').css({ fontSize: "12px", lineHeight: "12px" }));
      $controls.append($modeDragHandle);

      $controls.append(
        makeButton(I18n.t("admin_local.disable_edit_mode"), "icon icon-arrows-ccw", function () {
          tableLayout.editMode(false);
        }, "btn-outline-secondary")
      );
      $controls.append(
        makeButton(I18n.t("admin_local.save_layout"), "icon icon-floppy", function () {
          tableLayout.saveLayout();
        }, "btn-primary")
      );
      $layoutContainer.append($controls);
      tableLayout.makePanelRepositionable($controls, "table-layout-mode-controls", { containment: "parent", handle: ".table-layout-mode-panel-handle" });
    } else {
      var $editBtn = makeButton(I18n.t("admin_local.enable_edit_mode"), "icon icon-edit", function () {
        _log("Enabling edit mode");
        tableLayout.editMode(true);
      }, "btn-outline-secondary", true);
      $editBtn.attr("id", "table-layout-mode-controls");
      $editBtn.css({
        position: "absolute",
        left: "16px",
        bottom: "16px",
        zIndex: 2
      });
      $layoutContainer.append($editBtn);
      tableLayout.makePanelRepositionable($editBtn, "table-layout-mode-controls", { containment: "parent" });
    }
  },

  renderLayoutCreateControls: function () {
    $("#table-layout-create-controls").remove();

    var $layoutContainer = $("#c");
    if ($layoutContainer.length > 0 && $layoutContainer.data("ui-droppable")) {
      try {
        $layoutContainer.droppable("destroy");
      } catch (ex) {
      }
    }

    if (window.mobileAndTabletcheck() || !hasRole("sales.tablesoverview.modify") || tableLayout.roomView || !tableLayout.table_edit_mode) {
      return;
    }

    if ($layoutContainer.length === 0) return;
    if ($layoutContainer.css("position") === "static" || !$layoutContainer.css("position")) {
      $layoutContainer.css("position", "relative");
    }

    var $controls = $('<div id="table-layout-create-controls"/>').css({
      position: "absolute",
      left: "16px",
      top: "16px",
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      gap: "6px",
      flexWrap: "wrap",
      width: "max-content",
      maxWidth: "calc(100% - 32px)",
      height: "auto",
      minHeight: "0",
      maxHeight: "max-content",
      background: "rgba(255,255,255,0.96)",
      border: "1px solid #d7d7d7",
      borderRadius: "8px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.16)",
      padding: "8px"
    });
    if ($controls.get(0) && $controls.get(0).style) {
      $controls.get(0).style.setProperty("width", "max-content", "important");
      $controls.get(0).style.setProperty("max-width", "calc(100% - 32px)", "important");
      $controls.get(0).style.setProperty("height", "auto", "important");
      $controls.get(0).style.setProperty("min-height", "0", "important");
      $controls.get(0).style.setProperty("max-height", "max-content", "important");
    }

    var $dragHandle = $('<span class="table-layout-panel-handle" title="Move"/>').css({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "18px",
      minWidth: "18px",
      height: "18px",
      marginRight: "4px",
      color: "#6c757d",
      cursor: "move",
      userSelect: "none"
    });
    $dragHandle.append($('<i class="icon icon-menu"/>').css({ fontSize: "12px", lineHeight: "12px" }));
    $controls.append($dragHandle);

    var buildTemplateIcon = function (templateSvg, sizePx, removeSeats, templateKey) {
      if (!templateSvg) return null;
      var parsed = null;
      try {
        parsed = tableLayout.makeSVG2($(templateSvg));
      } catch (ex) {
        parsed = null;
      }
      if (!parsed) return null;

      var $node = $(parsed);
      $node.find("text, tspan").remove();
      $node.find("[opacity='0'], [style*='opacity:0'], [style*='opacity: 0'], [visibility='hidden']").remove();
      if (removeSeats) {
        $node.find(".eatwithme-seat").remove();
      }
      $node.find("[class]").removeAttr("class");
      $node.find("[id]").removeAttr("id");
      $node.removeAttr("class");
      $node.removeAttr("id");
      $node.removeAttr("style");
      $node.removeAttr("width");
      $node.removeAttr("height");

      var width = Number($node.attr("width")) || 128;
      var height = Number($node.attr("height")) || 76;
      var previewSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      previewSvg.setAttribute("aria-hidden", "true");
      previewSvg.setAttribute("width", String(sizePx));
      previewSvg.setAttribute("height", String(sizePx));
      previewSvg.setAttribute("viewBox", "0 0 " + width + " " + height);
      previewSvg.setAttribute("preserveAspectRatio", "xMidYMid meet");
      previewSvg.style.width = sizePx + "px";
      previewSvg.style.height = sizePx + "px";
      previewSvg.style.display = "block";
      previewSvg.style.overflow = "visible";

      var iconNode = $node.get(0);
      var iconWrapper = document.createElementNS("http://www.w3.org/2000/svg", "g");
      iconWrapper.appendChild(iconNode);
      previewSvg.appendChild(iconWrapper);

      try {
        var $probe = $("<div/>").css({
          position: "absolute",
          left: "-10000px",
          top: "-10000px",
          width: "1200px",
          height: "1200px",
          overflow: "visible",
          visibility: "hidden",
          pointerEvents: "none"
        });
        $probe.append(previewSvg);
        $("body").append($probe);

        var iconBBox = iconWrapper.getBBox ? iconWrapper.getBBox() : null;
        if (iconBBox && Number.isFinite(iconBBox.width) && Number.isFinite(iconBBox.height) && iconBBox.width > 0 && iconBBox.height > 0) {
          var pad = 0;
          var vbW = iconBBox.width + pad * 2;
          var vbH = iconBBox.height + pad * 2;

          // Normalize wrapper so legacy template coordinates fit a clean viewport.
          var shiftX = -(iconBBox.x - pad);
          var shiftY = -(iconBBox.y - pad);
          iconWrapper.setAttribute("transform", "translate(" + shiftX + "," + shiftY + ")");

          previewSvg.setAttribute("viewBox", "0 0 " + vbW + " " + vbH);
        }

        $probe.remove();
      } catch (ex) {
      }

      return $(previewSvg);
    };

    var makeIconButton = function (label, onClick, $iconNode, createType, templateKey) {
      var $btn = $('<button type="button" class="btn btn-sm btn-outline-secondary"/>').css({
        width: "38px",
        height: "38px",
        minWidth: "38px",
        minHeight: "38px",
        maxWidth: "38px",
        maxHeight: "38px",
        padding: "0",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: "1",
        cursor: "grab"
      });
      if ($btn.get(0) && $btn.get(0).style) {
        $btn.get(0).style.setProperty("width", "38px", "important");
        $btn.get(0).style.setProperty("height", "38px", "important");
        $btn.get(0).style.setProperty("min-width", "38px", "important");
        $btn.get(0).style.setProperty("min-height", "38px", "important");
        $btn.get(0).style.setProperty("max-width", "38px", "important");
        $btn.get(0).style.setProperty("max-height", "38px", "important");
      }

      if ($iconNode && $iconNode.length) {
        $btn.append($iconNode);
      } else {
        $btn.append($('<i class="icon icon-plus"/>'));
      }

      if (createType === "table") {
        $btn.css({ position: "relative" });
        $btn.append(
          $('<i class="icon icon-plus"/>').css({
            position: "absolute",
            right: "-4px",
            bottom: "-4px",
            fontSize: "10px",
            lineHeight: "10px",
            color: "#0d6efd",
            background: "#fff",
            borderRadius: "50%",
            padding: "1px"
          })
        );
      }

      $btn.attr("title", label);
      if (createType && templateKey) {
        $btn.attr("data-create-type", createType);
        $btn.attr("data-template-key", templateKey);
      }
      $btn.on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (createType === "table" || createType === "room") {
          return;
        }
        onClick();
      });

      if ($btn.attr("data-create-type")) {
        $btn.draggable({
          scope: "layout-create",
          cancel: "",
          helper: "clone",
          appendTo: "body",
          zIndex: 4000,
          cursor: "grabbing",
          distance: 6,
          revert: "invalid",
          revertDuration: 120,
          start: function () {
            tableLayout.hideTableActionButtons();
            tableLayout.hideSeatActionButtons();
          }
        });
      }

      return $btn;
    };

    var resolveDropSvg = function () {
      var $svg = $("svg[visible='true']").first();
      if ($svg.length === 0) {
        $svg = $("#c svg").first();
      }
      return $svg;
    };

    var getDropPointInSvg = function (event, ui) {
      var $svg = resolveDropSvg();
      if ($svg.length === 0) return null;

      var svgNode = $svg.get(0);
      if (!svgNode || !svgNode.createSVGPoint || !svgNode.getScreenCTM || !svgNode.getScreenCTM()) {
        return null;
      }

      var clientX = event && Number.isFinite(event.clientX) ? event.clientX : null;
      var clientY = event && Number.isFinite(event.clientY) ? event.clientY : null;
      if ((clientX == null || clientY == null) && event && Number.isFinite(event.pageX) && Number.isFinite(event.pageY)) {
        clientX = event.pageX - window.pageXOffset;
        clientY = event.pageY - window.pageYOffset;
      }
      if ((clientX == null || clientY == null) && ui && ui.offset && ui.helper) {
        clientX = ui.offset.left + ui.helper.outerWidth() / 2 - window.pageXOffset;
        clientY = ui.offset.top + ui.helper.outerHeight() / 2 - window.pageYOffset;
      }
      if (clientX == null || clientY == null) return null;

      var pt = svgNode.createSVGPoint();
      pt.x = clientX;
      pt.y = clientY;

      var ctm = svgNode.getScreenCTM();
      if (!ctm || !ctm.inverse) return null;
      var local = pt.matrixTransform(ctm.inverse());
      if (!local || !Number.isFinite(local.x) || !Number.isFinite(local.y)) return null;
      return { x: local.x, y: local.y };
    };

    $layoutContainer.droppable({
      scope: "layout-create",
      accept: "#table-layout-create-controls button[data-create-type]",
      tolerance: "pointer",
      drop: function (event, ui) {
        var $dragged = $(ui.draggable);
        var createType = $dragged.attr("data-create-type");
        var templateKey = $dragged.attr("data-template-key");
        if (!createType || !templateKey) return;

        var dropPoint = getDropPointInSvg(event, ui);
        if (createType === "room") {
          tableLayout.addLayoutRoomFromTemplate(templateKey, dropPoint);
          return;
        }
        tableLayout.addLayoutTableFromTemplate(templateKey, resolveDropSvg(), dropPoint);
      }
    });

    $controls.append(
      makeIconButton(I18n.t("admin_local.smaller") || "Smaller", function () {
        tableLayout.zoomFloorplan("-");
      }, $('<i class="icon icon-resize-small"/>'))
    );
    $controls.append(
      makeIconButton(I18n.t("admin_local.bigger") || "Bigger", function () {
        tableLayout.zoomFloorplan("+");
      }, $('<i class="icon icon-resize-full"/>'))
    );

    var roomKey = Object.keys(tableLayout.roomTemplates || {})[0];
    if (roomKey) {
      var roomTemplate = tableLayout.roomTemplates[roomKey];
      var $roomIcon = buildTemplateIcon(roomTemplate && roomTemplate.svg, 18, true, roomKey);
      $controls.append(
        makeIconButton(roomTemplate && roomTemplate.name ? roomTemplate.name : I18n.t("admin_local.room"), function () {
          tableLayout.addLayoutRoomFromTemplate(roomKey);
        }, $roomIcon, "room", roomKey)
      );
    }

    Object.keys(tableLayout.tableTemplates || {}).forEach(function (templateKey) {
      var template = tableLayout.tableTemplates[templateKey];
      if (!template || !template.svg) return;
      var $icon = buildTemplateIcon(template.svg, 18, false, templateKey);
      $controls.append(
        makeIconButton(template.name || templateKey, function () {
          tableLayout.addLayoutTableFromTemplate(templateKey, $("svg[visible='true']").first());
        }, $icon, "table", templateKey)
      );
    });

    $layoutContainer.append($controls);
    tableLayout.makePanelRepositionable($controls, "table-layout-create-controls", { containment: "parent", handle: ".table-layout-panel-handle" });
  },

  showTableActionButtons: function ($trigger) {
    tableLayout.hideSeatActionButtons();
    tableLayout.hideRoomActionButtons();
    if (!tableLayout.table_edit_mode || window.mobileAndTabletcheck() || !hasRole("sales.tablesoverview.modify")) {
      tableLayout.hideTableActionButtons();
      return;
    }

    var isRoomTrigger = $trigger && ($trigger.hasClass("eatwithme-roomName") || $trigger.closest("g.eatwithme-room").length > 0 || $trigger.hasClass("eatwithme-room"));

    $trigger = isRoomTrigger ? tableLayout.resolveRoomActionTrigger($trigger) : tableLayout.resolveTableActionTrigger($trigger);
    if (!$trigger || $trigger.length === 0) {
      tableLayout.hideTableActionButtons();
      return;
    }

    var config = null;
    if (isRoomTrigger) {
      config = tableLayout.getMultiRoomContextActions($trigger) || tableLayout.getRoomContextActions($trigger);
    } else {
      config = tableLayout.getMultiTableContextActions($trigger) || tableLayout.getTableContextActions($trigger);
    }
    if (!config || !config.items) {
      tableLayout.hideTableActionButtons();
      return;
    }

    var $anchor = $trigger;
    if (isRoomTrigger) {
      var $roomNameAnchor = $trigger.hasClass("eatwithme-roomName")
        ? $trigger
        : $trigger.find("text.eatwithme-roomName").first();
      if ($roomNameAnchor && $roomNameAnchor.length > 0) {
        $anchor = $roomNameAnchor;
      }
    }

    var rect = $anchor.get(0).getBoundingClientRect();
    var $panel = $("#table-layout-helper-actions");
    if ($panel.length === 0) {
      $panel = $('<div id="table-layout-helper-actions"/>');
      $("body").append($panel);
    }

    $panel.empty();
    var panelTop = rect.bottom + 20;
    var panelMaxTop = window.innerHeight - 220;
    if (panelTop > panelMaxTop) {
      panelTop = Math.max(8, rect.top - 170);
    }

    var panelLeft = Math.max(8, Math.min(rect.left, window.innerWidth - 440));
    if (isRoomTrigger) {
      panelLeft = Math.max(8, Math.min(rect.left + rect.width / 2 - 160, window.innerWidth - 440));
    }

    $panel.css({
      position: "fixed",
      left: panelLeft + "px",
      top: Math.max(8, panelTop) + "px",
      zIndex: 3000,
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      maxWidth: "430px",
      padding: "10px",
      background: "rgba(255,255,255,0.96)",
      border: "1px solid #d7d7d7",
      borderRadius: "8px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.16)"
    });
    tableLayout.makePanelRepositionable($panel, "table-layout-helper-actions", { containment: "window" });

    var $iconRow = $('<div class="table-layout-helper-icon-row"/>').css({
      display: "flex",
      gap: "6px",
      flexWrap: "wrap"
    });
    var $otherRow = $('<div class="table-layout-helper-other-row"/>').css({
      display: "flex",
      gap: "6px",
      flexWrap: "wrap",
      paddingTop: "6px",
      borderTop: "1px solid #ededed"
    });

    var actionUi = {
      makeBigger: { order: 0, iconClass: "icon icon-resize-full", iconOnly: true },
      makeSmaller: { order: 0.5, iconClass: "icon icon-resize-small", iconOnly: true },
      rotateLeft: { order: 1, iconClass: "icon icon-arrows-ccw", iconOnly: true },
      rotateRight: { order: 2, iconClass: "icon icon-arrows-ccw", iconOnly: true, iconStyle: { transform: "scaleX(-1)", display: "inline-block" } },
      duplicate: { order: 3, iconClass: "icon icon-docs", iconOnly: true },
      deleteTable: { order: 4, iconClass: "icon icon-trash-empty", iconOnly: true },
      editTable: { order: -1, iconClass: "icon icon-edit", iconOnly: true },
      rename: { order: -1, iconClass: "icon icon-edit", iconOnly: true },
      delete: { order: 6, iconClass: "icon icon-trash-empty", iconOnly: true },
      new_normal_seat: { order: 6, iconOnly: true, seatTemplateKey: "new_normal_seat" },
      new_wooden_seat: { order: 7, iconOnly: true, seatTemplateKey: "new_wooden_seat" },
      activate: { order: 10, iconClass: "icon icon-lock-open" },
      deactivate: { order: 11, iconClass: "icon icon-lock" },
      makeShareable: { order: 20, iconClass: "icon icon-plus" },
      makeNonShareable: { order: 21, iconClass: "icon icon-cancel" },
      makePOS: { order: 22, iconClass: "icon icon-plus" },
      makeNonPOS: { order: 23, iconClass: "icon icon-cancel" },
      makeKiosk: { order: 24, iconClass: "icon icon-plus" },
      makeNonKiosk: { order: 25, iconClass: "icon icon-cancel" },
      makeVisibleOnline: { order: 26, iconClass: "icon icon-plus" },
      makeNonVisibleOnline: { order: 27, iconClass: "icon icon-cancel" },
      makeBookOnline: { order: 28, iconClass: "icon icon-plus" },
      makeNonBookOnline: { order: 29, iconClass: "icon icon-cancel" },
      alignVertical: { order: 31, iconClass: "fa fa-align-center", iconOnly: true },
      alignHorizontal: { order: 32, iconClass: "fa fa-align-center", iconOnly: true, iconStyle: { transform: "rotate(90deg)", display: "inline-block" } },
      spreadEvenly: { order: 33, iconClass: "fa fa-arrows-h", iconOnly: true },
      editMode: { order: 30, iconClass: "icon icon-edit" }
    };

    var buildSeatTemplateIcon = function (templateKey) {
      var template = tableLayout.seatTemplates && tableLayout.seatTemplates[templateKey];
      if (!template || !template.svg) return null;

      var parsed = null;
      try {
        var parser = new DOMParser();
        var doc = parser.parseFromString(
          '<svg xmlns="http://www.w3.org/2000/svg">' + template.svg + "</svg>",
          "image/svg+xml"
        );
        parsed = doc.documentElement && doc.documentElement.firstElementChild ? doc.documentElement.firstElementChild.cloneNode(true) : null;
      } catch (ex) {
        parsed = null;
      }
      if (!parsed) return null;

      var $seatNode = $(parsed);
      $seatNode.attr("id", "");
      $seatNode.attr("class", "");
      $seatNode.attr("style", "");
      $seatNode.attr("eatwithme-seat-number", "");
      $seatNode.attr("transform", "scale(1,1) translate(0,0)");
      $seatNode.find('[opacity="0"], [display="none"], text').remove();

      var width = Number($seatNode.attr("width")) || 24;
      var height = Number($seatNode.attr("height")) || 24;
      var viewBox = "0 0 " + width + " " + height;

      try {
        var measureSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        measureSvg.setAttribute("style", "position:absolute;left:-99999px;top:-99999px;width:0;height:0;overflow:hidden");
        var measureNode = $seatNode.get(0).cloneNode(true);
        measureSvg.appendChild(measureNode);
        document.body.appendChild(measureSvg);
        if (measureNode && measureNode.getBBox) {
          var bbox = measureNode.getBBox();
          if (bbox && Number.isFinite(bbox.width) && Number.isFinite(bbox.height) && bbox.width > 0 && bbox.height > 0) {
            viewBox = [bbox.x, bbox.y, bbox.width, bbox.height].join(" ");
          }
        }
        if (measureSvg.parentNode) {
          measureSvg.parentNode.removeChild(measureSvg);
        }
      } catch (ex) {
      }

      var previewSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      previewSvg.setAttribute("aria-hidden", "true");
      previewSvg.setAttribute("width", "18");
      previewSvg.setAttribute("height", "18");
      previewSvg.setAttribute("viewBox", viewBox);
      previewSvg.setAttribute("preserveAspectRatio", "xMidYMid meet");
      previewSvg.style.width = "18px";
      previewSvg.style.height = "18px";
      previewSvg.style.overflow = "visible";
      previewSvg.style.display = "block";
      previewSvg.appendChild($seatNode.get(0));
      return $(previewSvg);
    };

    var addButton = function (key, label) {
      var meta = actionUi[key] || {};
      var btnClasses = "btn btn-sm btn-outline-secondary" + (meta.iconOnly ? " helper-icon-btn" : "");
      var $btn = $('<button type="button" class="' + btnClasses + '"/>');
      if (meta.seatTemplateKey) {
        var $seatIcon = $('<span class="helper-seat-icon"/>').css({
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "22px",
          minWidth: "22px",
          maxWidth: "22px",
          height: "22px",
          minHeight: "22px",
          maxHeight: "22px"
        });

        $btn.css({
          width: "36px",
          minWidth: "36px",
          maxWidth: "36px",
          height: "30px",
          minHeight: "30px",
          maxHeight: "30px",
          padding: "2px 4px"
        });

        var $templateIcon = buildSeatTemplateIcon(meta.seatTemplateKey);
        if ($templateIcon) {
          $seatIcon.append($templateIcon);
        } else {
          $seatIcon.append($('<i class="icon icon-plus"/>'));
        }

        $seatIcon.append(
          $('<i class="icon icon-plus"/>').css({
            position: "absolute",
            right: "-5px",
            bottom: "-5px",
            fontSize: "10px",
            lineHeight: "10px",
            color: "#0d6efd",
            background: "#fff",
            borderRadius: "50%"
          })
        );
        $btn.append($seatIcon);
      } else if (meta.iconClass) {
        var $icon = $('<i class="' + meta.iconClass + '"/>');
        if (meta.iconStyle) {
          $icon.css(meta.iconStyle);
        }
        $btn.append($icon);
        if (!meta.iconOnly) {
          $btn.append($('<span style="margin-left:6px"/>').text(label || key));
        }
      } else {
        $btn.text(label || key);
      }
      $btn.attr("title", label || key);
      if (meta.iconOnly) {
        $btn.css({ minWidth: "34px", padding: "4px 6px" });
      }
      $btn.on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        config.callback(key, {});
        setTimeout(function () {
          if (!meta.iconOnly) {
            if (isRoomTrigger) tableLayout.hideRoomActionButtons();
            else tableLayout.hideTableActionButtons();
            return;
          }

          var nextTargetId = $trigger.attr("id");
          if (key === "editTable") {
            if (isRoomTrigger) tableLayout.hideRoomActionButtons();
            else tableLayout.hideTableActionButtons();
            return;
          }
          if (key === "rotateLeft" || key === "rotateRight" || key === "makeBigger" || key === "makeSmaller" || key === "rename" || key === "alignVertical" || key === "alignHorizontal" || key === "spreadEvenly") {
            var selector = isRoomTrigger ? ('g.eatwithme-room#' + nextTargetId) : ('g.eatwithme-table#' + nextTargetId);
            var $rotated = $(selector).filter(function () {
              return $(this).closest('svg[visible="true"]').length > 0;
            }).first();
            if ($rotated.length === 0 && !isRoomTrigger) {
              $rotated = $('svg[visible="true"] g.eatwithme-table.selectable.selected').first();
            }
            if ($rotated.length > 0) {
              if (isRoomTrigger) tableLayout.showRoomActionButtons($rotated);
              else tableLayout.showTableActionButtons($rotated);
            } else if (isRoomTrigger) {
              tableLayout.hideRoomActionButtons();
            } else {
              tableLayout.hideTableActionButtons();
            }
            return;
          }

          var $next = isRoomTrigger ? $('svg[visible="true"] g.eatwithme-room#' + nextTargetId) : $('svg[visible="true"] g.eatwithme-table#' + nextTargetId);
          if ($next.length === 0) {
            $next = isRoomTrigger ? $("svg[visible='true'] g.eatwithme-room.ui-selected").first() : $("svg[visible='true'] g.eatwithme-table.ui-selected").first();
          }
          if ($next.length === 0) {
            $next = $(isRoomTrigger ? "svg[visible='true'] g.eatwithme-room" : "svg[visible='true'] g.eatwithme-table").filter(function () {
              return $(this).closest(".ui-selected").length > 0;
            }).first();
          }
          if ($next.length > 0) {
            if (isRoomTrigger) tableLayout.showRoomActionButtons($next.first());
            else tableLayout.showTableActionButtons($next.first());
          } else {
            if (isRoomTrigger) tableLayout.hideRoomActionButtons();
            else tableLayout.hideTableActionButtons();
          }
        }, 0);
      });
      if (meta.iconOnly) {
        $iconRow.append($btn);
      } else {
        $otherRow.append($btn);
      }
    };

    var sortedActions = [];
    Object.keys(config.items).forEach(function (key) {
      var item = config.items[key];
      if (item == null) return;
      if (key === "title") return;
      if (typeof item === "string") return;
      if (item.items) {
        Object.keys(item.items).forEach(function (childKey) {
          var childItem = item.items[childKey] || {};
          sortedActions.push({ key: childKey, label: childItem.name || childKey });
        });
        return;
      }
      sortedActions.push({ key: key, label: item.name || key });
    });

    sortedActions.sort(function (a, b) {
      var aOrder = actionUi[a.key] && Number.isFinite(actionUi[a.key].order) ? actionUi[a.key].order : 999;
      var bOrder = actionUi[b.key] && Number.isFinite(actionUi[b.key].order) ? actionUi[b.key].order : 999;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return String(a.label).localeCompare(String(b.label));
    });

    var $selectedNumberText = tableLayout.getSelectedTableNumberTextTarget();
    if (!isRoomTrigger && $selectedNumberText.length) {
      sortedActions = sortedActions.filter(function (action) {
        return action.key === "makeBigger" || action.key === "makeSmaller";
      });
    }

    sortedActions.forEach(function (action) {
      addButton(action.key, action.label);
    });

    if ($iconRow.children().length > 0) {
      $panel.append($iconRow);
    }
    if ($otherRow.children().length > 0) {
      $panel.append($otherRow);
    }
  },

  bindTableActionButtons: function () {
    $(document).off("click.tableActionButtonsSelect");
    $(document).off("click.tableActionButtonsDismiss");

    $(document).on("click.tableActionButtonsSelect", "svg[visible='true'] g.eatwithme-table, svg[visible='true'] tspan.eatwithme-tableNumber, svg[visible='true'] text.eatwithme-roomName", function (e) {
      if (!tableLayout.table_edit_mode) {
        tableLayout.hideTableActionButtons();
        return;
      }
      tableLayout.showTableActionButtons($(e.currentTarget));
    });

    $(document).on("click.tableActionButtonsDismiss", function (e) {
      if ($(e.target).closest("#table-layout-helper-actions").length > 0) return;
      if ($(e.target).closest("g.eatwithme-table, tspan.eatwithme-tableNumber, text.eatwithme-roomName").length > 0) return;
      tableLayout.hideTableActionButtons();
    });
  },

  getOverlappingRoomsAtPoint: function (clientX, clientY) {
    if (!Number.isFinite(Number(clientX)) || !Number.isFinite(Number(clientY))) return $();

    var roomNodes = [];
    $("svg[visible='true'] g.eatwithme-room").each(function (_, roomNode) {
      if (!roomNode || !roomNode.getBoundingClientRect) return;
      var rect = roomNode.getBoundingClientRect();
      if (!rect) return;

      var left = Number(rect.left);
      var top = Number(rect.top);
      var right = Number(rect.right);
      var bottom = Number(rect.bottom);
      if (!Number.isFinite(left) || !Number.isFinite(top) || !Number.isFinite(right) || !Number.isFinite(bottom)) return;

      if (Number(clientX) >= left && Number(clientX) <= right && Number(clientY) >= top && Number(clientY) <= bottom) {
        roomNodes.push(roomNode);
      }
    });

    // SVG paint order: later siblings are on top, so return top-to-bottom.
    roomNodes.reverse();
    return $(roomNodes);
  },

  resolveRoomActionTrigger: function ($trigger, triggerEvent) {
    if (!$trigger || $trigger.length === 0) return $();

    var fromRoomNameText = $trigger.hasClass("eatwithme-roomName") || $trigger.closest("text.eatwithme-roomName").length > 0;
    var $resolved = $();
    if ($trigger.hasClass("eatwithme-roomName")) {
      $resolved = $($trigger.closest("g.eatwithme-room").get(0));
    } else if ($trigger.hasClass("eatwithme-room")) {
      $resolved = $($trigger.get(0));
    } else {
      $resolved = $($trigger.closest("g.eatwithme-room").get(0));
    }

    var originalEvent = triggerEvent && (triggerEvent.originalEvent || triggerEvent);
    var clientX = originalEvent && Number(originalEvent.clientX);
    var clientY = originalEvent && Number(originalEvent.clientY);
    if (fromRoomNameText) return $resolved;
    if (!Number.isFinite(clientX) || !Number.isFinite(clientY)) return $resolved;

    var $stackedRooms = tableLayout.getOverlappingRoomsAtPoint(clientX, clientY);
    if (!$stackedRooms || $stackedRooms.length <= 1) return $resolved;

    var resolvedNode = $resolved.get(0);
    var resolvedIndex = -1;
    $stackedRooms.each(function (idx, node) {
      if (node === resolvedNode) {
        resolvedIndex = idx;
        return false;
      }
    });

    if (resolvedIndex < 0) {
      return $($stackedRooms.get(0));
    }

    // Re-clicking the currently selected top room cycles to the next overlapped room.
    if ($resolved.hasClass("ui-selected")) {
      return $($stackedRooms.get((resolvedIndex + 1) % $stackedRooms.length));
    }

    return $resolved;
  },

  hideRoomActionButtons: function () {
    tableLayout.hideTableActionButtons();
  },

  getRoomContextActions: function ($trigger) {
    $trigger = tableLayout.resolveRoomActionTrigger($trigger);
    if (!$trigger || $trigger.length === 0) return null;
    if (!tableLayout.table_edit_mode) return null;

    return {
      callback: function (key) {
        var $room = tableLayout.resolveRoomActionTrigger($trigger);
        if (!$room || $room.length === 0) return;
        var $roomName = $room.find("text.eatwithme-roomName").first();
        var $roomText = $roomName.find("tspan").first();
        var currentName = String($roomText.text() || $roomName.text() || "").trim();

        switch (key) {
          case "bringToTop":
            tableLayout.changeRoomZOrder($room, "top");
            break;
          case "bringForward":
            tableLayout.changeRoomZOrder($room, "forward");
            break;
          case "sendBackward":
            tableLayout.changeRoomZOrder($room, "backward");
            break;
          case "sendToBack":
            tableLayout.changeRoomZOrder($room, "back");
            break;
          case "makeBigger":
            tableLayout.scaleSvgTarget($roomName.length > 0 ? $roomName : $room, 1.1);
            break;
          case "makeSmaller":
            tableLayout.scaleSvgTarget($roomName.length > 0 ? $roomName : $room, 0.9);
            break;
          case "rename": {
            var nextName = window.prompt(I18n.t("admin_local.room"), currentName);
            if (nextName == null) break;
            nextName = String(nextName).trim();
            if (nextName.length === 0 || nextName === currentName) break;
            var oldRoomId = $room.attr("id") || (currentName ? "room_" + currentName : "");
            var nextRoomId = "room_" + nextName;
            $roomText.text(nextName);
            $roomName.attr("id", "roomname_" + nextName);
            $room.attr("id", nextRoomId);
            if (localStorage.roomView === oldRoomId) {
              localStorage.roomView = nextRoomId;
            }
            break;
          }
          case "delete":
            var $deleteRoomContainer = $room.closest("g.ui-draggable");
            if (!tableLayout.canKeepLandscapeAfterRemoving($deleteRoomContainer)) {
              tableLayout.showLandscapeConstraintMessage();
              break;
            }
            if (localStorage.roomView === $room.attr("id")) {
              delete localStorage.roomView;
            }
            $deleteRoomContainer.remove();
            tableLayout.hideRoomActionButtons();
            break;
        }
      },
      items: {
        title: { name: I18n.t("admin_local.room") },
        sep: "---------",
        bringToTop: { name: "Bring To Top", icon: "edit" },
        bringForward: { name: "Bring Forward", icon: "edit" },
        sendBackward: { name: "Send Backward", icon: "edit" },
        sendToBack: { name: "Send To Back", icon: "edit" },
        sepOrder: "---------",
        rename: { name: I18n.t("admin_local.rename"), icon: "edit" },
        makeBigger: { name: "Bigger", icon: "edit" },
        makeSmaller: { name: "Smaller", icon: "edit" },
        delete: { name: I18n.t("admin_local.delete"), icon: "delete" }
      }
    };
  },

  showRoomActionButtons: function ($trigger) {
    return tableLayout.showTableActionButtons($trigger);
  },

  bindRoomActionButtons: function () {
    tableLayout.bindTableActionButtons();
  },

  resolveSeatActionTrigger: function ($trigger) {
    if (!$trigger || $trigger.length === 0) return $();
    if ($trigger.hasClass("eatwithme-seat")) return $($trigger.get(0));
    return $($trigger.closest("g.eatwithme-seat").get(0));
  },

  getSeatContextActions: function ($trigger) {
    $trigger = tableLayout.resolveSeatActionTrigger($trigger);
    if (!$trigger || $trigger.length === 0) return null;
    if (!tableLayout.table_edit_mode) return null;

    var items = {};
    items["title"] = { name: I18n.t("admin_local.seat") };
    items["sep"] = "---------";
    items["makeBigger"] = {
      name: "Bigger",
      icon: "edit"
    };
    items["makeSmaller"] = {
      name: "Smaller",
      icon: "edit"
    };
    items["rotateLeft"] = {
      name: I18n.t("admin_local.rotate_left"),
      icon: "edit"
    };
    items["rotateRight"] = {
      name: I18n.t("admin_local.rotate_right"),
      icon: "edit"
    };
    items["duplicate"] = {
      name: I18n.t("admin_local.duplicate"),
      icon: "add"
    };
    items["deleteSeat"] = {
      name: I18n.t("admin_local.delete"),
      icon: "delete"
    };

    return {
      callback: function (key) {
        var setSeatRotationAroundCenter = function ($seat, deltaDeg) {
          if (!$seat || $seat.length === 0) return;
          var seatNode = $seat.get(0);
          if (!seatNode || !seatNode.getBBox || !seatNode.getScreenCTM) return;

          var parentNode = seatNode.parentNode;
          if (!parentNode || !parentNode.getScreenCTM || !parentNode.getScreenCTM() || !parentNode.getScreenCTM().inverse) return;

          var svgRoot = seatNode.ownerSVGElement;
          if (!svgRoot || !svgRoot.createSVGPoint || !svgRoot.createSVGMatrix) return;

          var box = null;
          try {
            box = seatNode.getBBox();
          } catch (ex) {
            box = null;
          }
          if (!box) return;

          var localCenterX = Number(box.x || 0) + Number(box.width || 0) / 2;
          var localCenterY = Number(box.y || 0) + Number(box.height || 0) / 2;

          var seatScreen = seatNode.getScreenCTM();
          var parentScreen = parentNode.getScreenCTM();
          if (!seatScreen || !parentScreen) return;

          var localToParent = parentScreen.inverse().multiply(seatScreen);

          var localCenter = svgRoot.createSVGPoint();
          localCenter.x = localCenterX;
          localCenter.y = localCenterY;
          var centerInParent = localCenter.matrixTransform(localToParent);

          var rotateMatrix = svgRoot.createSVGMatrix()
            .translate(centerInParent.x, centerInParent.y)
            .rotate(deltaDeg)
            .translate(-centerInParent.x, -centerInParent.y);

          var nextMatrix = rotateMatrix.multiply(localToParent);
          $seat.attr("transform", "matrix(" + nextMatrix.a + "," + nextMatrix.b + "," + nextMatrix.c + "," + nextMatrix.d + "," + nextMatrix.e + "," + nextMatrix.f + ")");
        };

        switch (key) {
          case "makeBigger":
            tableLayout.scaleSvgTarget($trigger, 1.1);
            break;
          case "makeSmaller":
            tableLayout.scaleSvgTarget($trigger, 0.9);
            break;
          case "deleteSeat":
            $trigger.remove();
            break;
          case "rotateRight":
            setSeatRotationAroundCenter($trigger, 45);
            break;
          case "rotateLeft":
            setSeatRotationAroundCenter($trigger, -45);
            break;
          case "duplicate":
            var $new = $trigger.clone();
            $new.appendTo($trigger.parent());
            var $tableContainer = $trigger.closest("g.ui-draggable").filter(function () {
              return $(this).find("g.eatwithme-table").length > 0;
            }).first();
            if (!$tableContainer || $tableContainer.length === 0) {
              $tableContainer = $trigger.parents("g").filter(function () {
                return $(this).find("g.eatwithme-table").length > 0;
              }).first();
            }

            var $table = $tableContainer.find("g.eatwithme-table").first();
            var tableId = $table.attr("id");
            if (!tableId) {
              tableId = String($trigger.attr("id") || "").split("-")[0] || "0";
            }

            var nextSeatIndex = 1;
            var nextSeatNumber = 1;
            $trigger.parent().find("g.eatwithme-seat").each(function (_, seatNode) {
              var sid = $(seatNode).attr("id") || "";
              var sm = new RegExp("^" + tableId + "-(\\d+)$").exec(sid);
              if (sm) {
                nextSeatIndex = Math.max(nextSeatIndex, Number(sm[1]) + 1);
              }
              var sn = Number($(seatNode).attr("eatwithme-seat-number"));
              if (Number.isFinite(sn) && sn > 0) {
                nextSeatNumber = Math.max(nextSeatNumber, sn + 1);
              }
            });

            $new.attr("id", tableId + "-" + nextSeatIndex);
            $new.attr("eatwithme-seat-number", String(nextSeatNumber));
            $new.addClass("selectable");
            $new.off("click", auth.clickHandler);
            $new.off("click", tableLayout.clickSelectHandler);
            if (tableLayout.table_edit_mode) {
              $new.on("click", tableLayout.clickSelectHandler);
            } else {
              $new.on("click", auth.clickHandler);
            }

            var seatTransform = $new.attr("transform") || "";
            if (/translate\((-?[\d\.]+),(-?[\d\.]+)\)/.test(seatTransform)) {
              $new.attr("transform", seatTransform.replace(/translate\((-?[\d\.]+),(-?[\d\.]+)\)/, function (_, x, y) {
                return "translate(" + (parseFloat(x) + 24) + "," + y + ")";
              }));
            } else {
              $new.attr("transform", ("translate(24,0) " + seatTransform).trim());
            }

            if (!$tableContainer || $tableContainer.length === 0) {
              $tableContainer = $trigger.parent().parent();
            }
            if (tableLayout.shouldRealignRectTableSeats($tableContainer)) {
              tableLayout.alignSeatsToClosestBorderHalfOutside($tableContainer);
            }
            if (tableLayout.table_edit_mode) {
              tableLayout.refreshEditModeResizeCorners($tableContainer);
            }

            tableLayout.initTableDraggable();
            tableLayout.initTableContextMenu();
            break;
        }
      },
      items: items
    };
  },

  showSeatActionButtons: function ($trigger) {
    tableLayout.hideTableActionButtons();
    tableLayout.hideRoomActionButtons();
    if (!tableLayout.table_edit_mode || window.mobileAndTabletcheck() || !hasRole("sales.tablesoverview.modify")) {
      tableLayout.hideSeatActionButtons();
      return;
    }

    var config = tableLayout.getSeatContextActions($trigger);
    if (!config || !config.items) {
      tableLayout.hideSeatActionButtons();
      return;
    }

    $trigger = tableLayout.resolveSeatActionTrigger($trigger);
    if (!$trigger || $trigger.length === 0) {
      tableLayout.hideSeatActionButtons();
      return;
    }

    var rect = $trigger.get(0).getBoundingClientRect();
    var $panel = $("#seat-layout-helper-actions");
    if ($panel.length === 0) {
      $panel = $('<div id="seat-layout-helper-actions"/>');
      $("body").append($panel);
    }

    $panel.empty();
    $panel.css({
      position: "fixed",
      left: Math.max(8, Math.min(rect.left, window.innerWidth - 340)) + "px",
      top: Math.max(8, Math.min(rect.bottom + 14, window.innerHeight - 140)) + "px",
      zIndex: 3000,
      display: "flex",
      gap: "6px",
      flexWrap: "wrap",
      maxWidth: "330px",
      padding: "8px",
      background: "rgba(255,255,255,0.96)",
      border: "1px solid #d7d7d7",
      borderRadius: "8px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.16)"
    });
    tableLayout.makePanelRepositionable($panel, "seat-layout-helper-actions", { containment: "window" });

    var actionUi = {
      makeBigger: { order: 0, iconClass: "icon icon-resize-full", iconOnly: true },
      makeSmaller: { order: 0.5, iconClass: "icon icon-resize-small", iconOnly: true },
      rotateLeft: { order: 1, iconClass: "icon icon-arrows-ccw", iconOnly: true },
      rotateRight: { order: 2, iconClass: "icon icon-arrows-ccw", iconOnly: true, iconStyle: { transform: "scaleX(-1)", display: "inline-block" } },
      duplicate: { order: 3, iconClass: "icon icon-docs", iconOnly: true },
      deleteSeat: { order: 4, iconClass: "icon icon-trash-empty", iconOnly: true }
    };

    var addButton = function (key, label) {
      var meta = actionUi[key] || {};
      var btnClasses = "btn btn-sm btn-outline-secondary" + (meta.iconOnly ? " helper-icon-btn" : "");
      var $btn = $('<button type="button" class="' + btnClasses + '"/>');
      if (meta.iconClass) {
        var $icon = $('<i class="' + meta.iconClass + '"/>');
        if (meta.iconStyle) {
          $icon.css(meta.iconStyle);
        }
        $btn.append($icon);
      } else {
        $btn.text(label || key);
      }
      $btn.attr("title", label || key);
      $btn.css({ minWidth: "34px", padding: "4px 6px" });
      $btn.on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        config.callback(key, {});
        var nextId = $trigger.attr("id");
        setTimeout(function () {
          if (key === "rotateLeft" || key === "rotateRight" || key === "makeBigger" || key === "makeSmaller") {
            var $rotated = $('g.eatwithme-seat#' + nextId).filter(function () {
              return $(this).closest('svg[visible="true"]').length > 0;
            }).first();
            if ($rotated.length > 0) {
              tableLayout.showSeatActionButtons($rotated);
            }
            return;
          }

          var $next = $('svg[visible="true"] g.eatwithme-seat#' + nextId).first();
          if ($next.length > 0) {
            tableLayout.showSeatActionButtons($next);
          } else {
            tableLayout.hideSeatActionButtons();
          }
        }, 0);
      });
      $panel.append($btn);
    };

    var sortedActions = [];
    Object.keys(config.items).forEach(function (key) {
      var item = config.items[key];
      if (item == null) return;
      if (key === "title") return;
      if (typeof item === "string") return;
      sortedActions.push({ key: key, label: item.name || key });
    });

    sortedActions.sort(function (a, b) {
      var aOrder = actionUi[a.key] && Number.isFinite(actionUi[a.key].order) ? actionUi[a.key].order : 999;
      var bOrder = actionUi[b.key] && Number.isFinite(actionUi[b.key].order) ? actionUi[b.key].order : 999;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return String(a.label).localeCompare(String(b.label));
    });

    sortedActions.forEach(function (action) {
      addButton(action.key, action.label);
    });
  },

  bindSeatActionButtons: function () {
    $(document).off("click.seatActionButtonsSelect");
    $(document).off("click.seatActionButtonsDismiss");

    $(document).on("click.seatActionButtonsSelect", "svg[visible='true'] g.eatwithme-seat", function (e) {
      if (!tableLayout.table_edit_mode) {
        tableLayout.hideSeatActionButtons();
        return;
      }
      e.stopPropagation();
      tableLayout.showSeatActionButtons($(e.currentTarget));
    });

    $(document).on("click.seatActionButtonsDismiss", function (e) {
      if ($(e.target).closest("#seat-layout-helper-actions").length > 0) return;
      if ($(e.target).closest("g.eatwithme-seat").length > 0) return;
      tableLayout.hideSeatActionButtons();
    });
  },

  initTableContextMenu: function () {
    if (window.mobileAndTabletcheck() || !hasRole("sales.tablesoverview.modify")) {
      tableLayout.hideTableActionButtons();
      tableLayout.hideSeatActionButtons();
      tableLayout.hideRoomActionButtons();
      return;
    }
    tableLayout.bindTableActionButtons();
    tableLayout.bindSeatActionButtons();
    tableLayout.bindRoomActionButtons();
    try {
      $.contextMenu("destroy", "g.eatwithme-table");
    } catch (ex) {
    }
    try {
      $.contextMenu("destroy", "g.eatwithme-seat");
    } catch (ex) {
    }
  },

  svgDragStart: function (event, ui) {
    var $target = $(event.target);
    var isRoomDragTarget = $target.hasClass("eatwithme-room") || $target.find("g.eatwithme-room").length > 0;
    var dragOrigin = event && event.originalEvent && event.originalEvent.target ? event.originalEvent.target : event.target;
    var startedFromRoomName = $(dragOrigin).closest("text.eatwithme-roomName, text.eatwithme-roomName *").length > 0;
    var roomNameDragEnabled = isRoomDragTarget && startedFromRoomName;
    if (tableLayout.table_edit_mode) {
      var $tableForHelpers = $target.find("g.eatwithme-table").first();
      if ($tableForHelpers.length === 0 && $target.hasClass("eatwithme-table")) {
        $tableForHelpers = $target;
      }
      tableLayout.dragHelperTableId = $tableForHelpers.length > 0 ? $tableForHelpers.attr("id") : null;
      tableLayout.hideTableActionButtons();
      tableLayout.hideSeatActionButtons();
    }
    $target.attr("transform_bk", $target.attr("transform"));
    var resizeEdges = tableLayout.getResizeEdges(event, $target);
    if (resizeEdges != null) {
      $target.attr("resize_mode", "true");
      $target.attr("room_name_drag", null);
      $target.removeData("multiDragMembers");
      $target.attr("room_drag_locked", null);
      $target.attr("resize_left", resizeEdges.left ? "true" : null);
      $target.attr("resize_right", resizeEdges.right ? "true" : null);
      $target.attr("resize_top", resizeEdges.top ? "true" : null);
      $target.attr("resize_bottom", resizeEdges.bottom ? "true" : null);
      var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec($target.attr("transform_bk") || "");
      $target.attr("resize_translate_x_bk", matches ? matches[1] : "0");
      $target.attr("resize_translate_y_bk", matches ? matches[2] : "0");
      tableLayout.captureSeatResizeEdges($target);
    } else {
      $target.attr("resize_mode", null);
      $target.attr("room_drag_locked", (isRoomDragTarget && !startedFromRoomName) ? "true" : null);
      $target.attr("room_name_drag", roomNameDragEnabled ? "true" : null);
      $target.attr("resize_left", null);
      $target.attr("resize_right", null);
      $target.attr("resize_top", null);
      $target.attr("resize_bottom", null);
      $target.attr("resize_translate_x_bk", null);
      $target.attr("resize_translate_y_bk", null);

      if (roomNameDragEnabled) {
        var $roomNameText = $target.find("text.eatwithme-roomName").first();
        if ($roomNameText.length > 0) {
          $roomNameText.attr("room_name_transform_bk", $roomNameText.attr("transform") || "");
        }
      }

      var $tableTarget = $target.find("g.eatwithme-table").first();
      if ($tableTarget.length === 0 && $target.hasClass("eatwithme-table")) {
        $tableTarget = $target;
      }

      var selectedMembers = [];
      if ($tableTarget.length > 0) {
        var tableId = String($tableTarget.attr("id") || "");
        var $selectedTables = $("svg[visible='true'] g.eatwithme-table.ui-selected");
        var isSelectedTable = tableId.length > 0 && $selectedTables.filter("#" + tableId).length > 0;

        if (isSelectedTable && $selectedTables.length > 1) {
          $selectedTables.each(function (_, tableNode) {
            var $container = $(tableNode).closest("g.ui-draggable").filter(function () {
              return $(this).find("g.eatwithme-table").length > 0;
            }).first();
            if (!$container || $container.length === 0) {
              $container = $(tableNode).parent().parent();
            }
            if (!$container || $container.length === 0) return;

            var containerNode = $container.get(0);
            if (selectedMembers.indexOf(containerNode) !== -1) return;
            selectedMembers.push(containerNode);
            $container.attr("multi_drag_transform_bk", $container.attr("transform") || "");
          });
        }
      }
      if (selectedMembers.length > 1) {
        $target.data("multiDragMembers", selectedMembers);
      } else {
        $target.removeData("multiDragMembers");
      }
    }
  },
  svgDrag: function (event, ui) {
    tableLayout.mousedown = null;
    if (tableLayout.contextmenu == true) return;
    if (tableLayout.table_edit_mode == false) return;
    // update coordinates manually, since top/left style props don't work on
    // SVG
    var $target = $(event.target);
    if ($target.attr("room_drag_locked") === "true" && $target.attr("resize_mode") !== "true") {
      if ($target.attr("transform_bk") != null) {
        $target.attr("transform", $target.attr("transform_bk"));
      }
      $target.css("top", "");
      $target.css("left", "");
      return;
    }
    var bound = event.target.getBoundingClientRect();
    if ($target.attr("top") == null) {
      $target.attr("top", bound.top);
      $target.attr("left", bound.left);
    }
    if ($target.prop("tagName") == "ellipse" && $target.attr("resize_mode") !== "true" && !event.shiftKey) {
      var bound = event.target.getBoundingClientRect();
      $target.attr("cx", ui.position.left - $target.attr("left") + bound.width / 2);
      $target.attr("cy", ui.position.top - $target.attr("top") + bound.height / 2);
    } else {
      var svg = $($("svg[visible = 'true']")[0]);
      var viewport = svg.get(0).viewBox.baseVal;
      var zoom = svg.css("zoom");
      var scaleX = svg.width() / viewport.width;
      var scaleY = svg.height() / viewport.height;
      var rotate = 0;
      var $t = $target;
      if ($t.hasClass("eatwithme-seat")) $t = $t.parent();
      while ($t.get(0).localName != "svg") {
        var transform = $t.attr("transform");
        var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec(transform);
        if (matches != null) {
          scaleX *= parseFloat(matches[1]);
          scaleY *= parseFloat(matches[2]);
        }
        var matches = /rotate\((-?[\d\.]+)\)/.exec(transform);
        if (matches != null) {
          rotate += parseFloat(matches[1]);
        }
        $t = $t.parent();
      }
      var left = parseFloat(ui.position.left);
      var top = parseFloat(ui.position.top);
      var original_left = parseFloat($target.attr("left"));
      var original_top = parseFloat($target.attr("top"));
      var original_transform = $target.attr("transform_bk");
      var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(original_transform);
      var shiftX = left - ui.originalPosition.left;
      var shiftY = top - ui.originalPosition.top;

      if (svg[0] !== tableLayout.SVG[0]) {
        rotate += 90;
      }

      var angle = -rotate * (Math.PI / 180); // Convert to radians

      var rotatedX = Math.cos(angle) * shiftX - Math.sin(angle) * shiftY;

      var rotatedY = Math.sin(angle) * shiftX + Math.cos(angle) * shiftY;

      var isRoomNameDrag = $target.attr("room_name_drag") === "true" && $target.attr("resize_mode") !== "true";
      if (isRoomNameDrag) {
        var $roomNameText = $target.find("text.eatwithme-roomName").first();
        var $roomRect = $roomNameText.prev("rect").first();
        if ($roomNameText.length > 0 && $roomRect.length > 0) {
          var moveScale = 1;
          var moveVariant = svg.parents('#floorplan').attr("variant");
          if (moveVariant == 2) {
            moveScale = scaleX;
          } else if (moveVariant == 1) {
            moveScale = scaleY;
          } else {
            moveScale = scaleY;
          }

          var deltaX = rotatedX / zoom / moveScale;
          var deltaY = rotatedY / zoom / moveScale;
          if (!Number.isFinite(deltaX)) deltaX = 0;
          if (!Number.isFinite(deltaY)) deltaY = 0;

          var baseTextTransform = $roomNameText.attr("room_name_transform_bk");
          if (baseTextTransform == null) {
            baseTextTransform = $roomNameText.attr("transform") || "";
          }
          var translateRegex = /translate\(\s*(-?[\d\.]+)(?:[\s,]+)(-?[\d\.]+)\s*\)/;
          var baseMatch = translateRegex.exec(baseTextTransform || "");
          var baseX = baseMatch ? Number(baseMatch[1]) : 0;
          var baseY = baseMatch ? Number(baseMatch[2]) : 0;
          var nextX = baseX + deltaX;
          var nextY = baseY + deltaY;

          var nextTransform;
          if (translateRegex.test(baseTextTransform || "")) {
            nextTransform = (baseTextTransform || "").replace(translateRegex, "translate(" + nextX + "," + nextY + ")");
          } else if ((baseTextTransform || "").length > 0) {
            nextTransform = "translate(" + nextX + "," + nextY + ") " + baseTextTransform;
          } else {
            nextTransform = "translate(" + nextX + "," + nextY + ")";
          }

          $roomNameText.attr("transform", nextTransform);

          try {
            var roomBox = $roomRect.get(0).getBoundingClientRect();
            var textBox = $roomNameText.get(0).getBoundingClientRect();
            if (roomBox && textBox) {
              var adjustX = 0;
              var adjustY = 0;

              if (textBox.width > roomBox.width) {
                adjustX = (roomBox.x + (roomBox.width - textBox.width) / 2) - textBox.x;
              } else {
                if (textBox.x < roomBox.x) {
                  adjustX = roomBox.x - textBox.x;
                } else if ((textBox.x + textBox.width) > (roomBox.x + roomBox.width)) {
                  adjustX = (roomBox.x + roomBox.width) - (textBox.x + textBox.width);
                }
              }

              if (textBox.height > roomBox.height) {
                adjustY = (roomBox.y + (roomBox.height - textBox.height) / 2) - textBox.y;
              } else {
                if (textBox.y < roomBox.y) {
                  adjustY = roomBox.y - textBox.y;
                } else if ((textBox.y + textBox.height) > (roomBox.y + roomBox.height)) {
                  adjustY = (roomBox.y + roomBox.height) - (textBox.y + textBox.height);
                }
              }

              if (adjustX !== 0 || adjustY !== 0) {
                var clampedX = nextX + adjustX;
                var clampedY = nextY + adjustY;
                var clampedTransform;
                if (translateRegex.test(baseTextTransform || "")) {
                  clampedTransform = (baseTextTransform || "").replace(translateRegex, "translate(" + clampedX + "," + clampedY + ")");
                } else if ((baseTextTransform || "").length > 0) {
                  clampedTransform = "translate(" + clampedX + "," + clampedY + ") " + baseTextTransform;
                } else {
                  clampedTransform = "translate(" + clampedX + "," + clampedY + ")";
                }
                $roomNameText.attr("transform", clampedTransform);
              }
            }
          } catch (ex) {
          }
        }

        if ($target.attr("transform_bk") != null) {
          $target.attr("transform", $target.attr("transform_bk"));
        }
        $target.css("top", "");
        $target.css("left", "");
        return;
      }

      rotate = 0;
      if ((event.shiftKey || $target.attr("resize_mode") === "true") && !tableLayout.isPoolTableResizeLocked($target)) {
        //Stretch
        var $shape = $target.find(".eatwithme-table rect, .eatwithme-table ellipse, .eatwithme-table path, .eatwithme-room rect").first();
        var $personPathsForResize = $target.find(".eatwithme-table .person path");
        if ($personPathsForResize.length > 0) {
          // Composite templates (e.g. pool table) should resize by scaling the person-group path,
          // so all grouped objects grow/shrink together.
          $shape = $personPathsForResize.first();
        }
        if ($shape.length === 0) {
          $target.css("top", "");
          $target.css("left", "");
          return;
        }
        var shapeTag = ($shape.prop("tagName") || "").toLowerCase();
        var scaleX = svg.width() / viewport.width;
        var scaleY = svg.height() / viewport.height;

        var $t = $shape;
        while ($t.get(0).localName != "svg") {
          var transform = $t.attr("transform");
          var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec(transform);
          if (matches != null) {
            scaleX *= parseFloat(matches[1]);
            scaleY *= parseFloat(matches[2]);
          }
          var matches = /rotate\((-?[\d\.]+)\)/.exec(transform);
          if (matches != null) {
            rotate += parseFloat(matches[1]);
          }
          $t = $t.parent();
        }
        var scale = 1;
        const variant = svg.parent().parent().parent().attr("variant");
        if (variant == 2) {
          scale = scaleX;
        } else if (variant == 1) {
          scale = scaleY;
        } else {
          scale = scaleX;
        }

        if (svg[0] !== tableLayout.SVG[0]) {
          rotate += 90;
        }

        if ($shape.attr("width_bk") == undefined) {
          if (shapeTag === "rect") {
            $shape.attr("width_bk", $shape.attr("width"));
          } else if (shapeTag === "ellipse") {
            $shape.attr("width_bk", Number($shape.attr("rx") || 0) * 2);
          } else {
            var pathBox = $shape.get(0).getBBox();
            $shape.attr("width_bk", pathBox.width);
          }
        }
        if ($shape.attr("height_bk") == undefined) {
          if (shapeTag === "rect") {
            $shape.attr("height_bk", $shape.attr("height"));
          } else if (shapeTag === "ellipse") {
            $shape.attr("height_bk", Number($shape.attr("ry") || 0) * 2);
          } else {
            var pathBox2 = $shape.get(0).getBBox();
            $shape.attr("height_bk", pathBox2.height);
          }
        }
        if ($shape.attr("resize_inv_ctm_a_bk") == null || $shape.attr("resize_inv_ctm_b_bk") == null || $shape.attr("resize_inv_ctm_c_bk") == null || $shape.attr("resize_inv_ctm_d_bk") == null) {
          var shapeCtmBk = $shape.get(0).getScreenCTM();
          if (shapeCtmBk && shapeCtmBk.inverse) {
            var invShapeCtmBk = shapeCtmBk.inverse();
            $shape.attr("resize_inv_ctm_a_bk", invShapeCtmBk.a);
            $shape.attr("resize_inv_ctm_b_bk", invShapeCtmBk.b);
            $shape.attr("resize_inv_ctm_c_bk", invShapeCtmBk.c);
            $shape.attr("resize_inv_ctm_d_bk", invShapeCtmBk.d);
            $shape.attr("resize_angle_bk", Math.atan2(shapeCtmBk.b, shapeCtmBk.a));
          }
        }
        if (shapeTag === "path") {
          var $shapeGroupBk = $shape.parent();
          if ($shapeGroupBk.attr("resize_transform_bk") == null) {
            $shapeGroupBk.attr("resize_transform_bk", $shapeGroupBk.attr("transform") || "");
          }
          if ($shapeGroupBk.attr("resize_bbox_x_bk") == null || $shapeGroupBk.attr("resize_bbox_y_bk") == null) {
            var pathBBoxBk = $shape.get(0).getBBox();
            $shapeGroupBk.attr("resize_bbox_x_bk", pathBBoxBk.x);
            $shapeGroupBk.attr("resize_bbox_y_bk", pathBBoxBk.y);
          }
        }

        var localDx = 0;
        var localDy = 0;
        var resizeAngle = rotate * (Math.PI / 180);
        var invA = Number($shape.attr("resize_inv_ctm_a_bk"));
        var invB = Number($shape.attr("resize_inv_ctm_b_bk"));
        var invC = Number($shape.attr("resize_inv_ctm_c_bk"));
        var invD = Number($shape.attr("resize_inv_ctm_d_bk"));
        var angleBk = Number($shape.attr("resize_angle_bk"));
        if (!Number.isNaN(invA) && !Number.isNaN(invB) && !Number.isNaN(invC) && !Number.isNaN(invD)) {
          localDx = invA * Number(shiftX) + invC * Number(shiftY);
          localDy = invB * Number(shiftX) + invD * Number(shiftY);
          if (!Number.isNaN(angleBk)) {
            resizeAngle = angleBk;
          }
        } else {
          localDx = (Math.cos(resizeAngle) * Number(shiftX) + Math.sin(resizeAngle) * Number(shiftY)) / scale;
          localDy = (-Math.sin(resizeAngle) * Number(shiftX) + Math.cos(resizeAngle) * Number(shiftY)) / scale;
        }

        var resizeLeft = $target.attr("resize_left") === "true";
        var resizeRight = $target.attr("resize_right") === "true";
        var resizeTop = $target.attr("resize_top") === "true";
        var resizeBottom = $target.attr("resize_bottom") === "true";

        // Fallback for Shift-resize where no specific edge/corner was selected.
        if (!resizeLeft && !resizeRight && !resizeTop && !resizeBottom) {
          resizeRight = true;
          resizeBottom = true;
        }

        var minSize = 30;
        var widthBk = Number($shape.attr("width_bk"));
        var heightBk = Number($shape.attr("height_bk"));
        var newWidth = widthBk;
        var newHeight = heightBk;
        var translateXBk = Number($target.attr("resize_translate_x_bk") || 0);
        var translateYBk = Number($target.attr("resize_translate_y_bk") || 0);
        var localAnchorShiftX = 0;
        var localAnchorShiftY = 0;

        if (resizeRight) {
          newWidth = Math.max(minSize, widthBk + localDx);
        }
        if (resizeLeft) {
          newWidth = Math.max(minSize, widthBk - localDx);
          var appliedDx = widthBk - newWidth;
          localAnchorShiftX += appliedDx;
        }
        if (resizeBottom) {
          newHeight = Math.max(minSize, heightBk + localDy);
        }
        if (resizeTop) {
          newHeight = Math.max(minSize, heightBk - localDy);
          var appliedDy = heightBk - newHeight;
          localAnchorShiftY += appliedDy;
        }

        var anchorShiftWorldX = Math.cos(resizeAngle) * localAnchorShiftX - Math.sin(resizeAngle) * localAnchorShiftY;
        var anchorShiftWorldY = Math.sin(resizeAngle) * localAnchorShiftX + Math.cos(resizeAngle) * localAnchorShiftY;
        var translateX = translateXBk + anchorShiftWorldX;
        var translateY = translateYBk + anchorShiftWorldY;

        if (shapeTag === "rect") {
          $shape.attr("width", newWidth);
          $shape.attr("height", newHeight);
        } else if (shapeTag === "ellipse") {
          var currentCx = Number($shape.attr("cx") || 0);
          var currentCy = Number($shape.attr("cy") || 0);
          var currentRx = Number($shape.attr("rx") || 0);
          var currentRy = Number($shape.attr("ry") || 0);
          var leftEdge = currentCx - currentRx;
          var topEdge = currentCy - currentRy;
          $shape.attr("rx", newWidth / 2);
          $shape.attr("ry", newHeight / 2);
          $shape.attr("cx", leftEdge + newWidth / 2);
          $shape.attr("cy", topEdge + newHeight / 2);
        } else if (shapeTag === "path") {
          var $shapeGroup = $shape.parent();
          var groupTransformBk = $shapeGroup.attr("resize_transform_bk") || "";
          var bboxX = Number($shapeGroup.attr("resize_bbox_x_bk") || 0);
          var bboxY = Number($shapeGroup.attr("resize_bbox_y_bk") || 0);
          var sx = widthBk > 0 ? newWidth / widthBk : 1;
          var sy = heightBk > 0 ? newHeight / heightBk : 1;
          var scaleTransform = "translate(" + bboxX + "," + bboxY + ") scale(" + sx + "," + sy + ") translate(" + (-bboxX) + "," + (-bboxY) + ")";
          $shapeGroup.attr("transform", scaleTransform + (groupTransformBk ? " " + groupTransformBk : ""));
        }

        var transformBk = $target.attr("transform_bk") || "";
        var newTransform;
        if (/translate\((-?[\d\.]+),(-?[\d\.]+)\)/.test(transformBk)) {
          newTransform = transformBk.replace(/translate\((-?[\d\.]+),(-?[\d\.]+)\)/, "translate(" + translateX + "," + translateY + ")");
        } else if (transformBk.length > 0) {
          newTransform = "translate(" + translateX + "," + translateY + ") " + transformBk;
        } else {
          newTransform = "translate(" + translateX + "," + translateY + ")";
        }
        $target.attr("transform", newTransform);
        tableLayout.refreshEditModeResizeCorners($target);
      } else {
        if (svg[0] !== tableLayout.SVG[0]) {
          rotate += 90;
        }
        angle = -rotate * (Math.PI / 180); // Convert to radians
        //move
        var scale = 1;
        //const variant = svg.parent().parent().parent().attr("variant");
        const variant = svg.parents('#floorplan').attr("variant");
        if (variant == 2) {
          scale = scaleX;
        } else if (variant == 1) {
          scale = scaleY;
        } else {
          scale = scaleY;
        }

        var new_left = rotatedX / zoom / scale + parseFloat(matches[1]);
        var new_top = rotatedY / zoom / scale + parseFloat(matches[2]);
        var new_transform = original_transform.replace(/translate\((-?[\d\.]+),(-?[\d\.]+)\)/, "translate(" + new_left + "," + new_top + ")");
        $target.attr("transform", new_transform);

        var multiDragMembers = $target.data("multiDragMembers");
        if (multiDragMembers && multiDragMembers.length > 1) {
          var baseLeft = Number(matches[1] || 0);
          var baseTop = Number(matches[2] || 0);
          var deltaLeft = new_left - baseLeft;
          var deltaTop = new_top - baseTop;

          multiDragMembers.forEach(function (memberNode) {
            if (!memberNode || memberNode === $target.get(0)) return;
            var $member = $(memberNode);
            var memberTransformBk = $member.attr("multi_drag_transform_bk") || "";
            var memberMatches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(memberTransformBk);
            var memberBaseLeft = memberMatches ? Number(memberMatches[1] || 0) : 0;
            var memberBaseTop = memberMatches ? Number(memberMatches[2] || 0) : 0;
            var memberNextLeft = memberBaseLeft + deltaLeft;
            var memberNextTop = memberBaseTop + deltaTop;
            var memberNextTranslate = "translate(" + memberNextLeft + "," + memberNextTop + ")";

            if (/translate\((-?[\d\.]+),(-?[\d\.]+)\)/.test(memberTransformBk)) {
              $member.attr("transform", memberTransformBk.replace(/translate\((-?[\d\.]+),(-?[\d\.]+)\)/, memberNextTranslate));
            } else if (memberTransformBk.length > 0) {
              $member.attr("transform", memberNextTranslate + " " + memberTransformBk);
            } else {
              $member.attr("transform", memberNextTranslate);
            }
          });
        }
      }
      $target.css("top", "");
      $target.css("left", "");
    }
  },
  shouldRealignRectTableSeats: function ($tableContainer) {
    if (!$tableContainer || $tableContainer.length === 0) return false;

    var shape = $tableContainer.find(".eatwithme-table rect, .eatwithme-table path, .eatwithme-table ellipse").first().get(0);
    if (!shape) {
      shape = $tableContainer.find(".eatwithme-room rect").first().get(0);
    }
    if (!shape || !shape.getScreenCTM) return false;

    var shapeTag = (shape.tagName || "").toLowerCase();
    if (shapeTag === "ellipse") return true;

    var ctm = shape.getScreenCTM();
    if (!ctm) return false;

    var rotationDeg = Math.atan2(ctm.b, ctm.a) * (180 / Math.PI);
    if (!Number.isFinite(rotationDeg)) return false;

    var normalized = ((rotationDeg % 360) + 360) % 360;
    var nearestQuarterTurn = Math.round(normalized / 90) * 90;
    var delta = Math.abs(normalized - nearestQuarterTurn);
    var toleranceDeg = 1;
    return delta <= toleranceDeg;
  },
  svgDragEnd: function (event, ui) {
    var $target = $(event.target);
    var multiDragMembers = $target.data("multiDragMembers");
    if (multiDragMembers && multiDragMembers.length > 0) {
      multiDragMembers.forEach(function (memberNode) {
        if (!memberNode) return;
        $(memberNode).attr("multi_drag_transform_bk", null);
      });
      $target.removeData("multiDragMembers");
    }
    var transformBk = $target.attr("transform_bk");
    var wasResize = $target.attr("resize_mode") === "true";
    var hasTable = $target.find("g.eatwithme-table").length > 0;
    var wasRoomNameDrag = $target.attr("room_name_drag") === "true";
    if (wasResize) {
      var shape = $target.find("rect, ellipse, path").first().get(0);
      var shapeTag = shape ? (shape.tagName || "").toLowerCase() : "";
      if (shapeTag !== "ellipse") {
        if (tableLayout.shouldRealignRectTableSeats($target)) {
          tableLayout.alignSeatsToClosestBorderHalfOutside($target);
        }
      }
      tableLayout.centerTableNumberAfterResize($target);

      var $roomNameText = $target.find("text.eatwithme-roomName").first();
      var $roomRect = $roomNameText.prev("rect").first();
      if ($roomNameText.length > 0 && $roomRect.length > 0) {
        try {
          var roomBox = $roomRect.get(0).getBoundingClientRect();
          var textBox = $roomNameText.get(0).getBoundingClientRect();
          var isOutside = textBox.x < roomBox.x || textBox.y < roomBox.y || (textBox.x + textBox.width) > (roomBox.x + roomBox.width) || (textBox.y + textBox.height) > (roomBox.y + roomBox.height);
          if (isOutside) {
            var parentNode = $roomNameText.get(0).parentNode;
            var svgRoot = parentNode && parentNode.ownerSVGElement;
            if (parentNode && parentNode.getScreenCTM && parentNode.getScreenCTM() && parentNode.getScreenCTM().inverse && svgRoot && svgRoot.createSVGPoint) {
              var parentInv = parentNode.getScreenCTM().inverse();
              var currentPoint = svgRoot.createSVGPoint();
              currentPoint.x = textBox.x + textBox.width / 2;
              currentPoint.y = textBox.y + textBox.height / 2;
              var desiredPoint = svgRoot.createSVGPoint();
              desiredPoint.x = roomBox.x + roomBox.width / 2;
              desiredPoint.y = roomBox.y + roomBox.height / 2;
              var currentCenter = currentPoint.matrixTransform(parentInv);
              var desiredCenter = desiredPoint.matrixTransform(parentInv);
              var deltaX = desiredCenter.x - currentCenter.x;
              var deltaY = desiredCenter.y - currentCenter.y;
              var baseTextTransform = $roomNameText.attr("transform") || "";
              var translateRegex = /translate\(\s*(-?[\d\.]+)(?:[\s,]+)(-?[\d\.]+)\s*\)/;
              if (translateRegex.test(baseTextTransform)) {
                $roomNameText.attr("transform", baseTextTransform.replace(translateRegex, function (_match, x, y) {
                  return "translate(" + (Number(x) + deltaX) + "," + (Number(y) + deltaY) + ")";
                }));
              } else if (baseTextTransform.length > 0) {
                $roomNameText.attr("transform", "translate(" + deltaX + "," + deltaY + ") " + baseTextTransform);
              } else {
                $roomNameText.attr("transform", "translate(" + deltaX + "," + deltaY + ")");
              }
            }
          }
        } catch (ex) {
        }
      }
    }
    if (wasRoomNameDrag) {
      var $roomNameText = $target.find("text.eatwithme-roomName").first();
      var $roomRect = $roomNameText.prev("rect").first();
      if ($roomNameText.length > 0 && $roomRect.length > 0) {
        try {
          var roomBox = $roomRect.get(0).getBoundingClientRect();
          var textBox = $roomNameText.get(0).getBoundingClientRect();
          var fallsOutside = textBox.x < roomBox.x || textBox.y < roomBox.y || (textBox.x + textBox.width) > (roomBox.x + roomBox.width) || (textBox.y + textBox.height) > (roomBox.y + roomBox.height);
          if (fallsOutside) {
            var roomNameTransformBk = $roomNameText.attr("room_name_transform_bk");
            if (roomNameTransformBk != null) {
              $roomNameText.attr("transform", roomNameTransformBk);
            }
          }
        } catch (ex) {
        }
      }
    }
    if (!wasResize && hasTable) {
      if (!tableLayout.keepLayoutLandscapeWithTable($target, { fallbackTransform: transformBk })) {
        tableLayout.showLandscapeConstraintMessage();
      }
    }
    $target.attr("top", null);
    $target.attr("left", null);
    $target.attr("transform_bk", null);
    $target.attr("resize_mode", null);
    $target.attr("resize_left", null);
    $target.attr("resize_right", null);
    $target.attr("resize_top", null);
    $target.attr("resize_bottom", null);
    $target.attr("room_drag_locked", null);
    $target.attr("room_name_drag", null);
    $target.attr("resize_translate_x_bk", null);
    $target.attr("resize_translate_y_bk", null);
    $target.find("text.eatwithme-roomName").attr("room_name_transform_bk", null);
    $target.find("g.eatwithme-seat").attr("resize_edge_bk", null);
    $target.find("g.eatwithme-seat").attr("resize_angle_bk", null);
    $target.css("top", "");
    $target.css("left", "");
    var $shapes = $target.find(".eatwithme-table rect, .eatwithme-table ellipse, .eatwithme-table path, .eatwithme-room rect");
    $shapes.attr("width_bk", null);
    $shapes.attr("height_bk", null);
    $shapes.attr("resize_inv_ctm_a_bk", null);
    $shapes.attr("resize_inv_ctm_b_bk", null);
    $shapes.attr("resize_inv_ctm_c_bk", null);
    $shapes.attr("resize_inv_ctm_d_bk", null);
    $shapes.attr("resize_angle_bk", null);
    var $shapeGroups = $target.find(".eatwithme-table path").parent();
    $shapeGroups.attr("resize_transform_bk", null);
    $shapeGroups.attr("resize_bbox_x_bk", null);
    $shapeGroups.attr("resize_bbox_y_bk", null);

    if (tableLayout.table_edit_mode && tableLayout.dragHelperTableId) {
      var helperTableId = tableLayout.dragHelperTableId;
      tableLayout.dragHelperTableId = null;
      setTimeout(function () {
        var $table = $('svg[visible="true"] g.eatwithme-table#' + helperTableId).first();
        if ($table.length === 0) {
          $table = tableLayout.resolveTableActionTrigger($target);
        }
        if ($table.length === 0) {
          $table = $('svg[visible="true"] g.eatwithme-table.selectable.selected').first();
        }
        if ($table.length > 0) {
          tableLayout.showTableActionButtons($table);
        }
      }, 120);
    } else {
      tableLayout.dragHelperTableId = null;
    }
  },

  centerTableNumberAfterResize: function ($tableContainer) {
    if (!$tableContainer || $tableContainer.length === 0) return;

    var tableNode = $tableContainer.find("g.eatwithme-table").first().get(0);
    if (!tableNode || !tableNode.getScreenCTM || !tableNode.getScreenCTM() || !tableNode.getScreenCTM().inverse) return;

    var shape = null;
    var $personPaths = $tableContainer.find(".eatwithme-table .person path");
    if ($personPaths.length >= 2) {
      // For person tables the second path is the body, so center the name there.
      shape = $personPaths.get(1);
    }
    if (!shape) {
      shape = $tableContainer.find(".eatwithme-table rect, .eatwithme-table ellipse, .eatwithme-table path").first().get(0);
    }
    if (!shape) return;

    var numberTextNode = $tableContainer.find("tspan.eatwithme-tableNumber").first().parent().get(0);
    if (!numberTextNode || !numberTextNode.getBBox || !numberTextNode.getScreenCTM || !numberTextNode.getScreenCTM()) return;

    var shapeBounds = tableLayout.getShapeBoundsInTableCoords($(tableNode), shape);
    if (!shapeBounds) return;

    var tableCTM = tableNode.getScreenCTM();
    var tableInv = tableCTM.inverse();
    var svgRoot = tableNode.ownerSVGElement;
    if (!svgRoot || !svgRoot.createSVGPoint) return;

    var makePoint = function (x, y) {
      var p = svgRoot.createSVGPoint();
      p.x = x;
      p.y = y;
      return p;
    };

    var transformPoint = function (matrix, x, y) {
      return makePoint(x, y).matrixTransform(matrix);
    };

    var toBounds = function (points) {
      var minX = Number.POSITIVE_INFINITY;
      var minY = Number.POSITIVE_INFINITY;
      var maxX = Number.NEGATIVE_INFINITY;
      var maxY = Number.NEGATIVE_INFINITY;
      points.forEach(function (pt) {
        minX = Math.min(minX, pt.x);
        minY = Math.min(minY, pt.y);
        maxX = Math.max(maxX, pt.x);
        maxY = Math.max(maxY, pt.y);
      });
      return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
      };
    };

    var textBBox = numberTextNode.getBBox();
    if (!textBBox) return;
    var textCTM = numberTextNode.getScreenCTM();

    var textCornersInTable = [
      transformPoint(tableInv.multiply(textCTM), textBBox.x, textBBox.y),
      transformPoint(tableInv.multiply(textCTM), textBBox.x + textBBox.width, textBBox.y),
      transformPoint(tableInv.multiply(textCTM), textBBox.x, textBBox.y + textBBox.height),
      transformPoint(tableInv.multiply(textCTM), textBBox.x + textBBox.width, textBBox.y + textBBox.height)
    ];
    var textBoundsInTable = toBounds(textCornersInTable);
    if (!Number.isFinite(textBoundsInTable.width) || !Number.isFinite(textBoundsInTable.height)) return;

    var currentCenterInTableX = textBoundsInTable.x + textBoundsInTable.width / 2;
    var currentCenterInTableY = textBoundsInTable.y + textBoundsInTable.height / 2;
    var targetCenterInTableX = Number(shapeBounds.x || 0) + Number(shapeBounds.width || 0) / 2;
    var targetCenterInTableY = Number(shapeBounds.y || 0) + Number(shapeBounds.height || 0) / 2;

    var currentCenterInScreen = transformPoint(tableCTM, currentCenterInTableX, currentCenterInTableY);
    var targetCenterInScreen = transformPoint(tableCTM, targetCenterInTableX, targetCenterInTableY);

    var parentNode = numberTextNode.parentNode;
    if (!parentNode || !parentNode.getScreenCTM || !parentNode.getScreenCTM() || !parentNode.getScreenCTM().inverse) return;
    var parentInv = parentNode.getScreenCTM().inverse();

    var currentCenterInParent = transformPoint(parentInv, currentCenterInScreen.x, currentCenterInScreen.y);
    var targetCenterInParent = transformPoint(parentInv, targetCenterInScreen.x, targetCenterInScreen.y);
    var moveDx = targetCenterInParent.x - currentCenterInParent.x;
    var moveDy = targetCenterInParent.y - currentCenterInParent.y;

    var $numberText = $(numberTextNode);
    var transform = $numberText.attr("transform") || "";
    // Apply centering translation before existing transforms so rotated labels
    // move in parent space and land correctly at table center.
    var nextTransform = "translate(" + moveDx + "," + moveDy + ")" + (transform ? " " + transform : "");
    $numberText.attr("transform", nextTransform);
  },

  realignTableVisuals: function ($target) {
    if (!$target || $target.length === 0) return;

    var $tableContainer = $target;
    if (!$tableContainer.hasClass("ui-draggable") || $tableContainer.find("g.eatwithme-table").length === 0) {
      $tableContainer = $target.closest("g.ui-draggable").filter(function () {
        return $(this).find("g.eatwithme-table").length > 0;
      }).first();
    }
    if (!$tableContainer || $tableContainer.length === 0) return;

    var shape = $tableContainer.find(".eatwithme-table rect, .eatwithme-table ellipse, .eatwithme-table path").first().get(0);
    if (shape) {
      var shapeTag = (shape.tagName || "").toLowerCase();
      if (shapeTag !== "ellipse") {
        if (tableLayout.shouldRealignRectTableSeats($tableContainer)) {
          tableLayout.alignSeatsToClosestBorderHalfOutside($tableContainer);
        }
      }
    }

    tableLayout.centerTableNumberAfterResize($tableContainer);

    if (tableLayout.table_edit_mode) {
      tableLayout.refreshEditModeResizeCorners($tableContainer);
    }
  },

  resize: () => {
    if (tableLayout.table_edit_mode) return;
    if (tableLayout.SVG == null) return;
    if (tableLayout.tables == null || typeof orderListUtil.allOrders == "undefined") return;
    if (typeof sessionStorage._editTable != "undefined" && typeof sessionStorage.tableNumberSelected != "undefined") return;
    if (tableLayout.dragging == true) return;

    if ($("#c svg").length < 1) return;
    if (tableLayout.SVG) {
      tableLayout.SVG.hide();
      tableLayout.SVG.parent().hide();
      if (tableLayout.rotatedSVG) {
        tableLayout.rotatedSVG.hide();
        tableLayout.rotatedSVG.parent().hide();
      }
      tableLayout.SVG = tableLayout.originalSVG;
      tableLayout.SVG.show();
      tableLayout.SVG.parent().show();
      tableLayout.tableOccupationsCache = {};

      Object.values(tableLayout.svgs).forEach(o => o.remove());
      tableLayout.svgs = {};
      tableLayout.width = null;
      tableLayout.height = null;
      delete tableLayout.div;
      tableLayout.renderSVG(tableLayout.getOrientation());
      tableLayout.updateTableOccupations();
    }
  },

  makeSVG: function (tag, attrs) {
    var el = document.createElementNS("http://www.w3.org/2000/svg", tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    return el;
  },

  makeSVG2: function (element) {
    var n = element.get(0).localName;
    if (n == undefined) return null;
    var el = document.createElementNS("http://www.w3.org/2000/svg", n);
    $(element.get(0).attributes).each(function (ind, p) {
      el.setAttribute(p.name, element.attr(p.name));
    });
    $(element.get(0).childNodes).each(function (ind, p) {
      var v = tableLayout.makeSVG2($(p));
      if (v != null) el.appendChild(v);
    });
    return el;
  },
  preUpdateTable: function (occupations, statistics) {

    const now = new Date().getTime();

    class Decorations {
      clazz = []
      attrs = {}
      pclazz = []
      ppclazz = []
      appended = []
      pAppended = []
      ppAppended = []
      rectAppended = []
      appendedItems = []
      mainClazz = []
      hash() {
        const hash = JSON.stringify([this.clazz, this.attrs, this.pclazz, this.ppclazz, this.appendedItems]);
        return hash;
      }
      addClass(clazz) {
        if (this.clazz.indexOf(clazz) === -1)
          this.clazz.push(clazz);
      }
      removeClass(clazz) {
        if (this.clazz.indexOf(clazz) !== -1)
          this.clazz.splice(clazz.indexOf(clazz), 1);
      }
      hasClass(clazz) {
        return this.clazz.indexOf(clazz) !== -1
      }
      attr(name, value) {
        this.attrs[name] = value;
      }
      pAddClass(clazz) {
        if (this.pclazz.indexOf(clazz) === -1)
          this.pclazz.push(clazz);
      }
      pRemoveClass(clazz) {
        if (this.pclazz.indexOf(clazz) !== -1)
          this.pclazz.splice(clazz.indexOf(clazz), 1);
      }
      ppAddClass(clazz) {
        if (this.ppclazz.indexOf(clazz) === -1)
          this.ppclazz.push(clazz);
      }
      ppRemoveClass(clazz) {
        if (this.ppclazz.indexOf(clazz) !== -1)
          this.ppclazz.splice(clazz.indexOf(clazz), 1);
      }
      addMainClass(clazz) {
        if (this.mainClazz.indexOf(clazz) === -1)
          this.mainClazz.push(clazz);
      }
      append(a) {
        this.appended.push(a);
        this.appendedItems.push(a);
      }
      pAppend(a) {
        this.pAppended.push(a);
        this.appendedItems.push(a);
      }
      ppAppend(a) {
        this.ppAppended.push(a);
        this.appendedItems.push(a.nodeName + "." + a.classList + "." + $(a).attr('href'));
      }
      rectAppend(a) {
        this.rectAppended.push(a);
      }
      appendItem(a) {
        this.appendedItems.push(a);
      }
      clear() {
        if (!this.table)
          return;

        this.clazz.forEach(clazz => {
          if (this.table.hasClass(clazz)) {
            this.table.removeClass(clazz);
          }
        })
        this.pclazz.forEach(clazz => {
          this.table.parent().removeClass(clazz);
        })
        this.ppclazz.forEach(clazz => {
          this.table.parent().parent().removeClass(clazz);
        })

        Object.keys(this.attrs).forEach(key => {
          this.table.removeAttr(key);
        })

        this.mainClazz.forEach(clazz => {
          $('#main').removeClass(clazz);
        })

        this.table.parent().parent().find('.svgadded').remove();

        if (tableLayout.showSeats) {
          var seats = table.parent().find(".eatwithme-seat");
          $(seats).removeClass("occupied");
        }
      }
      apply() {
        if (!this.table)
          return;
        this.clear();

        this.clazz.forEach(clazz => {
          this.table.addClass(clazz);
        })
        this.pclazz.forEach(clazz => {
          this.table.parent().addClass(clazz);
        })
        this.ppclazz.forEach(clazz => {
          this.table.parent().parent().addClass(clazz);
        })

        this.mainClazz.forEach(clazz => {
          $('#main').addClass(clazz);
        })

        this.appended.forEach(a => {
          this.table.append(a);
        })
        this.pAppended.forEach(a => {
          this.table.parent().append(a);
        })
        this.ppAppended.forEach(a => {
          this.table.parent().parent().append(a);
        })

        Object.keys(this.attrs).forEach(key => {
          this.table.attr(key, this.attrs[key]);
        })

        var rect = table.find("rect,path,ellipse");
        var rectParent = rect.parent();
        this.rectAppended.forEach(a => {
          rectParent.append(a);
        })

        if (tableLayout.showSeats) {
          var seats = table.parent().find(".eatwithme-seat");
          $(seats).removeClass("occupied");
          for (let i = 0; i < this.seatsOccupied; i++) {
            $(seats[i]).addClass("occupied");
          }
        }

      }
    }
    const decorations = new Decorations();

    var seatOccupationMap = new Map();
    var table = $('#c svg[visible="true"] g.eatwithme-table[id = "' + occupations[0].restaurantTable.number + '"]');

    var tableNumber = occupations[0].restaurantTable.number;
    if (table.length == 0) {
      return decorations;
    }

    decorations.addClass("occupied")

    decorations.table = table;

    var tableOccupationIds = "";
    var activeOccupationIds = new Set();
    var occupationsWithOrdersToAccept = new Set();
    var fullyDeliveredOccupations = new Set();

    var orientation = tableLayout.getOrientation();

    var tables = [];

    var waiterNeeded = false;
    var tableOccupation;
    var runningOccupations = 0;
    var booked = false;
    var bookedTableOccupation = null;
    const pickupNumber = auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"];
    const homeDeliveryNumber = auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"];

    const ordersByTable = orderListUtil.ordersCache && orderListUtil.ordersCache.reduce((obj, item) => {
      var key = item.tableNumber;
      if (!obj[key]) {
        obj[key] = [];
      }
      obj[key].push(item);
      return obj;
    }, {});

    var lockedShown = auth.myStatus.restaurant_settings["tables-overview"].lockTableOnEdit || true;

    const n = new Date().getTime();

    $(occupations).each(function (ind, restaurantTableOccupation) {
      if (!restaurantTableOccupation.active) {
        return;
      }
      var orders = getOrdersByTableNumber(restaurantTableOccupation.tableOccupationId, restaurantTableOccupation.restaurantTable.number);
      var activeOrders = orders.filter(order => order.recordState === "ACTIVE");
      if (orders.length > 0) {
        decorations.addClass("withOrders");
      } else {
      }
      var tableOccupation = getTableOccupation(restaurantTableOccupation.tableOccupationId);
      if (tableOccupation.occupationStart == null) {
        booked = true;
        if (bookedTableOccupation == null || Number(bookedTableOccupation.bookedOccupationStart) > Number(tableOccupation.bookedOccupationStart)) bookedTableOccupation = tableOccupation;
      } else {
        runningOccupations++;
        activeOccupationIds.add(tableOccupation.id);
        if (activeOrders.some(order => order.state === "ordered")) {
          occupationsWithOrdersToAccept.add(tableOccupation.id);
        } else if (activeOrders.length > 0 && activeOrders.every(order => order.state === "delivered" || order.state === "cancelled")) {
          fullyDeliveredOccupations.add(tableOccupation.id);
        }
      }
      var ttable = getTable(restaurantTableOccupation.restaurantTable.number);
      if (!ttable)
        return;
      if (tableLayout.showSeats) {
        if (!ttable.pos && tableOccupation.occupationStart != null && orders.length == 0 && restaurantTableOccupation.occupationStart) {
          if (new Date().getTime() - restaurantTableOccupation.occupationStart > 600000) {
            decorations.addClass("in-delay-90");
            decorations.removeClass("in-delay-50");
            decorations.removeClass("in-delay-75");
          } else if (new Date().getTime() - restaurantTableOccupation.occupationStart > 300000 && !table.hasClass("in-delay-90")) {
            decorations.addClass("in-delay-75");
            decorations.removeClass("in-delay-50");
          } else if (new Date().getTime() - restaurantTableOccupation.occupationStart > 120000 && !table.hasClass("in-delay-90") && !table.hasClass("in-delay-75")) {
            decorations.addClass("in-delay-50");
          }
        }
      }
      var amountToPay = getAmountsToPay(restaurantTableOccupation.tableMateIds);
      var amountPaid = getAmountsPaid(restaurantTableOccupation.tableMateIds);
      var $t = table.parent().parent();
      var nameshift = 0;

      /*
      if (auth.device.platform !== "browser" && auth.minspeed > 30)
        return;
        */

      const isPickup = Number(ttable.number) === pickupNumber;
      const isHomeDelivery = Number(ttable.number) === homeDeliveryNumber;

      var scale = table.data("scale");
      if (!scale) {
        var scaleX = 1;
        var scaleY = 1;
        var rotate = 0;
        while ($t.get(0).localName != "svg") {
          var transform = $t.attr("transform");
          var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec(transform);
          if (matches != null) {
            scaleX *= parseFloat(matches[1]);
            scaleY *= parseFloat(matches[2]);
          }
          var matches = /rotate\(-?([\d\.]+)\)/.exec(transform);
          if (matches != null) {
            rotate += parseFloat(matches[1]);
          }
          $t = $t.parent();
        }
        scale = Math.min(scaleX, scaleY);
        table.data("scale", scale)
      }
      var rect = table.data("bbox");
      if (!rect) {
        rect = table.parent().parent().get(0).getBBox();
        table.data("bbox", rect);
      }

      var r1 = $(table).data("br");
      if (!r1) {
        r1 = $(table).get(0).getBoundingClientRect();
        $(table).data("br", r1);
      }


      if (!ttable.pos && !isPickup && !isHomeDelivery) {
        if (amountToPay == 0 && amountPaid > 0) {
          // ### fully paid ###
          decorations.addClass("paid");
          decorations.ppAddClass("paid");

          var fontsize = Math.max(20, Math.min(r1.width, r1.height) / 4 / scale);
          nameshift = fontsize / 4 + fontsize / 6;

          var text = tableLayout.makeSVG("text", {
            class: "svgadded",
            style: "filter: url(#shadow)",
            transform: "translate(" + -(Number(rect.width / 2 + nameshift)) + ", " + -(Number(rect.height / 2 + nameshift)) + ") rotate(-45)",
            "font-size": fontsize,
            "text-anchor": "middle",
            x: 0,
            y: 0
          });
          var tspan = tableLayout.makeSVG("tspan", { class: "svgadded", "alignment-baseline": "central", fill: "gray", stroke: "red", "stroke-width": 0.8, opacity: 0.8 });
          decorations.ppAppend(text);
          $(text).append(tspan);
          $(tspan).html(I18n.t("admin_local.paid"));
          var text = tableLayout.makeSVG("text", {
            class: "svgadded",
            transform: "translate(" + -(Number(rect.width / 2 + nameshift)) + ", " + -(Number(rect.height) / 2 + nameshift) + ") rotate(-45)",
            "font-size": fontsize,
            "text-anchor": "middle",
            x: 0,
            y: 0
          });
          var tspan = tableLayout.makeSVG("tspan", { class: "svgadded", "alignment-baseline": "central", fill: "yellow", stroke: "red", "stroke-width": 0.0, opacity: 0.8 });
          if (text) {
            decorations.ppAppend(text);
            $(text).append(tspan);
          }
          nameshift = 0;
          $(tspan).html(I18n.t("admin_local.paid"));
        } else if (amountToPay !== 0) {
          decorations.addClass("unpaid");
          restaurantTableOccupation.tableMateIds.forEach(function (id) {
            var tableMate = getTableMate(id);
            if (!tableMate) {
            } else if (getStateIndex(tableMate, "wantsToPay") >= 0) {
              decorations.addClass("wantsToPay");
            } else if (getStateIndex(tableMate, "paymentRequest") >= 0) {
              if (decorations.hasClass("paymentRequests")) {
              } else if (decorations.hasClass("paymentRequest")) {
                decorations.removeClass("paymentRequests");
                decorations.addClass("paymentRequests");
              } else {
                decorations.addClass("paymentRequest");
                decorations.attr("paymentMethod", tableMate.states[getStateIndex(tableMate, "paymentRequest")].reference);
              }
            }
            if (tableMate && getStateIndex(tableMate, "payingOnline") >= 0) {
              decorations.addClass("payingOnline");
            }
          });
        }

        // console.log(restaurantTableOccupation.restaurantTable.number, restaurantTableOccupation);
        if (lockedShown && restaurantTableOccupation.editedBy) {
          //console.log(restaurantTableOccupation.editedBy);
          decorations.addClass("lockedForEdit");
        }

      }


      try {
        if (((tableOccupation.leadCustomerId && getTableMate(tableOccupation.leadCustomerId) && getTableMate(tableOccupation.leadCustomerId).name) || (tableOccupation.tableMates.length > 0 && tableOccupation.tableMates[0].name)) && !isPickup && !isHomeDelivery) {

          if (orderListUtil.tableOccupations && orderListUtil.tableOccupations.filter(t => t.restaurantTables.filter(t => t.restaurantTable && t.restaurantTable.number === ttable.number).length > 0).length === 1) {

            const name = tableOccupation.tableMates.filter(t => t.tableNumber === ttable.number)[0]?.name || (tableOccupation.leadCustomerId && getTableMate(tableOccupation.leadCustomerId)?.name) || "";

            var fontsize = Math.min(r1.width, r1.height) / 4 / scale;
            fontsize = Math.max(20, fontsize / Math.max(1, (name.length / 13)));

            var text = tableLayout.makeSVG("text", {
              class: "svgadded ",
              style: "filter: url(#shadow)",
              transform: "translate(" + - (Number(rect.width / 2 - +nameshift)) + ", " + -(Number(rect.height / 2 + nameshift)) + ") rotate(-45)",
              "font-size": fontsize,
              "text-anchor": "middle",
              x: 0,
              y: 0
            });
            var tspan = tableLayout.makeSVG("tspan", { class: "svgadded", "alignment-baseline": "central", fill: "gray", stroke: "red", "stroke-width": 0.8, opacity: 0.8 });
            const $tspan = $(tspan);
            $(text).append(tspan);
            $tspan.html(name);
            decorations.ppAppend(text);
            var text = tableLayout.makeSVG("text", {
              class: "svgadded",
              transform: "translate(" + -(Number(rect.width / 2 - + nameshift)) + ", " + -(Number(rect.height / 2 + nameshift)) + ") rotate(-45)",
              "font-size": fontsize,
              "text-anchor": "middle",
              x: 0,
              y: 0
            });
            var tspan = tableLayout.makeSVG("tspan", { class: "svgadded", "alignment-baseline": "central", fill: tableOccupation.connected ? tableOccupation.customerOrdered ? "blue" : "gray" : "yellow", stroke: "red", "stroke-width": 0.1, opacity: 0.8 });
            if (text) {
              decorations.ppAppend(text);
              $(text).append(tspan);
            }
            $(tspan).html(name);
            $(tspan).click(tableLayout.tableClickHandler);
          }
        }
      } catch (ex) {
        console.error(ex, ex);
      }

      if (!tableLayout.showSeats)
        return;

      if (tableOccupation.occupationStart != null)
        restaurantTableOccupation.tableMateIds.forEach(function (id) {
          var tableMate = getTableMate(id);
          if (tableMate && tableMate.tableMate && tableMate.active == true) {
            decorations.addClass("customer-managed");
          }
        });

      if (restaurantTableOccupation.waiterNeeded) waiterNeeded = restaurantTableOccupation.waiterNeeded;

      tableOccupationIds += tableOccupation.id + ",";
      //var tableNumberElement = $("#" + restaurantTableOccupation.restaurantTable.number + ".eatwithme-tableNumber");
      var t = seatOccupationMap.get(restaurantTableOccupation.restaurantTable.number);
      if (t == null) {
        t = {
          seatCount: restaurantTableOccupation.tableMateIds.length
        };
      } else {
        t.seatCount = t.seatCount + restaurantTableOccupation.tableMateIds.length;
      }
      t.states = {};
      var first = true;
      const ordersByOneTable = ordersByTable && ordersByTable[restaurantTableOccupation.restaurantTable.number];
      if (orderListUtil.ordersCache && ordersByOneTable) {
        for (let i = 0; i < ordersByOneTable.length; i++) {
          const oo = ordersByOneTable[i];

          if (oo.state !== "selected") {
            t.states[oo.state] = (t.states[oo.state] || 0) + 1;
          } else {
            if (!isHomeDelivery && !isPickup) {
              if (oo.orderedByCustomer) {
                t.states["customer_selected"] = 1;
              } else {
                t.states["selected"] = 1;
              }
            } else {
              const key = oo.orderedByCustomer ? "customer_selected" : "selected";
              t.states[key] = (t.states[key] || 0) + 1;
            }
          }
        }
      }

      if (tableLayout.showSeats)
        if (orderListUtil.allOrders && orderListUtil.allOrders.tables)
          orderListUtil.allOrders.tables.forEach(function (tt) {
            if (tt.tableNumber == restaurantTableOccupation.restaurantTable.number) {

              const multiLock = orderListUtil.allOrders.tables.find(t => t.tableNumber == restaurantTableOccupation.restaurantTable.number && t.tableOccupation != tt.tableOccupation);

              tables.push(tt);
              if (!multiLock) {
                if (tt.notDelivered) {
                  decorations.addClass("notDelivered");
                  decorations.addClass("timing_" + tt.timing);
                }
                if (tt.asapNotDelivered) {
                  decorations.addClass("asapNotDelivered");
                }

                //var $tt = table.find("rect,path,ellipse");
                var $t = table.find("rect,path,ellipse").parent();
                var rect = $t.data("bbox");
                if (!rect) {
                  rect = $t.get(0).getBBox();
                  $t.data("bbox", rect);
                }
                var rectWidth = rect.width;
                var rectHeight = rect.height;
                if (rectWidth === 0 || rect.height === 0)
                  return;
                var low = (4 - alltimings.indexOf(tt.timing)) / 5;

                var rotate = 0;
                while ($t.get(0).localName != "svg") {
                  var transform = $t.attr("transform");
                  var regexp = /rotate\((-?[\d\.]+)\)/g;
                  var matches;
                  while ((matches = regexp.exec(transform))) {
                    rotate += parseFloat(matches[1]);
                  }
                  $t = $t.parent();
                }

                if (orientation == "portrait") rotate += 90;

                if (!ttable.pos && !isHomeDelivery && !isPickup) {
                  var finished = (tt.timing == "asap" && !tt.asapNotDelivered) || (tt.timing != "asap" && !tt.notDelivered);
                  var rect2;
                  if (rotate == -90) {
                    rectHeight -= 4;
                    if (!finished) rect2 = tableLayout.makeSVG("rect", { class: "svgadded course unfinished " + tt.timing, x: 2, width: 15, y: 2 + rectHeight * (1 - low - 0.2), height: rectHeight * 0.2 });
                    else rect2 = tableLayout.makeSVG("rect", { class: "svgadded course finished " + tt.timing, x: 2, width: 8, y: 2 + rectHeight * (1 - low - 0.2), height: rectHeight * 0.2 });
                  } else if (rotate == 90) {
                    rectHeight -= 4;
                    if (!finished) rect2 = tableLayout.makeSVG("rect", { class: "svgadded course unfinished " + tt.timing, x: rectWidth - 17, width: 15, y: 2 + rectHeight * low, height: rectHeight * 0.2 });
                    else rect2 = tableLayout.makeSVG("rect", { class: "svgadded course finished " + tt.timing, x: rectWidth - 10, width: 8, y: 2 + rectHeight * low, height: rectHeight * 0.2 });
                  } else if (rotate == 0) {
                    rectWidth -= 4;
                    if (!finished) rect2 = tableLayout.makeSVG("rect", { class: "svgadded course unfinished " + tt.timing, y: rectHeight - 17, height: 15, x: 2 + rectWidth * (1 - low - 0.2), width: rectWidth * 0.2 });
                    else rect2 = tableLayout.makeSVG("rect", { class: "svgadded course finished " + tt.timing, y: rectHeight - 10, height: 8, x: 2 + rectWidth * (1 - low - 0.2), width: rectWidth * 0.2 });
                  } else if (rotate == -180 || rotate == 180) {
                    rectWidth -= 4;
                    if (!finished) rect2 = tableLayout.makeSVG("rect", { class: "svgadded course unfinished " + tt.timing, y: 2, height: 15, x: 2 + rectWidth * low, width: rectWidth * 0.2 });
                    else rect2 = tableLayout.makeSVG("rect", { class: "svgadded course finished " + tt.timing, y: 2, height: 8, x: 2 + rectWidth * low, width: rectWidth * 0.2 });
                  }
                  decorations.rectAppend(rect2);
                }


                if (tableLayout.showSeats) {
                  decorations.addClass("max_timing_" + tt.max_timing);
                  //var acceptedItemsWaitingForDelivery = tt.notDelivered ? (new Date().getTime() - tt.inActiveStateTimeStamp) / 1000 : 0;
                  var acceptedItemsWaitingForDelivery = tt.notDelivered ? tt.inStateDurations.active_delivering : 0;
                  var orderedItemsWaitingForAcceptance = tt.inStateDurations.active_accepting ? tt.inStateDurations.active_accepting : 0;
                  var orderedItemsWaitingForAcceptance2 = tt.inStateDurations.selected ? tt.inStateDurations.selected : 0;
                  if (acceptedItemsWaitingForDelivery + orderedItemsWaitingForAcceptance > 0) {
                    var deliveryDelay = acceptedItemsWaitingForDelivery == 0 ? 0 : acceptedItemsWaitingForDelivery / Math.max(20 * 60, statistics.acceptedItemsWaitingForDeliveryAll);
                    var acceptanceDelay = orderedItemsWaitingForAcceptance == 0 ? 0 : orderedItemsWaitingForAcceptance / Math.max(5 * 60, statistics.orderedItemsWaitingForAcceptanceAll);
                    var delay = Math.max(acceptanceDelay, deliveryDelay);
                    if (delay > 0.9) {
                      decorations.removeClass("in-delay-50");
                      decorations.removeClass("in-delay-75");
                      decorations.addClass("in-delay-90");
                    } else if (delay > 0.7 && !table.hasClass("in-delay-90")) {
                      decorations.addClass("in-delay-75");
                      decorations.removeClass("in-delay-50");
                    } else if (delay > 0.5 && !table.hasClass("in-delay-90") && !table.hasClass("in-delay-75")) {
                      decorations.addClass("in-delay-50");
                    }
                    first = false;
                  }
                }

              }
              t.states["unprinted"] = (t.states["unprinted"] ? t.states["unprinted"] : 0) + tt.unprinted;
              t.states["partprinted"] = (t.states["partprinted"] ? t.states["partprinted"] : 0) + tt.partprinted;
              t.states["beingprinted"] = (t.states["beingprinted"] ? t.states["beingprinted"] : 0) + tt.beingprinted;
              t.states["printFailed"] = (t.states["printFailed"] ? t.states["printFailed"] : 0) + tt.printFailed;
              /*
               * Object.keys(tt.stateMap).forEach(function(key,index) {
               * t.states[key] = (t.states[key] ? t.states[key] : 0) +
               * tt.stateMap[key].length; });
               */
            }
          });
      //if (tableLayout.showSeats) {
      seatOccupationMap.set(restaurantTableOccupation.restaurantTable.number, t);
      //}
    });

    //console.log((new Date().getTime() - n) + "ms for " + occupations.length + " tables");

    if (runningOccupations == 0 && booked) {
      decorations.addClass("booked");
    } else if (runningOccupations > 1) {
      decorations.addClass("multiple-occupation");
    }

    var producingShown = auth.myStatus.restaurant_settings["tables-overview"]["statesShown"].indexOf("producing") >= 0;
    var deliveringShown = auth.myStatus.restaurant_settings["tables-overview"]["statesShown"].indexOf("delivering") + auth.myStatus.restaurant_settings["tables-overview"]["statesShown"].indexOf("ready") >= 0;
    var lockedShown = auth.myStatus.restaurant_settings["tables-overview"].lockTableOnEdit || true;

    decorations.attr("tableOccupations", tableOccupationIds);
    seatOccupationMap.forEach(function (entry, key) {

      const isTakeaway = auth.myStatus.restaurant_settings["enabled-features"].pickup && auth.myStatus.restaurant_settings["enabled-features"].homedelivery && (key === auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"] || key === auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"])

      if (tableLayout.showSeats) {
        var seats = table.parent().find(".eatwithme-seat");
        decorations.seatsOccupied = Math.min(entry.seatCount, seats.length);
      }

      var tableCount = table.length;
      var $t = table;
      var rect = $t.data("bbox");
      if (rect == null) {
        console.log(table.parent().parent());
        rect = $t.parent().parent().get(0).getBBox();
        $t.data("bbox", rect);
      }
      var scaleX = 1;
      var scaleY = 1;
      var rotate = 0;
      while ($t.get(0).localName != "svg") {
        var transform = $t.attr("transform");
        var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec(transform);
        if (matches != null) {
          scaleX *= parseFloat(matches[1]);
          scaleY *= parseFloat(matches[2]);
        }
        var matches = /rotate\(-?([\d\.]+)\)/.exec(transform);
        if (matches != null) {
          rotate += parseFloat(matches[1]);
        }
        $t = $t.parent();
      }
      var scale = Math.min(scaleX, scaleY);

      var r1 = $(table).data("br");
      if (!r1) {
        r1 = $(table).get(0).getBoundingClientRect();
        $(table).data("br", r1);
      }

      var init_icon_size = Math.min(25, Math.min(r1.width, r1.height) / 3 / scale);

      var delivering = false;
      if (Number(tableCount) > 0) {
        Object.keys(entry.states).forEach(function (key, index) {
          //if (delivering == true) return;

          const icons = [];


          var icon_size = init_icon_size;

          var x = 0, y = 0;
          var img = null;
          var img2 = null;
          var transform = null;
          var imgclass = "";
          var imgclass2 = "";
          //console.log("customer_selected", entry.states[key])
          if (!isTakeaway && key == "customer_selected" && entry.states[key] > 0) {
            decorations.addClass("new-customer-selections");
          }
          if (key == "selected" && entry.states[key] > 0) {
            decorations.addClass("new-selections");
          }
          if (!isTakeaway && key == "ordered" && entry.states[key] > 0) {
            // ###  NEW CUSTOMER ORDERS ###
            icon_size = Math.min(rect.width, rect.height) / 4;
            //icon_size = (Math.min(rect.width, rect.height) / scale) * .5;
            x = +rect.width / 2 - icon_size * 3 / 4 * scale;
            y = +rect.height / 2 - icon_size * 3 / 4 * scale;
            img = "img/neworder.svg";
            delivering = true;
            imgclass = " unprinted ";
          } else if (key == "accepted" && entry.states[key] > 0) {
            icon_size = Math.min(rect.width, rect.height) / 4;
            //init_icon_size = Math.min(25, Math.min(r1.width, r1.height) );
            x = -icon_size / 2 * scale + rect.width / 2;
            y = -icon_size / 2 * scale - rect.height / 2;
            transform = "";
            scale = 1;
            if (entry.states.printFailed > 0) {
              img = "img/thermal-printer-red.png";
              //decorations.addClass("flash");
              decorations.addMainClass("warning");
              imgclass = " printfailed blink2 ";
              scale = 1;
            } else if (entry.states.partprinted > 0) {
              img = "img/thermal-printer-yellow.png";
              imgclass = " blink ";
              scale = 1;
              decorations.addClass("flash");
              decorations.addMainClass("warning");
              img2 = "img/cogwheel.png";
              imgclass2 = " cogwheel ";
            } else if (entry.states.beingprinted > 0) {
              img = "img/thermal-printer.png";
              imgclass = " printing ";
              img2 = "img/cogwheel.png";
              imgclass2 = " cogwheel ";
            } else if (entry.states.unprinted) {
              img = "img/thermal-unprinted.png";
              imgclass = " unprinted ";
            } else if (!isTakeaway) {
              img = "img/printed.png";
              imgclass = " printed ";
            }
          } else if (decorations.hasClass("paymentRequest")) {
            icon_size = (Math.min(rect.width, rect.height) / scale) * 1.2;
            x = (-icon_size / 2) * scale;
            y = (-icon_size / 2) * scale;
            img = "img/payment-request.png";
            delivering = true;
            imgclass = " payment-request";
          }
          if (img || imgclass) {
            icons.push({ img, icon_size, x, y, imgclass, img2, imgclass2 })
          }
          //icon_size = init_icon_size;
          x = 0; y = 0; img = null; img2 = null; transform = null; imgclass = ""; imgclass2 = "";

          if (!isTakeaway && deliveringShown && (key == "delivering" || key == "ready") && entry.states[key] > 0) {
            icon_size = Math.min(rect.width / scale, 1.6 * rect.height / scale);
            tables.forEach(tab => {
              if (((!deliveringShown && tab.stateMap["accepted"] == 0) || (deliveringShown && tab.stateMap["producing"] == 0)) && tab.stateMap["delivering"].length + tab.stateMap["ready"].length > 0) {
                //var r1 = $(table).parent().get(0).getBBox();
                //icon_size = Math.min(130000 * scale, Math.min(rect.width * scale, rect.height * scale));
                //icon_size=Math.min(rect.width,rect.height)/scale*1.2;
                x = (-icon_size / 2) * scale;
                y = (-icon_size / 2) * scale;
                img = "img/man-tie-bow-icon.svg";
                delivering = true;
              }
            });
          } else if (!isTakeaway && producingShown && key == "producing" && entry.states[key] > 0) {
            x = -rect.width / 2;
            y = -16 + rect.height / 2;
            img = "img/chefhat.png";
          }
          if (img || imgclass) {
            icons.push({ img, icon_size, x, y, imgclass, img2, imgclass2 })
          }
          icons.forEach(({ img, icon_size, x, y, imgclass, img2, imgclass2 }) => {
            const orientation = tableLayout.getOrientation();
            var image = tableLayout.makeSVG("image", {
              class: "svgadded " + key + imgclass,
              x: x,
              y: y,
              width: icon_size * scale,
              height: icon_size * scale,
              viewbox: "0 0 " + 32 * scale + " " + 32 * scale,
              href: img,
              transform: orientation === "portrait" ? ("rotate(-90," + (x + 16 * scale) + "," + (y + 16 * scale) + ")") : ""
            });
            decorations.ppAppend(image);
            var tooltip = tableLayout.makeSVG("title", {
            });
            image.append(tooltip);
            $(tooltip).html(I18n.t("admin_local.tablesoverview.tooltip." + imgclass.trim().split(" ")[0]));
            decorations.addClass(key);
            if (img2 != null) {
              var g2 = tableLayout.makeSVG("g", {
                class: "svgadded ",
                viewbox: -32 * scale + " " + -32 * scale + 32 * scale + " " + 32 * scale,
                transform: (orientation === "portrait" ? ("rotate(-90," + (x + 16 * scale) + "," + (y + 16 * scale) + ")") : "") + ("translate(" + (x + 16 * scale + icon_size * scale * .5 * .5) + "," + (y + 16 * scale + icon_size * scale * .5 * .5) + ")")
              });
              var image2 = tableLayout.makeSVG("image", {
                class: "svgadded " + key + imgclass2,
                x: -icon_size * scale * .5 * .7,
                y: -icon_size * scale * .5 * .7,
                width: icon_size * scale * .7,
                height: icon_size * scale * .7,
                viewbox: -32 * scale + " " + -32 * scale + 32 * scale + " " + 32 * scale,
                href: img2
              });
              decorations.ppAppend(g2);
              g2.append(image2);
              var tooltip = tableLayout.makeSVG("title", {
              });
              image.append(tooltip);
              $(tooltip).html(I18n.t("admin_local.tablesoverview.tooltip." + imgclass2.trim().split(" ")[0]));

              //decorations.addClass(key);
            }
          });
        });
        if (waiterNeeded) {
          var g = tableLayout.makeSVG("g", { class: "svgadded", x: -rect.width / 2, y: -rect.height / 2, width: 32, height: 32 });
          var image = tableLayout.makeSVG("image", { class: "svgadded waiterCalled", tableNumber: tableNumber, tableOccupation: tableOccupationIds, x: -16, y: 0, width: 32, height: 32, href: "img/bell.svg" });
          g.append(image);
          decorations.ppAppend(g);
          decorations.addClass("waiterCalled");
          var tooltip = tableLayout.makeSVG("title", {
          });
          image.append(tooltip);
          $(tooltip).html(I18n.t("admin_local.tablesoverview.tooltip.waiterCalled"));

          // table.addClass('waiterCalled');
        }

        if (isTakeaway && activeOccupationIds.size > 0) {
          var badgeRadius = Math.max(11, Math.min(rect.width, rect.height) / 8);
          var badgeGap = Math.max(4, badgeRadius * 0.35);
          var badgeBaseCx = rect.width / 2 - badgeRadius * 0.7;
          var badgeCy = rect.height / 2 - badgeRadius * 0.7;
          var occupationsToAccept = occupationsWithOrdersToAccept.size;
          var deliveredOccupations = fullyDeliveredOccupations.size;
          var remainingOccupations = Math.max(0, activeOccupationIds.size - occupationsToAccept - deliveredOccupations);
          var badgeStep = badgeRadius * 2 + badgeGap;
          var acceptBadgeClass = occupationsToAccept > 0 ? "table-occupation-count-badge--accept blink" : "table-occupation-count-badge--accept";

          var appendBadge = function (cx, fillColor, textValue, extraClass) {
            var badge = tableLayout.makeSVG("circle", {
              class: "svgadded table-occupation-count-badge " + extraClass,
              cx: cx,
              cy: badgeCy,
              r: badgeRadius,
              fill: fillColor,
              stroke: "#ffffff",
              "stroke-width": Math.max(1.5, badgeRadius * 0.18)
            });
            decorations.ppAppend(badge);

            var badgeText = tableLayout.makeSVG("text", {
              class: "svgadded table-occupation-count-label " + extraClass,
              x: cx,
              y: badgeCy,
              fill: "#ffffff",
              "font-size": Math.max(12, badgeRadius),
              "font-weight": "700",
              "text-anchor": "middle",
              "alignment-baseline": "central",
              style: "pointer-events:none"
            });
            $(badgeText).html(String(textValue));
            decorations.ppAppend(badgeText);
          };

          appendBadge(badgeBaseCx - badgeStep * 2, "#d7263d", occupationsToAccept, acceptBadgeClass);
          appendBadge(badgeBaseCx - badgeStep, "#5c677d", remainingOccupations, "table-occupation-count-badge--other");
          appendBadge(badgeBaseCx, "#2a9d8f", deliveredOccupations, "table-occupation-count-badge--delivered");
        }
      }

      if (booked && bookedTableOccupation.occupationStart == null) {
        var clazz = "";
        if (runningOccupations > 0) {
          var d = (bookedTableOccupation.bookedOccupationStart - new Date().getTime()) / 60000;
          if (d < 5) {
            clazz = " in-delay-90";
          } else if (d < 10) {
            clazz = " in-delay-75";
          } else if (d < 15) {
            clazz = " in-delay-50";
          }
        }
        var orientation = tableLayout.getOrientation();
        var textg = tableLayout.makeSVG("g", {
          class: "svgadded draggable booking-time"
        });
        var text = tableLayout.makeSVG("text", {
          class: clazz + " booking-time",
          stroke: "white",
          "stroke-width": 0.6,
          "font-size": 18,
          "text-anchor": "middle",
          transform: orientation === "portrait" ? "rotate(-90)" : "",
          fill: "darkblue",
          x: 0,
          y: -rect.height / 2 - 2
        });
        var seatsText = "";
        var bookedProperties = bookedTableOccupation.bookedProperties;
        if (bookedProperties.seats)
          Object.keys(bookedProperties.seats).forEach(tableN => {
            if (tableN == tableNumber) {
              var table = getTable(tableNumber);
              if (table.seats != bookedProperties.seats[tableN]) {
                seatsText = " (" + bookedProperties.seats[tableN] + ")";
              }
            }
          });
        var seats = $(text).html(moment(bookedTableOccupation.bookedOccupationStart).format("HH:mm") + seatsText);
        decorations.ppAppend(textg);
        textg.append(text);

        var svg = $('svg[visible = "true"]');
        svg.find("g.eatwithme-table").parent().parent().droppable({
          over: (event, ui) => {
            console.log("Created");
          },
          drop: function (event, ui) {
            console.log("OOKOK")
          }
        });

        $(textg).draggable({
          scroll: true,
          delay: 30,
          revert: function () {
            return true;
          },
          stack: 'eatwithme-table',
          start: function (event, ui) {
            tableLayout.dragging = true;

            var $target = $(event.target);
            tableLayout.oldTable = $target.parent().find(".eatwithme-table").attr("id");
            const target = this;
            $target.attr("transform_bk", $target.attr("transform"));
            /*
            var svg = $('svg[visible = "true"]');
            event.stopPropagation();
            svg.find("g.eatwithme-table").parent().parent().each((ind, t) => $(t).droppable({
              tolerance: "touch",
              greedy: true,
              accept: () => {
                return true;
              },
              over: (event, ui) => {
                console.log("Created");
              },
              drop: function (event, ui) {
                console.log("OOKOK")
                tableLayout.dragging = false;
                var tableSelected = $(event.target).find("g.eatwithme-table");
                var $target = $(ui.draggable);
        
                if (tableSelected.length == 1) {
                  var newTable = tableSelected.attr("id");
                  if (isNaN(newTable)) return;
                  if (tableLayout.oldTable === newTable)
                    return;
                  TableReservationComponent.updateBookingTable(bookedTableOccupation.id, tableLayout.oldTable, newTable);
                }
              }
            }));
            */
          },
          drag: function (trigger, ui) {
            var svg = $('svg[visible = "true"]');
            var viewport = svg.get(0).viewBox.baseVal;
            var zoom = tableLayout.getOrientation() === "landscape" ? 1 : tableLayout.z;
            var scaleX = svg.width() / viewport.width;
            var scaleY = svg.height() / viewport.height;
            var rotate = 0;
            var $target = $(trigger.target);
            var $t = $target;
            while ($t.get(0).localName != "svg") {
              var transform = $t.attr("transform");
              var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec(transform);
              if (matches != null) {
                scaleX *= parseFloat(matches[1]);
                scaleY *= parseFloat(matches[2]);
              }
              var matches = /rotate\((-?[\d\.]+)\)/.exec(transform);
              if (matches != null) {
                rotate += parseFloat(matches[1]);
              }
              $t = $t.parent();
            }
            var left = parseFloat(ui.position.left);
            var top = parseFloat(ui.position.top);
            var original_left = parseFloat($target.attr("left"));
            var original_top = parseFloat($target.attr("top"));
            var original_transform = $target.attr("transform_bk");
            var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(original_transform);
            if (matches == null) matches = [0, 0, 0];
            var shiftX = left - ui.originalPosition.left;
            var shiftY = top - ui.originalPosition.top - $target.get(0).getBBox().height;

            var angle = rotate * (Math.PI / 180); // Convert to radians

            var rotatedX = Math.cos(angle) * shiftX - Math.sin(angle) * shiftY;
            var rotatedY = Math.sin(angle) * shiftX + Math.cos(angle) * shiftY;

            if (tableLayout.getOrientation() !== "landscape") {
              var r = rotatedY;
              rotatedY = -rotatedX;
              rotatedX = r;
            }

            var scale = 1;
            const variant = svg.parent().parent().parent().attr("variant");
            if (variant == 2) {
              scale = scaleX;
            } else if (variant == 1) {
              scale = scaleY;
            }

            //move
            var new_left = rotatedX / zoom / scale + parseFloat(matches[1]);
            var new_top = rotatedY / zoom / scale + parseFloat(matches[2]);
            var new_transform;
            if (original_transform != null) {
              if (original_transform.indexOf("translate") !== -1) new_transform = original_transform.replace(/translate\((-?[\d\.]+),(-?[\d\.]+)\)/, "translate(" + new_left + "," + new_top + ")");
              else new_transform = " translate(" + new_left + "," + new_top + ") " + original_transform;
            } else new_transform = "translate(" + new_left + "," + new_top + ")";
            tableLayout.tableSelected = $('svg[visible = "true"] g.eatwithme-table:hover');
            $target.attr("transform", new_transform);
            $target.css("top", "");
            $target.css("left", "");
          },
          stop: function (event, ui) {
            tableLayout.dragging = false;
            var $target = $(event.target);
            if ($target.attr("transform_bk") != null) $target.attr("transform", $target.attr("transform_bk"));
            else $target.attr("transform", null);
            $target.attr("transform_bk", null);

            var left = parseFloat(ui.position.left);
            var top = parseFloat(ui.position.top);

            //var tableSelected = $(document.elementFromPoint(left, top)).parents(".eatwithme-table");
            if (tableLayout.tableSelected && tableLayout.tableSelected.length == 1) {
              var newTable = tableLayout.tableSelected.attr("id");
              if (isNaN(newTable)) return;
              if (tableLayout.oldTable === newTable)
                return;
              TableReservationComponent.updateBookingTable(bookedTableOccupation.id, tableLayout.oldTable, newTable);
            }

            //var svg = $('svg[visible = "true"]');
            //svg.find(".eatwithme-table").parent().parent().droppable("destroy");
          }
        });
      }
    });
    return decorations;
  },

  tableOccupationsCache: {},
  tableDecorationCache: {},
  updateTableOccupations: function () {
    if (tableLayout.table_edit_mode) return;
    if (tableLayout.SVG == null) return;
    if (tableLayout.tables == null || typeof orderListUtil.allOrders == "undefined") return;
    if (typeof sessionStorage._editTable != "undefined" && typeof sessionStorage.tableNumberSelected != "undefined") return;
    if (tableLayout.dragging == true) return;

    var orientation = tableLayout.getOrientation();

    var svg = orientation == "landscape" ? $(tableLayout.SVG) : $(tableLayout.rotatedSVG);

    /*
    if (!tableLayout.showSeats)
      svg.find("g.eatwithme-seat").remove();
      */


    //$('#c svg g.eatwithme-table[id]').each((ind, e) => e.id = Number(e.id));

    //tableLayout.clearAnnotations();

    if (!tableLayout.$tables) {
      tableLayout.$tables = svg.find("g.eatwithme-table");
    }
    var tables = tableLayout.$tables;
    tables.each(function (ind, table) {
      table = $(table);
      var tableNumber = table.attr("id");
      var t = getTable(tableNumber);
      if (t != null) {
        if (t.shareable) table.addClass("shareable");
        if (t.visibleOnline) table.addClass("visibleOnline");
        if (t.bookOnline) table.addClass("bookOnline");
        if (t.pos) table.addClass("pos")
        const isPickup = Number(t.number) === auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"];
        const isHomeDelivery = Number(t.number) === auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"];
        if (isPickup) table.addClass("pickup");
        if (isHomeDelivery) table.addClass("homedelivery");
      }
    });

    var producingShown = auth.myStatus.restaurant_settings["tables-overview"]["statesShown"].indexOf("producing") >= 0;

    $(".delivering-tasks").empty();
    $(".ordered-tasks").empty();

    var tableSetDelivering = new SortedMap([], (a, b) => (a.inStateTimeStamp["ready"] || a.inStateTimeStamp["delivering"]) - (b.inStateTimeStamp["ready"] || b.inStateTimeStamp["delivering"]));

    var tableSetOrdered = new SortedMap([], (a, b) => a.inStateTimeStamp["ordered"] - b.inStateTimeStamp["ordered"]);
    if (orderListUtil && orderListUtil.allOrders && orderListUtil.allOrders.tables)
      orderListUtil.allOrders.tables.forEach(table => {
        const isTakeaway = auth.myStatus.restaurant_settings["enabled-features"].pickup && auth.myStatus.restaurant_settings["enabled-features"].homedelivery && (table.tableNumber === auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"] || table.tableNumber === auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"])
        if (((!producingShown && table.stateMap["accepted"] == 0) || (producingShown && table.stateMap["producing"] == 0)) && table.stateMap["delivering"].length + table.stateMap["ready"].length > 0) {
          if (isTakeaway)
            return;
          var found = false;
          tableSetDelivering.forEach(t => found = table === t);
          if (!found) {
            if (orientation == "landscape") {
              if (isElementInViewport(tableLayout.SVG, tableLayout.SVG.find("#" + table.tableNumber + ".eatwithme-table"))) {
                tableSetDelivering.set(table, table);
              }
            } else {
              if (tableLayout.rotatedSVG)
                if (isElementInViewport(tableLayout.rotatedSVG, tableLayout.rotatedSVG.find("#" + table.tableNumber + ".eatwithme-table"))) {
                  tableSetDelivering.set(table, table);
                }
            }
          }
        }
        if (table.stateMap["ordered"].length > 0) {
          var found = false;
          tableSetOrdered.forEach(t => found = table.tableOccupation === t.tableOccupation);
          if (!found) {
            if (orientation == "landscape") {
              if (isElementInViewport(tableLayout.SVG, tableLayout.SVG.find("#" + table.tableNumber + ".eatwithme-table"))) {
                tableSetOrdered.set(table, table);
              }
            } else {
              if (tableLayout.rotatedSVG)
                if (isElementInViewport(tableLayout.rotatedSVG, tableLayout.rotatedSVG.find("#" + table.tableNumber + ".eatwithme-table"))) {
                  tableSetOrdered.set(table, table);
                }
            }
          }
        }
      });
    tableSetDelivering.forEach(table => {
      const button = $('<span style="white-space:nowrap" tableOccupation="' + table.tableOccupation + '" tableNumber="' + table.tableNumber + '" orders=' + table.orderIds + ">" + (getTable(table.tableNumber).name || table.tableNumber) + "</span>");
      button.appendTo(".delivering-tasks");
      button.on('click', event => tableLayout.tableDelivered(event));
    });
    tableSetOrdered.forEach(table => {
      const oc = getTableOccupation(table.tableOccupation);
      if (!oc) return;
      var tableName = getTable(table.tableNumber).name;
      if (!tableName) tableName = table.tableNumber;
      var button;
      const ids = getOrdersByTableNumber(oc.id, table.tableNumber, 'ordered').filter(o => o.recordState === "ACTIVE" && o.state === "ordered").map(o => o.id);
      if (oc.bookedProperties && oc.bookedProperties.platform) {
        if (oc.bookedProperties.platform === "wolt") {
          button = $('<span style="white-space:nowrap" class="wolt" tableOccupation="' + table.tableOccupation + '" tableNumber="' + table.tableNumber + '" orders=' + ids + ">" + tableName + "</span>");
        } else if (oc.bookedProperties.platform === "foodpanda") {
          button = $('<span style="white-space:nowrap" class="foodpanda" tableOccupation="' + table.tableOccupation + '" tableNumber="' + table.tableNumber + '" orders=' + ids + ">" + tableName + "</span>");
        } else if (oc.bookedProperties.platform === "falatozz") {
          button = $('<span style="white-space:nowrap" class="falatozz" tableOccupation="' + table.tableOccupation + '" tableNumber="' + table.tableNumber + '" orders=' + ids + ">" + tableName + "</span>");
        } else if (oc.bookedProperties.platform === "eatwithme") {
          button = $('<span style="white-space:nowrap" class="eatwithme" tableOccupation="' + table.tableOccupation + '" tableNumber="' + table.tableNumber + '" orders=' + ids + ">" + tableName + "</span>");
        } else if (oc.bookedProperties.platform === "choiceqr") {
          button = $('<span style="white-space:nowrap" class="choiceqr" tableOccupation="' + table.tableOccupation + '" tableNumber="' + table.tableNumber + '" orders=' + ids + ">" + tableName + "</span>");
        }
      }
      else
        button = $('<span style="white-space:nowrap"  tableOccupation="' + table.tableOccupation + '" tableNumber="' + table.tableNumber + '" orders=' + ids + ">" + tableName + "</span>");
      if (button) {
        button.appendTo(".ordered-tasks");
        button.on('click', event => {
          tableLayout.showSimpleOrderTimeout = setTimeout(() => tableLayout.showSimpleOrder(table.tableOccupation, table.tableNumber, ['ordered'], undefined, true), 400);
          tableLayout.tableAccepted(event, table.tableNumber);
        });
      }
    });
    if (tableSetOrdered.size) {
      $("#block-ordered-tasks").addClass("new-order");
    } else {
      $("#block-ordered-tasks").removeClass("new-order");
    }

    var tableWaiterCalled = orderListUtil.tableOccupations && orderListUtil.tableOccupations.filter(to => {
      const a = to.tableMates.filter(tm => tm.payable > 0 && getStateIndex(tm, "paymentRequest") >= 0).length;
      const b = to.restaurantTables.filter(rt => rt.waiterNeeded).length;
      return a || b;
    }).map(to => to.restaurantTables.filter(rt => {
      const r = rt.waiterNeeded || to.tableMates.filter(tm => tm.tableNumber == rt.restaurantTable.number && getStateIndex(tm, "paymentRequest") > 0).length;
      return r;
    }).map(t => { return { ...t, tableOccupation: to.id } })).reduce((a, b) => [...a, ...b], []).sort((a, b) => a.waiterNeededSince - b.waiterNeededSince);
    const blockwaitercalled = $("#block-call-waiter .call-waiter");
    blockwaitercalled.empty();
    if (tableWaiterCalled?.length) {
      tableWaiterCalled.forEach(table => {
        var tableName = getTable(table.restaurantTable.number).name;
        if (tableName) tableName = tableName.substring(0, 3); else tableName = table.restaurantTable.number;
        const button = $('<span tableOccupation="' + (table.tableOccupation) + '" tableNumber="' + table.restaurantTable.number + '">' + tableName + "</span>");
        button.appendTo(blockwaitercalled);
        button.on('dblclick', t => tableLayout.waiterCalled($(t.target).attr("tablenumber"), $(t.target).attr("tableoccupation")));
      });
      blockwaitercalled.addClass("new-order");
      playNewAcceptedOrderSound();
    } else {
      blockwaitercalled.removeClass("new-order");
    }

    tableLayout.tables.forEach(function (table) {
      const t = $('svg[visible = "true"] g.eatwithme-table[id = "' + table.number + '"]');
      if (!t || t.length === 0) return;
      if (table.shareable) {
        t.addClass("shareable");
      }
      if (table.pos) {
        t.addClass("pos");
      }
      if (table.bookOnline) {
        t.addClass("bookOnline");
      }
      if (table.visibleOnline) {
        t.addClass("visibleOnline");
      }
      if (table.isActive == false) {
        t.addClass("inactive");
      }
      const isPickup = Number(table.number) === auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"];
      const isHomeDelivery = Number(table.number) === auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"];
      if (isPickup) {
        t.addClass("pickup");
      }
      if (isHomeDelivery) {
        t.addClass("homedelivery");
      }
      function decorate(type) {
        //if (auth.device.platform !== "browser")
        //return;
        const enabled = Boolean(auth.myStatus.restaurant_settings["enabled-features"][type]["webshop"]);
        if (enabled) {
          $('#' + type + '-switch').remove();
          const closed = Boolean(auth.myStatus.restaurant_settings["enabled-features"][type]["closed"]);
          const closedButton = $("<div id='" + type + "-switch'><label class='switch'><input type='checkbox' " + (closed ? '' : 'checked') + "/><span class='slider round'/></label><span></span></div>");
          closedButton.css('left', t.get(0).getBoundingClientRect().left)
          closedButton.css('top', t.parent().get(0).getBoundingClientRect().top)
          closedButton.css('font-size', Math.max(10, Math.min(t.get(0).getBoundingClientRect().width / 20, t.get(0).getBoundingClientRect().height / 3)) + "px");


          function l() {
            const closed = Boolean(auth.myStatus.restaurant_settings["enabled-features"][type]["closed"]);
            closedButton.find(">span").html(I18n.t("admin_local." + (closed ? "closed" : "opened")));
            closedButton.find("input").prop("checked", !closed);
          }
          l();

          $("#floorplan-main").append(closedButton);
          closedButton.find('input').on("change", (e) => {
            auth.myStatus.restaurant_settings["enabled-features"][type]["closed"] = !closedButton.find("input").prop("checked");
            const setting = {
              "enabled-features": {

              }
            }
            setting["enabled-features"][type] = {
              closed: auth.myStatus.restaurant_settings["enabled-features"][type]["closed"]
            }
            put("restaurantService/" + auth.myStatus.restaurant_id + "/settings", setting);
            l();
          })
        }
        $('#' + type + '-auto-switch').remove();
        const auto = Boolean(auth.myStatus.restaurant_settings["enabled-features"][type]["autoaccept"]);
        const autoAcceptButton = $("<div id='" + type + "-auto-switch'><label class='switch'><input type='checkbox' " + (auto ? '' : 'checked') + "/><span class='slider round'/></label><span></span></div>");
        autoAcceptButton.css('left', t.get(0).getBoundingClientRect().right)
        autoAcceptButton.css('top', t.parent().get(0).getBoundingClientRect().top)
        autoAcceptButton.css('font-size', Math.max(10, Math.min(t.get(0).getBoundingClientRect().width / 20, t.get(0).getBoundingClientRect().height / 3)) + "px");
        $("#floorplan-main").append(autoAcceptButton);
        function a() {
          const auto = Boolean(auth.myStatus.restaurant_settings["enabled-features"][type]["autoaccept"]);
          autoAcceptButton.find(">span").html(I18n.t("admin_local.accept_" + (auto ? "auto" : "manual")));
          autoAcceptButton.find("input").prop("checked", auto);
        }
        a();

        autoAcceptButton.find('input').on("change", (e) => {
          auth.myStatus.restaurant_settings["enabled-features"][type]["autoaccept"] = autoAcceptButton.find("input").prop("checked");
          const setting = {
            "enabled-features": {

            }
          }
          setting["enabled-features"][type] = {
            autoaccept: auth.myStatus.restaurant_settings["enabled-features"][type]["autoaccept"]
          }
          put("restaurantService/" + auth.myStatus.restaurant_id + "/settings", setting);
          a();
        })
        const foodpandaplaces = featureEnabled("foodpanda") && getFeature("foodpanda").places ? getFeature("foodpanda").places.filter(p => p.enabled && p.id) : [];
        const woltplaces = featureEnabled("wolt") && getFeature("wolt").places ? getFeature("wolt").places.filter(p => p.enabled && p.restaurantId) : [];
        $('#floorplan-main .platforms').empty();
        const buttons = (platform, places) => {
          if (t.length)
            places.forEach(place => {
              const closedButton = $("<div class='" + platform + "-switch'>" + (places.length > 1 ? "<span class='name'>" + place.name + "</span>" : "") + "<label class='switch'><input type='checkbox' " + (place.closed ? '' : 'checked') + "/><span class='slider round'/></label>" + "<span class='state'></span></div>");
              //closedButton.css('left', t.get(0).getBoundingClientRect().left)
              //closedButton.css('top', t.parent().get(0).getBoundingClientRect().top)
              //closedButton.css('font-size', Math.max(10, Math.min(t.get(0).getBoundingClientRect().width / 20, t.get(0).getBoundingClientRect().height / 3)) + "px");
              closedButton.css('font-size', "17px");
              function l() {
                closedButton.find(">span.state").html(I18n.t("admin_local." + (place.closed ? "closed" : "opened")));
                closedButton.find("input").prop("checked", !place.closed);
                //console.log("closed", place.closed, platform, place.name);
                if (place.closed) {
                  closedButton.find(">span.state").addClass("closed", place.closed);
                } else {
                  closedButton.find(">span.state").removeClass("closed");
                }
              }
              if (tableLayout.platformOpenUpdated)
                l();
              else if (place.direct) {
                get("integration/" + platform + "/" + auth.myStatus.restaurant_id + "/remoteId/" + (platform === "foodpanda" ? place.id : place.restaurantId) + "/availability", undefined, undefined, undefined, false).done((data) => {
                  place.closed = data?.status !== "open";
                  //_log("got availability:");
                  //console.log("got availability:", platform, place.id, data, place.closed);
                  closedButton.find("input").prop("checked", !place.closed);
                  l();
                  tableLayout.platformOpenUpdated = true;
                  //console.log("platformOpenUpdated set to true");
                }).fail(() => { auth.ajaxError = false });
              }
              $("#floorplan-main .platforms").prepend(closedButton);
              closedButton.find('input').off("change");
              closedButton.find('input').on("change", (e) => {
                place.closed = !closedButton.find("input").prop("checked");
                patch("integration/" + platform + "/" + auth.myStatus.restaurant_id + "/remoteId/" + (platform === "foodpanda" ? place.id : place.restaurantId) + "/availability/" + !place.closed, undefined, undefined, undefined, false).done((data) => {
                  place.closed = data?.status !== "open";
                  //console.log("got availability:", platform, place.id, data, place.closed);
                  closedButton.find("input").prop("checked", !place.closed);
                  l();
                });
              })
            });
        }
        buttons("foodpanda", foodpandaplaces);
        buttons("wolt", woltplaces);
      }
      if (isHomeDelivery) {
        decorate("homedelivery");
      }
      if (isPickup) {
        decorate("pickup");
      }

    });

    if (svg.length == 0) return;
    var viewport = svg.get(0).viewBox.baseVal;
    var svgRect = svg.get(0).getBoundingClientRect();
    var w = svg.width() / svgRect.width;
    var h = svg.height() / svgRect.height;
    /*
    var w = svg.attr('width').replace('px', '') / svg.css('width').replace('px', '');
    var h = svg.attr('height').replace('px', '') / svg.css('height').replace('px', '');
    */
    svg.find(".table-connections").remove();

    var restaurantTableOccupations = [];
    var now = new Date().getTime();
    var bookingList = [];
    if (orderListUtil.tableOccupations)
      orderListUtil.tableOccupations.forEach(function (tableOccupation) {
        if (tableOccupation.occupationStart == null && (tableOccupation.bookedOccupationStart - now) / 60000 > auth.myStatus.restaurant_settings["enabled-features"].prebooking.showBefore) {
          return;
        }
        if (tableOccupation.occupationStart == null && (now - tableOccupation.bookedOccupationStart) / 60000 > auth.myStatus.restaurant_settings["enabled-features"].prebooking.maxLateDuration) {
          return;
        }
        var tableCount = tableOccupation.restaurantTables.length;
        var centerX1;
        var centerY1;
        if (tableOccupation.occupationStart == null) {
          bookingList.push({ tableOccupation: tableOccupation, key: tableOccupation.id });
          if (tableOccupation.bookedProperties.seats)
            Object.values(tableOccupation.bookedProperties.seats).forEach(numbers => {
              numbers.forEach(number => {
                if (Array.isArray(number)) {
                  number.forEach((number, ind) => {
                    var g = $("g#" + number + ".eatwithme-table").parent().parent();
                    if (g.length > 0) {
                      //table is displayed in the layout
                      var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(g.attr("transform"));
                      var centerX2 = Number(matches[1]);
                      var centerY2 = Number(matches[2]);

                      if (ind > 0) {
                        svg.prepend(tableLayout.makeSVG2($('<line class="table-connections action-needed" x1=' + centerX1 + " y1=" + centerY1 + " x2=" + centerX2 + " y2=" + centerY2 + ' style=""/>')));
                      }

                      centerX1 = centerX2;
                      centerY1 = centerY2;
                    }
                  });
                }
              });
            });
        }
        tableOccupation.restaurantTables.forEach(function (restaurantTableOccupation, ind) {
          if (!restaurantTableOccupation.active || restaurantTableOccupation.restaurantTable === null) {
            return;
          }
          var number = restaurantTableOccupation.restaurantTable.number;
          if (tableCount > 1) {
            var g = $("svg[visible = 'true'] g#" + number + ".eatwithme-table").parent().parent();
            if (g.length > 0) {
              //table is displayed in the layout
              var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(g.attr("transform"));
              var centerX2 = Number(matches[1]);
              var centerY2 = Number(matches[2]);
              var clazz = "table-connections";
              if (tableOccupation.bookedOccupationStart - now < 300000)
                clazz += " action-needed";

              if (centerX1 && centerY1) {
                svg.prepend(
                  tableLayout.makeSVG2($('<line class="' + clazz + '" x1=' + centerX1 + " y1=" + centerY1 + " x2=" + centerX2 + " y2=" + centerY2 + ' style="stroke-dasharray:5,5;stroke:rgb(255,0,0);stroke-width:2"/>'))
                );
              }

              centerX1 = centerX2;
              centerY1 = centerY2;
            }
          }
          restaurantTableOccupation.tableOccupationId = tableOccupation.id;
          if (restaurantTableOccupations[number]) {
            restaurantTableOccupations[number].push(restaurantTableOccupation);
          } else restaurantTableOccupations[number] = [restaurantTableOccupation];
        });
      });

    tableLayout.bookingList.reload(bookingList);
    if (bookingList.length > 0) {
      if (tableLayout.bookingListCount !== 1) {
        tableLayout.bookingListCount = 1;
        tableLayout.resize();
        console.log("resize")
      }
      //      $("#bookingList").show();
    } else {
      if (tableLayout.bookingListCount !== 0) {
        tableLayout.bookingListCount = 0;
        tableLayout.resize();
        //console.log("resize")
      }
      //  $("#bookingList").hide();
    }

    var statistics = {
      acceptedItemsWaitingForDeliveryAll: 0,
      acceptedItemsWaitingForDeliveryAllMax: 0,
      acceptedItemsWaitingForDeliveryAllMin: 0,
      acceptedItemsWaitingForDeliveryAllCount: 0,
      orderedItemsWaitingForAcceptanceAll: 0,
      orderedItemsWaitingForAcceptanceAllMax: 0,
      orderedItemsWaitingForAcceptanceAllMin: 0,
      orderedItemsWaitingForAcceptanceAllCount: 0
    };
    for (var property in restaurantTableOccupations) {
      if (restaurantTableOccupations.hasOwnProperty(property)) {
        tableLayout.updateStatistics(restaurantTableOccupations[property], statistics);
      }
    }

    /*
    $("#activeAverageAcceptanceDuration").html(getDuration(statistics.orderedItemsWaitingForAcceptanceAll));
    $("#activeAverageDeliveringDuration").html(getDuration(statistics.acceptedItemsWaitingForDeliveryAll));
    $("#activeMaxAcceptanceDuration").html(getDuration(statistics.orderedItemsWaitingForAcceptanceAllMax));
    $("#activeMaxDeliveringDuration").html(getDuration(statistics.acceptedItemsWaitingForDeliveryAllMax));
    $("#activeMinAcceptanceDuration").html(getDuration(statistics.orderedItemsWaitingForAcceptanceAllMin));
    $("#activeMinDeliveringDuration").html(getDuration(statistics.acceptedItemsWaitingForDeliveryAllMin));
    */

    /*
    $("svg .in-delay-90").removeClass("in-delay-90");
    $("svg .in-delay-75").removeClass("in-delay-75");
    $("svg .in-delay-50").removeClass("in-delay-50");
    */
    /*
     $("#main").removeClass("warning");
     $("svg .flash").removeClass("flash");
     */
    const now2 = new Date().getTime();

    for (var property in restaurantTableOccupations) {
      const decorations = this.preUpdateTable(restaurantTableOccupations[property], statistics);

      if (!this.tableDecorationCache[property] || this.tableDecorationCache[property].hash() !== decorations.hash()) {
        if (this.tableDecorationCache[property]) {
          this.tableDecorationCache[property].clear();
        }
        this.tableDecorationCache[property] = decorations;
        delete this.tableOccupationsCache[property];
      } else {
        this.tableDecorationCache[property] = decorations;
      }

    }

    for (var property in this.tableOccupationsCache) {
      if (!restaurantTableOccupations[property]) {
        //delete this.tableOccupationsCache[property];
        if (this.tableDecorationCache[property]) {
          this.tableDecorationCache[property].clear();
        }
        delete this.tableDecorationCache[property];
        this.clearTableAnnotations(property);
      }
    }

    for (var property in restaurantTableOccupations) {
      //if (JSON.stringify(this.tableOccupationsCache[property]) === JSON.stringify(restaurantTableOccupations[property]))
      const tableOccupation = getTableOccupation(restaurantTableOccupations[property][0].tableOccupationId);
      var modificationTimeStamp = tableOccupation.modificationTimeStamp;
      const prevTimestamp = this.tableOccupationsCache[property];
      if (prevTimestamp == modificationTimeStamp) {
        delete restaurantTableOccupations[property];
      } else {
        this.tableOccupationsCache[property] = modificationTimeStamp;
      }
    }

    for (var property in restaurantTableOccupations) {

      if (restaurantTableOccupations.hasOwnProperty(property)) {
        this.clearTableAnnotations(property);
      }
    }
    for (var property in restaurantTableOccupations) {
      const decorations = this.tableDecorationCache[property];
      if (decorations)
        decorations.apply();
    }

    //console.log("updateTable time", restaurantTableOccupations.length, new Date().getTime() - now2);
    var iconsAdded = svg.find("image.svgadded");
    iconsAdded.click(tableLayout.tableClickHandler2);
    const time4 = new Date().getTime() - now2;
    return time4;
  },

  tableDelivered: function (t) {
    const def = $.Deferred();
    const tt = t.target;
    const tableNumber = $(tt).attr("tableNumber");
    const tableOccupation = $(tt).attr("tableOccupation");
    tableLayout.showSimpleOrderTimeout = setTimeout(() => tableLayout.showSimpleOrder(tableOccupation, tableNumber, ['ready', 'delivering']), 400);
    if ($(tt).hasClass("pushed")) {
      clearTimeout(tableLayout.showSimpleOrderTimeout);
      tableLayout.showSimpleOrderTimeout = undefined;
      simpleChangeStateByTableAndMenuItem($(t.target), "delivering", "delivered", null, def);
    } else {
      $(tt).addClass("pushed");
      setTimeout(function () {
        $(tt).removeClass("pushed");
      }, 2000);
    }
    return def.promise();
  },

  waiterCalled: (tableNumber, tableOccupation = "0") => {
    const def = $.Deferred();
    tableOccupation.split(",").filter(t => t).forEach(tableOccupation =>
      get("adminService/" + localStorage.restaurantSelected + "/cancelCallWaiter/" + tableOccupation + "/" + tableNumber).done(data => { update(data); def.resolve() }));
    return def.promise();
  },

  tableAccepted: function (t, tableNumber) {
    const def = $.Deferred();
    if ($(t.target).hasClass("pushed")) {
      if (tableLayout.showSimpleOrderTimeout) {
        clearTimeout(tableLayout.showSimpleOrderTimeout);
        tableLayout.showSimpleOrderTimeout = undefined;
      }
      selectTableNumberSelected(tableNumber);
      simpleChangeStateByTableAndMenuItem($(t.target), "ordered", "accepted", undefined, def);
    } else {
      $(t.target).addClass("pushed");
      setTimeout(function () {
        $(t.target).removeClass("pushed");
      }, 2000);
    }
    return def.promise();
  },

  updateStatistics: function (occupations, statistics) {
    var table = $('[id="' + occupations[0].restaurantTable.number + '"].eatwithme-table');
    $(occupations).each(function (ind, restaurantTableOccupation) {
      var first = true;
      if (orderListUtil.allOrders && orderListUtil.allOrders.tables)
        orderListUtil.allOrders.tables.forEach(function (tt) {
          if (tt.tableNumber == restaurantTableOccupation.restaurantTable.number) {
            if (first) {
              //var acceptedItemsWaitingForDelivery = tt.notDelivered ? (new Date().getTime() - tt.inActiveStateTimeStamp) / 1000 : 0;
              var acceptedItemsWaitingForDelivery = tt.notDelivered ? tt.inStateDurations.active_delivering : 0;
              var orderedItemsWaitingForAcceptance = tt.inStateDurations.active_accepting;
              if (tt.notDelivered) {
                statistics.acceptedItemsWaitingForDeliveryAllCount++;
                statistics.acceptedItemsWaitingForDeliveryAll =
                  ((statistics.acceptedItemsWaitingForDeliveryAllCount - 1) * statistics.acceptedItemsWaitingForDeliveryAll + acceptedItemsWaitingForDelivery) / statistics.acceptedItemsWaitingForDeliveryAllCount;
                statistics.acceptedItemsWaitingForDeliveryAllMax = Math.max(statistics.acceptedItemsWaitingForDeliveryAllMax, acceptedItemsWaitingForDelivery);
                statistics.acceptedItemsWaitingForDeliveryAllMin =
                  statistics.orderedItemsWaitingForAcceptanceAllCount > 1 ? Math.min(statistics.acceptedItemsWaitingForDeliveryAllMax, acceptedItemsWaitingForDelivery) : acceptedItemsWaitingForDelivery;
              }
              if (orderedItemsWaitingForAcceptance > 0) {
                statistics.orderedItemsWaitingForAcceptanceAllCount++;
                statistics.orderedItemsWaitingForAcceptanceAll =
                  ((statistics.orderedItemsWaitingForAcceptanceAllCount - 1) * statistics.orderedItemsWaitingForAcceptanceAll + orderedItemsWaitingForAcceptance) / statistics.orderedItemsWaitingForAcceptanceAllCount;
                statistics.orderedItemsWaitingForAcceptanceAllMax = Math.max(statistics.orderedItemsWaitingForAcceptanceAllMax, orderedItemsWaitingForAcceptance);
                statistics.orderedItemsWaitingForAcceptanceAllMin =
                  statistics.orderedItemsWaitingForAcceptanceAllCount > 1 ? Math.min(statistics.orderedItemsWaitingForAcceptanceAllMin, orderedItemsWaitingForAcceptance) : orderedItemsWaitingForAcceptance;
              }
            }
          }
        });
    });
  },

  collectTableRoomAssignmentsFromLayout: function () {
    var assignments = {};
    var $svg = $("#c svg[visible='true']").last();
    if (!$svg || $svg.length === 0) {
      $svg = tableLayout.SVG && tableLayout.SVG.length ? $(tableLayout.SVG).last() : $("svg[visible='true']").last();
    }
    if (!$svg || $svg.length === 0) {
      return assignments;
    }

    var rooms = [];
    $svg.find("g.eatwithme-room").each(function (roomIndex, roomNode) {
      var $room = $(roomNode);
      var roomRect = $room.find("rect").first().get(0);
      if (!roomRect || !roomRect.getBoundingClientRect) {
        return;
      }
      var roomBounds = roomRect.getBoundingClientRect();
      if (!roomBounds || !Number.isFinite(roomBounds.width) || !Number.isFinite(roomBounds.height)) {
        return;
      }

      var roomName = ($room.find("text.eatwithme-roomName tspan").first().text() || "").trim();
      if (!roomName) {
        roomName = (($room.attr("id") || "").replace(/^room_/, "")).trim();
      }
      if (!roomName) {
        return;
      }

      rooms.push({
        name: roomName,
        left: roomBounds.left,
        right: roomBounds.right,
        top: roomBounds.top,
        bottom: roomBounds.bottom,
        zOrder: roomIndex
      });
    });

    if (rooms.length === 0) {
      return assignments;
    }

    $svg.find("g.eatwithme-table").each(function (_, tableNode) {
      var $table = $(tableNode);
      var tableNumber = Number($table.attr("id"));
      if (!tableNumber || !Number.isFinite(tableNumber)) {
        return;
      }
      var tableBounds = tableNode.getBoundingClientRect();
      if (!tableBounds || !Number.isFinite(tableBounds.left) || !Number.isFinite(tableBounds.top)) {
        return;
      }

      var cx = tableBounds.left + tableBounds.width / 2;
      var cy = tableBounds.top + tableBounds.height / 2;
      var matchedRoom = null;

      rooms.forEach(function (room) {
        var inside = cx >= room.left && cx <= room.right && cy >= room.top && cy <= room.bottom;
        if (!inside) {
          return;
        }
        if (!matchedRoom || room.zOrder > matchedRoom.zOrder) {
          matchedRoom = room;
        }
      });

      assignments[tableNumber] = matchedRoom ? matchedRoom.name : null;
    });

    return assignments;
  },

  collectVisibleRoomNamesFromLayout: function () {
    var visibleRoomNames = new Set();
    var $svg = tableLayout.SVG && tableLayout.SVG.length ? $(tableLayout.SVG).last() : $("svg[visible='true']").last();
    if (!$svg || $svg.length === 0) {
      return visibleRoomNames;
    }

    $svg.find("g.eatwithme-room").each(function (_, roomNode) {
      var $room = $(roomNode);
      var roomName = ($room.find("text.eatwithme-roomName tspan").first().text() || "").trim();
      if (!roomName) {
        roomName = (($room.attr("id") || "").replace(/^room_/, "")).trim();
      }
      if (roomName) {
        visibleRoomNames.add(roomName);
      }
    });

    return visibleRoomNames;
  },

  syncTableRoomsInBackground: function (assignments, visibleRoomNamesOverride) {
    if (!assignments) {
      return;
    }

    admin.getRooms(function (rooms) {
      var roomByName = new Map();
      var roomById = new Map();
      var $activeSvg = $("#c svg[visible='true']").last();
      if (!$activeSvg || $activeSvg.length === 0) {
        $activeSvg = tableLayout.SVG && tableLayout.SVG.length ? $(tableLayout.SVG).last() : $("svg[visible='true']").last();
      }
      var normalizeRoomName = function (value) {
        return (value == null ? "" : String(value)).trim();
      };
      var normalizeRoomNameKey = function (value) {
        return normalizeRoomName(value).toLowerCase();
      };

      var registerRoom = function (room) {
        if (!room) {
          return;
        }
        var roomId = room.id != null ? Number(room.id) : null;
        if (roomId && Number.isFinite(roomId)) {
          roomById.set(roomId, room);
        }
        var primaryName = normalizeRoomName(room.room);
        var secondaryName = normalizeRoomName(room.name);
        var primaryKey = normalizeRoomNameKey(primaryName);
        var secondaryKey = normalizeRoomNameKey(secondaryName);
        if (primaryKey && !roomByName.has(primaryKey)) {
          roomByName.set(primaryKey, room);
        }
        if (secondaryKey && !roomByName.has(secondaryKey)) {
          roomByName.set(secondaryKey, room);
        }
      };

      (rooms || []).forEach(registerRoom);

      var visibleRoomNamesSource = visibleRoomNamesOverride instanceof Set ? visibleRoomNamesOverride : tableLayout.collectVisibleRoomNamesFromLayout();
      var visibleRoomNames = new Set();
      visibleRoomNamesSource.forEach(function (roomName) {
        var roomNameKey = normalizeRoomNameKey(roomName);
        if (roomNameKey) {
          visibleRoomNames.add(roomNameKey);
        }
      });

      var missingRoomNames = [];
      var registerMissingRoomName = function (roomName) {
        var normalized = normalizeRoomName(roomName);
        var normalizedKey = normalizeRoomNameKey(normalized);
        if (!normalizedKey) {
          return;
        }
        if (!roomByName.has(normalizedKey) && missingRoomNames.indexOf(normalized) === -1) {
          missingRoomNames.push(normalized);
        }
      };

      Object.keys(assignments).forEach(function (tableNumberKey) {
        registerMissingRoomName(assignments[tableNumberKey]);
      });

      visibleRoomNames.forEach(function (roomName) {
        registerMissingRoomName(roomName);
      });

      var getCurrentRoomId = function (table) {
        return table && table.room && table.room.id ? Number(table.room.id) : (table && table.roomId ? Number(table.roomId) : null);
      };

      var deleteEmptyRooms = function () {
        window.setTimeout(function () {
          admin.getTables(function (tableLayouts) {
            var roomUsage = new Map();
            var latestTables = tableLayouts && Array.isArray(tableLayouts.restaurantTables) ? tableLayouts.restaurantTables : [];

            latestTables.forEach(function (table) {
              var finalRoomId = getCurrentRoomId(table);
              if (!finalRoomId || !Number.isFinite(finalRoomId)) {
                return;
              }
              roomUsage.set(finalRoomId, (roomUsage.get(finalRoomId) || 0) + 1);
            });

            roomById.forEach(function (_room, roomId) {
              var roomName = normalizeRoomNameKey(_room && (_room.room || _room.name));
              var existsVisually = roomName && visibleRoomNames.has(roomName);
              if ((roomUsage.get(roomId) || 0) === 0 && !existsVisually) {
                admin.deleteRoom(roomId);
              }
            });
          });
        }, 1000);
      };

      var syncAssignments = function () {
        var updates = [];
        Object.keys(assignments).forEach(function (tableNumberKey) {
          var tableNumber = Number(tableNumberKey);
          if (!tableNumber || !Number.isFinite(tableNumber)) {
            return;
          }

          var table = getTable(tableNumber);
          if (!table || !table.id) {
            return;
          }

          var roomName = normalizeRoomName(assignments[tableNumberKey]);
          var desiredRoom = null;
          var desiredRoomId = null;
          if (roomName) {
            var mappedRoom = roomByName.get(normalizeRoomNameKey(roomName));
            if (!mappedRoom || !mappedRoom.id) {
              return;
            }
            desiredRoom = { id: mappedRoom.id };
            desiredRoomId = Number(mappedRoom.id);
          }

          var currentRoomId = getCurrentRoomId(table);
          if (currentRoomId === desiredRoomId) {
            return;
          }

          updates.push({
            table: table,
            room: desiredRoom
          });
        });

        if (updates.length === 0) {
          deleteEmptyRooms();
          return;
        }

        var remaining = updates.length;
        var onUpdateDone = function () {
          remaining--;
          if (remaining <= 0) {
            deleteEmptyRooms();
          }
        };

        updates.forEach(function (updateItem) {
          admin.modifyTable(
            {
              ...updateItem.table,
              id: updateItem.table.id,
              number: updateItem.table.number,
              room: updateItem.room
            },
            updateItem.table.forStore,
            updateItem.table.extensions,
            onUpdateDone,
            onUpdateDone
          );
        });
      };

      if (missingRoomNames.length === 0) {
        syncAssignments();
        return;
      }

      var createNextRoom = function (index) {
        if (index >= missingRoomNames.length) {
          syncAssignments();
          return;
        }

        var newRoomName = missingRoomNames[index];
        admin.addRoom(newRoomName, true, true, true, function (createdRoom) {
          registerRoom(createdRoom);
          if (!roomByName.has(normalizeRoomNameKey(newRoomName))) {
            admin.getRooms(function (latestRooms) {
              (latestRooms || []).forEach(registerRoom);
              createNextRoom(index + 1);
            });
            return;
          }
          createNextRoom(index + 1);
        });
      };

      createNextRoom(0);
    });
  },

  saveLayout: function () {
    if (tableLayout.getOrientation() !== "landscape")
      return;
    var s = $(".selectable");
    tableLayout.clearAnnotations();
    tableLayout.centralizeTables();
    tableLayout.SVG.find("g.eatwithme-table").each((ind, t) => {
      const box = t.getBoundingClientRect();
      const number = t.id;
      const table = getTable(number);
      if (table) {
        table.x = box.x + box.width / 2;
        table.y = box.y + box.height / 2;
      }
    });
    tableLayout.centralizeTables();
    const box = tableLayout.SVG[0].getBBox();
    var floorPlan = $('svg[visible="true"]').clone();
    floorPlan.find("circle.eatwithme-resize-corner").remove();
    floorPlan.attr("viewBox", (box.x - 10) + " " + (box.y - 10) + " " + (box.width + 20) + " " + (box.height + 20));
    floorPlan.find("g.eatwithme-table").each((ind, t) => {
      const tname = $(t).find("tspan.eatwithme-tableNumber").parent();
      const transform = tname.attr("transform");
      if (transform && transform.indexOf("rotate(-90 ") !== -1)
        tname.attr("transform", transform.substring(0, transform.indexOf("rotate(-90")))
    });


    $(floorPlan).css("zoom", 1);
    var s = $(floorPlan).prop("outerHTML");
    var roomAssignments = tableLayout.collectTableRoomAssignmentsFromLayout();
    var visibleRoomNames = tableLayout.collectVisibleRoomNamesFromLayout();
    tableLayout.editMode(false);
    tableLayout.floorplan.floorplan = s;
    admin.modifyRestaurantFloorplan(tableLayout.floorplan.id, tableLayout.floorplan.name, tableLayout.floorplan.floorplan, tableLayout.floorplan.active, function () {
      tableLayout.syncTableRoomsInBackground(roomAssignments, visibleRoomNames);
      getMyStatus(() => {
        tableLayout.centralizeTables();
        tableLayout.reset();
        tableLayout.initialize();
        tableLayout.updateTableOccupations();
        document.onkeydown = tableLayout.originalOnKeyDown;
      });
    });
  },

  clickSelectHandler: trigger => {
    if (tableLayout.suppressNextSelectionClick) {
      tableLayout.suppressNextSelectionClick = false;
      trigger.preventDefault();
      if (trigger.stopImmediatePropagation) {
        trigger.stopImmediatePropagation();
      }
      trigger.stopPropagation();
      return;
    }

    if (trigger && trigger.stopImmediatePropagation) {
      trigger.stopImmediatePropagation();
    }

    select(trigger.currentTarget, trigger);
    if (tableLayout.table_edit_mode) {
      var $current = $(trigger.currentTarget);
      if ($current.hasClass("eatwithme-table") || $current.hasClass("eatwithme-tableNumber") || $current.closest("g.eatwithme-table").length > 0) {
        var $tableTarget = tableLayout.resolveTableActionTrigger($current);
        var additiveSelect = !!(trigger && trigger.originalEvent && (trigger.originalEvent.shiftKey || trigger.originalEvent.metaKey || trigger.originalEvent.ctrlKey));
        if (!additiveSelect) {
          $("svg[visible='true'] g.eatwithme-table.ui-selected").removeClass("ui-selected");
        }
        if ($tableTarget && $tableTarget.length > 0) {
          $tableTarget.addClass("ui-selected");
        }
        tableLayout.syncMultiSelectedTableVisuals();
        tableLayout.showTableActionButtons($current);
      } else if ($current.hasClass("eatwithme-roomName") || $current.closest("text.eatwithme-roomName").length > 0) {
        var $roomTarget = tableLayout.resolveRoomActionTrigger($current, trigger);
        var additiveRoomSelect = !!(trigger && trigger.originalEvent && (trigger.originalEvent.shiftKey || trigger.originalEvent.metaKey || trigger.originalEvent.ctrlKey));
        if (!additiveRoomSelect) {
          $("svg[visible='true'] g.eatwithme-room.ui-selected").removeClass("ui-selected");
        }
        if ($roomTarget && $roomTarget.length > 0) {
          $roomTarget.addClass("ui-selected");
          tableLayout.refreshEditModeResizeCorners($roomTarget);
        }
        tableLayout.showRoomActionButtons($current);
      } else if ($current.hasClass("eatwithme-seat") || $current.closest("g.eatwithme-seat").length > 0) {
        tableLayout.showSeatActionButtons($current);
      } else {
        tableLayout.hideTableActionButtons();
        tableLayout.hideRoomActionButtons();
        tableLayout.hideSeatActionButtons();
      }
    }
    trigger.stopPropagation();
  },

  applyEditModeTableHandles: function (active) {
    var handles = $("svg[visible='true'] g.eatwithme-table > g[stroke-width]");
    var roomShapes = $("svg[visible='true'] g.eatwithme-room rect");
    var tableShapes = $("svg[visible='true'] g.eatwithme-table rect, svg[visible='true'] g.eatwithme-table ellipse, svg[visible='true'] g.eatwithme-table path");
    var resizableContainers = $("svg[visible='true'] g.eatwithme-table, svg[visible='true'] g.eatwithme-room");
    if (active) {
      handles.each(function (_, handle) {
        var $handle = $(handle);
        if ($handle.attr("stroke-width_bk") == null) {
          $handle.attr("stroke-width_bk", $handle.attr("stroke-width") || "1");
        }
        if ($handle.attr("stroke_bk") == null) {
          $handle.attr("stroke_bk", $handle.attr("stroke") || "#000000");
        }
        if ($handle.attr("stroke-dasharray_bk") == null) {
          $handle.attr("stroke-dasharray_bk", $handle.attr("stroke-dasharray") || "none");
        }
        if ($handle.attr("stroke-opacity_bk") == null) {
          $handle.attr("stroke-opacity_bk", $handle.attr("stroke-opacity") || "1");
        }
        $handle.attr("stroke-width", tableLayout.editModeTableStrokeWidth);
        $handle.attr("stroke", tableLayout.editModeTableStrokeColor);
        $handle.attr("stroke-dasharray", "none");
        $handle.attr("stroke-opacity", "0.95");
      });
      roomShapes.each(function (_, shape) {
        var $shape = $(shape);
        if ($shape.attr("stroke-width_bk") == null) {
          $shape.attr("stroke-width_bk", $shape.attr("stroke-width") || "1");
        }
        if ($shape.attr("stroke_bk") == null) {
          $shape.attr("stroke_bk", $shape.attr("stroke") || "#000000");
        }
        if ($shape.attr("stroke-dasharray_bk") == null) {
          $shape.attr("stroke-dasharray_bk", $shape.attr("stroke-dasharray") || "none");
        }
        if ($shape.attr("stroke-opacity_bk") == null) {
          $shape.attr("stroke-opacity_bk", $shape.attr("stroke-opacity") || "1");
        }
        $shape.attr("stroke-width", tableLayout.editModeTableStrokeWidth);
        $shape.attr("stroke", tableLayout.editModeTableStrokeColor);
        $shape.attr("stroke-dasharray", "none");
        $shape.attr("stroke-opacity", "0.95");
        $shape.css("cursor", "");
      });
      tableShapes.css("cursor", "move");
      tableShapes.off("mousemove.editResizeCursor mouseleave.editResizeCursor");
      tableShapes.on("mousemove.editResizeCursor", function (event) {
        var $dragTarget = $(event.currentTarget).closest("g.eatwithme-table, g.eatwithme-room").parent().parent();
        var edges = tableLayout.getResizeEdges(event, $dragTarget);
        var cursor = tableLayout.getResizeCursorByEdges(edges);
        $(event.currentTarget).css("cursor", cursor || "move");
      });
      tableShapes.on("mouseleave.editResizeCursor", function (event) {
        $(event.currentTarget).css("cursor", "move");
      });
      tableShapes.off("click.editHelperActions");
      tableShapes.on("click.editHelperActions", function (event) {
        if (tableLayout.suppressNextSelectionClick) {
          tableLayout.suppressNextSelectionClick = false;
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        var $container = $(event.currentTarget).closest("g.eatwithme-table, g.eatwithme-room");
        if ($container.hasClass("eatwithme-table")) {
          tableLayout.showTableActionButtons($container);
        } else {
          tableLayout.hideTableActionButtons();
          tableLayout.hideSeatActionButtons();
        }
      });
      resizableContainers.addClass("edit-resizable");
      tableLayout.refreshEditModeResizeCorners();
    } else {
      handles.each(function (_, handle) {
        var $handle = $(handle);
        if ($handle.attr("stroke-width_bk") != null) {
          $handle.attr("stroke-width", $handle.attr("stroke-width_bk"));
          $handle.attr("stroke-width_bk", null);
        }
        if ($handle.attr("stroke_bk") != null) {
          $handle.attr("stroke", $handle.attr("stroke_bk"));
          $handle.attr("stroke_bk", null);
        }
        if ($handle.attr("stroke-dasharray_bk") != null) {
          $handle.attr("stroke-dasharray", $handle.attr("stroke-dasharray_bk"));
          $handle.attr("stroke-dasharray_bk", null);
        }
        if ($handle.attr("stroke-opacity_bk") != null) {
          $handle.attr("stroke-opacity", $handle.attr("stroke-opacity_bk"));
          $handle.attr("stroke-opacity_bk", null);
        }
      });
      tableShapes.off("mousemove.editResizeCursor mouseleave.editResizeCursor");
      tableShapes.off("click.editHelperActions");
      tableShapes.css("cursor", "");
      resizableContainers.removeClass("edit-resizable");
      resizableContainers.find("circle.eatwithme-resize-corner").remove();
    }
  },

  getResizeCursorByEdges: function (edges) {
    if (!edges) return null;

    var normalized = {
      left: !!edges.left,
      right: !!edges.right,
      top: !!edges.top,
      bottom: !!edges.bottom
    };

    var rotationDeg = Number(edges.rotationDeg || 0);
    var quarterTurns = Math.round(rotationDeg / 90);
    var turns = ((quarterTurns % 4) + 4) % 4;

    while (turns > 0) {
      normalized = {
        top: normalized.left,
        right: normalized.top,
        bottom: normalized.right,
        left: normalized.bottom
      };
      turns--;
    }

    if ((normalized.left && normalized.top) || (normalized.right && normalized.bottom)) return "nwse-resize";
    if ((normalized.right && normalized.top) || (normalized.left && normalized.bottom)) return "nesw-resize";
    if (normalized.left || normalized.right) return "ew-resize";
    if (normalized.top || normalized.bottom) return "ns-resize";
    return null;
  },

  getShapeBoundsInTableCoords: function ($table, shape) {
    if (!$table || $table.length === 0 || !shape || !shape.getBBox || !shape.getScreenCTM) return null;

    var tableNode = $table.get(0);
    if (!tableNode || !tableNode.getScreenCTM) return null;

    var shapeCTM = shape.getScreenCTM();
    var tableCTM = tableNode.getScreenCTM();
    if (!shapeCTM || !tableCTM || !tableCTM.inverse) return null;

    var shapeToTable = tableCTM.inverse().multiply(shapeCTM);
    var bbox = shape.getBBox();

    var corners = [
      { x: bbox.x, y: bbox.y },
      { x: bbox.x + bbox.width, y: bbox.y },
      { x: bbox.x, y: bbox.y + bbox.height },
      { x: bbox.x + bbox.width, y: bbox.y + bbox.height }
    ];

    var minX = Number.POSITIVE_INFINITY;
    var minY = Number.POSITIVE_INFINITY;
    var maxX = Number.NEGATIVE_INFINITY;
    var maxY = Number.NEGATIVE_INFINITY;

    corners.forEach(function (corner) {
      var x = shapeToTable.a * corner.x + shapeToTable.c * corner.y + shapeToTable.e;
      var y = shapeToTable.b * corner.x + shapeToTable.d * corner.y + shapeToTable.f;
      minX = Math.min(minX, x);
      minY = Math.min(minY, y);
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);
    });

    if (!Number.isFinite(minX) || !Number.isFinite(minY) || !Number.isFinite(maxX) || !Number.isFinite(maxY)) return null;

    return {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY
    };
  },

  captureSeatResizeEdges: function ($tableContainer) {
    if (!$tableContainer || $tableContainer.length === 0) return;

    var tableNode = $tableContainer.find("g.eatwithme-table").first().get(0);
    var referenceNode = $tableContainer.get(0);
    if (!referenceNode || !referenceNode.getScreenCTM || !referenceNode.getScreenCTM() || !referenceNode.getScreenCTM().inverse) {
      referenceNode = tableNode;
    }
    if (!referenceNode || !referenceNode.getScreenCTM || !referenceNode.getScreenCTM() || !referenceNode.getScreenCTM().inverse) return;

    var shape = $tableContainer.find(".eatwithme-table rect, .eatwithme-table ellipse, .eatwithme-table path").first().get(0);
    if (!shape) return;

    var shapeBounds = tableLayout.getShapeBoundsInTableCoords($(referenceNode), shape);
    if (!shapeBounds) return;

    var referenceCTM = referenceNode.getScreenCTM();
    var referenceInv = referenceCTM.inverse();
    var svgRoot = tableNode.ownerSVGElement;
    if (!svgRoot || !svgRoot.createSVGPoint) return;

    var borderX = Number(shapeBounds.x || 0);
    var borderY = Number(shapeBounds.y || 0);
    var borderW = Number(shapeBounds.width || 0);
    var borderH = Number(shapeBounds.height || 0);
    if (borderW <= 0 || borderH <= 0) return;

    var shapeTag = (shape.tagName || "").toLowerCase();
    var isRoundLikeShape = shapeTag === "ellipse";
    var borderCenterX = borderX + borderW / 2;
    var borderCenterY = borderY + borderH / 2;
    var radiusX = Math.max(1, borderW / 2);
    var radiusY = Math.max(1, borderH / 2);

    var makePoint = function (x, y) {
      var p = svgRoot.createSVGPoint();
      p.x = x;
      p.y = y;
      return p;
    };

    var transformPoint = function (matrix, x, y) {
      return makePoint(x, y).matrixTransform(matrix);
    };

    var toBounds = function (points) {
      var minX = Number.POSITIVE_INFINITY;
      var minY = Number.POSITIVE_INFINITY;
      var maxX = Number.NEGATIVE_INFINITY;
      var maxY = Number.NEGATIVE_INFINITY;
      points.forEach(function (pt) {
        minX = Math.min(minX, pt.x);
        minY = Math.min(minY, pt.y);
        maxX = Math.max(maxX, pt.x);
        maxY = Math.max(maxY, pt.y);
      });
      return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
      };
    };

    $tableContainer.find("g.eatwithme-seat").each(function (_, seatNode) {
      if (!seatNode || !seatNode.getBBox || !seatNode.getScreenCTM || !seatNode.getScreenCTM()) return;

      var seatCTM = seatNode.getScreenCTM();
      var seatToReference = referenceInv.multiply(seatCTM);
      var seatW = Number($(seatNode).attr("width"));
      var seatH = Number($(seatNode).attr("height"));
      var hasSeatSize = Number.isFinite(seatW) && Number.isFinite(seatH) && seatW > 0 && seatH > 0;

      var localCenterX = 0;
      var localCenterY = 0;
      if (hasSeatSize) {
        localCenterX = seatW / 2;
        localCenterY = seatH / 2;
      } else {
        var seatBBox = seatNode.getBBox();
        if (!seatBBox) return;
        localCenterX = seatBBox.x + seatBBox.width / 2;
        localCenterY = seatBBox.y + seatBBox.height / 2;
      }

      var seatCenterPoint = transformPoint(seatToReference, localCenterX, localCenterY);
      var seatCenterX = seatCenterPoint.x;
      var seatCenterY = seatCenterPoint.y;

      if (isRoundLikeShape) {
        var angle = Math.atan2((seatCenterY - borderCenterY) / radiusY, (seatCenterX - borderCenterX) / radiusX);
        $(seatNode).attr("resize_angle_bk", String(angle));
        $(seatNode).attr("resize_edge_bk", null);
        return;
      }

      var dLeft = Math.abs(seatCenterX - borderX);
      var dRight = Math.abs(seatCenterX - (borderX + borderW));
      var dTop = Math.abs(seatCenterY - borderY);
      var dBottom = Math.abs(seatCenterY - (borderY + borderH));

      var edge = "left";
      var minDist = dLeft;
      if (dRight < minDist) {
        minDist = dRight;
        edge = "right";
      }
      if (dTop < minDist) {
        minDist = dTop;
        edge = "top";
      }
      if (dBottom < minDist) {
        edge = "bottom";
      }

      $(seatNode).attr("resize_edge_bk", edge);
    });
  },

  alignSeatsToClosestBorderHalfOutside: function ($tableContainer) {
    if (!$tableContainer || $tableContainer.length === 0) return;

    var tableNode = $tableContainer.find("g.eatwithme-table").first().get(0);
    var referenceNode = $tableContainer.get(0);
    if (!referenceNode || !referenceNode.getScreenCTM || !referenceNode.getScreenCTM() || !referenceNode.getScreenCTM().inverse) {
      referenceNode = tableNode;
    }
    if (!referenceNode || !referenceNode.getScreenCTM || !referenceNode.getScreenCTM() || !referenceNode.getScreenCTM().inverse) return;

    var shape = $tableContainer.find(".eatwithme-table rect, .eatwithme-table ellipse, .eatwithme-table path").first().get(0);
    if (!shape) return;

    var shapeBounds = tableLayout.getShapeBoundsInTableCoords($(referenceNode), shape);
    if (!shapeBounds) return;

    var referenceCTM = referenceNode.getScreenCTM();
    var referenceInv = referenceCTM.inverse();
    var svgRoot = tableNode.ownerSVGElement;
    if (!svgRoot || !svgRoot.createSVGPoint) return;

    var borderX = Number(shapeBounds.x || 0);
    var borderY = Number(shapeBounds.y || 0);
    var borderW = Number(shapeBounds.width || 0);
    var borderH = Number(shapeBounds.height || 0);
    if (borderW <= 0 || borderH <= 0) return;

    var shapeTag = (shape.tagName || "").toLowerCase();
    var isRoundLikeShape = shapeTag === "ellipse";
    var borderCenterX = borderX + borderW / 2;
    var borderCenterY = borderY + borderH / 2;
    var radiusX = Math.max(1, borderW / 2);
    var radiusY = Math.max(1, borderH / 2);

    var makePoint = function (x, y) {
      var p = svgRoot.createSVGPoint();
      p.x = x;
      p.y = y;
      return p;
    };

    var transformPoint = function (matrix, x, y) {
      return makePoint(x, y).matrixTransform(matrix);
    };

    var toBounds = function (points) {
      var minX = Number.POSITIVE_INFINITY;
      var minY = Number.POSITIVE_INFINITY;
      var maxX = Number.NEGATIVE_INFINITY;
      var maxY = Number.NEGATIVE_INFINITY;
      points.forEach(function (pt) {
        minX = Math.min(minX, pt.x);
        minY = Math.min(minY, pt.y);
        maxX = Math.max(maxX, pt.x);
        maxY = Math.max(maxY, pt.y);
      });
      return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
      };
    };

    var seatsByEdge = {
      left: [],
      right: [],
      top: [],
      bottom: []
    };
    var ellipseSeats = [];

    var getRotateCenterInParent = function (seatNode) {
      var transform = ($(seatNode).attr("transform") || "").trim();
      var rotateWithCenter = /rotate\(\s*-?[\d\.]+[\s,]+(-?[\d\.]+)[\s,]+(-?[\d\.]+)\s*\)/.exec(transform);
      if (!rotateWithCenter) return null;
      var cx = Number(rotateWithCenter[1]);
      var cy = Number(rotateWithCenter[2]);
      if (!Number.isFinite(cx) || !Number.isFinite(cy)) return null;
      return { x: cx, y: cy };
    };

    $tableContainer.find("g.eatwithme-seat").each(function (_, seatNode) {
      if (!seatNode || !seatNode.getBBox || !seatNode.getScreenCTM || !seatNode.getScreenCTM()) return;

      var seatCTM = seatNode.getScreenCTM();
      var seatToReference = referenceInv.multiply(seatCTM);
      var seatW = Number($(seatNode).attr("width"));
      var seatH = Number($(seatNode).attr("height"));
      var hasSeatSize = Number.isFinite(seatW) && Number.isFinite(seatH) && seatW > 0 && seatH > 0;

      var localCenterX = 0;
      var localCenterY = 0;
      var localHalfW = 1;
      var localHalfH = 1;
      if (hasSeatSize) {
        localCenterX = seatW / 2;
        localCenterY = seatH / 2;
        localHalfW = Math.max(1, seatW / 2);
        localHalfH = Math.max(1, seatH / 2);
      } else {
        var seatBBox = seatNode.getBBox();
        if (!seatBBox) return;
        localCenterX = seatBBox.x + seatBBox.width / 2;
        localCenterY = seatBBox.y + seatBBox.height / 2;
        localHalfW = Math.max(1, seatBBox.width / 2);
        localHalfH = Math.max(1, seatBBox.height / 2);
      }

      var seatCenterPoint = transformPoint(seatToReference, localCenterX, localCenterY);
      var seatCenterX = seatCenterPoint.x;
      var seatCenterY = seatCenterPoint.y;

      var halfWPoint = transformPoint(seatToReference, localCenterX + localHalfW, localCenterY);
      var halfHPoint = transformPoint(seatToReference, localCenterX, localCenterY + localHalfH);
      var seatHalfW = Math.max(1, Math.sqrt(Math.pow(halfWPoint.x - seatCenterX, 2) + Math.pow(halfWPoint.y - seatCenterY, 2)));
      var seatHalfH = Math.max(1, Math.sqrt(Math.pow(halfHPoint.x - seatCenterX, 2) + Math.pow(halfHPoint.y - seatCenterY, 2)));

      if (isRoundLikeShape) {
        var storedAngle = Number($(seatNode).attr("resize_angle_bk"));
        var measuredAngle = Math.atan2((seatCenterY - borderCenterY) / radiusY, (seatCenterX - borderCenterX) / radiusX);
        var angle = Number.isFinite(storedAngle) ? storedAngle : measuredAngle;
        var outsideOffset = Math.max(1, Math.max(seatHalfW, seatHalfH) / 3);
        var seatParentNode = seatNode.parentNode;
        var rotateCenter = getRotateCenterInParent(seatNode);
        if (!seatParentNode || !seatParentNode.getScreenCTM || !seatParentNode.getScreenCTM() || !seatParentNode.getScreenCTM().inverse) return;
        ellipseSeats.push({
          seatNode: seatNode,
          parentInv: seatParentNode.getScreenCTM().inverse(),
          seatCenterX: seatCenterX,
          seatCenterY: seatCenterY,
          rotateCenterInParentX: rotateCenter ? rotateCenter.x : null,
          rotateCenterInParentY: rotateCenter ? rotateCenter.y : null,
          angle: angle,
          outsideOffset: outsideOffset
        });
        return;
      }

      var dLeft = Math.abs(seatCenterX - borderX);
      var dRight = Math.abs(seatCenterX - (borderX + borderW));
      var dTop = Math.abs(seatCenterY - borderY);
      var dBottom = Math.abs(seatCenterY - (borderY + borderH));

      var edge = "left";
      var minDist = dLeft;
      if (dRight < minDist) {
        minDist = dRight;
        edge = "right";
      }
      if (dTop < minDist) {
        minDist = dTop;
        edge = "top";
      }
      if (dBottom < minDist) {
        edge = "bottom";
      }

      var storedEdge = $(seatNode).attr("resize_edge_bk");
      if (storedEdge === "left" || storedEdge === "right" || storedEdge === "top" || storedEdge === "bottom") {
        edge = storedEdge;
      }

      var outsideOffsetX = seatHalfW / 3;
      var outsideOffsetY = seatHalfH / 3;
      var parentNode = seatNode.parentNode;
      var rotateCenter = getRotateCenterInParent(seatNode);
      if (!parentNode || !parentNode.getScreenCTM || !parentNode.getScreenCTM() || !parentNode.getScreenCTM().inverse) return;
      seatsByEdge[edge].push({
        seatNode: seatNode,
        parentInv: parentNode.getScreenCTM().inverse(),
        seatCenterX: seatCenterX,
        seatCenterY: seatCenterY,
        rotateCenterInParentX: rotateCenter ? rotateCenter.x : null,
        rotateCenterInParentY: rotateCenter ? rotateCenter.y : null,
        outsideOffsetX: outsideOffsetX,
        outsideOffsetY: outsideOffsetY,
        orderValue: (edge === "left" || edge === "right") ? seatCenterY : seatCenterX
      });
    });

    var applySeatTarget = function (seatData, targetCenterInTableX, targetCenterInTableY) {
      var targetCenterInScreen = transformPoint(referenceCTM, targetCenterInTableX, targetCenterInTableY);

      var currentCenterInScreen = transformPoint(referenceCTM, seatData.seatCenterX, seatData.seatCenterY);
      var currentCenterInParent = transformPoint(seatData.parentInv, currentCenterInScreen.x, currentCenterInScreen.y);

      var targetCenterInParent = transformPoint(seatData.parentInv, targetCenterInScreen.x, targetCenterInScreen.y);
      var moveDx = targetCenterInParent.x - currentCenterInParent.x;
      var moveDy = targetCenterInParent.y - currentCenterInParent.y;

      var $seat = $(seatData.seatNode);
      var transform = $seat.attr("transform") || "";
      var translateRegex = /translate\(\s*(-?[\d\.]+)\s*,\s*(-?[\d\.]+)\s*\)/;
      var match = translateRegex.exec(transform);

      if (match) {
        var tx = Number(match[1]) + moveDx;
        var ty = Number(match[2]) + moveDy;
        $seat.attr("transform", transform.replace(translateRegex, "translate(" + tx + "," + ty + ")"));
      } else {
        $seat.attr("transform", "translate(" + moveDx + "," + moveDy + ") " + transform);
      }

      return {
        targetCenterInParentX: targetCenterInParent.x,
        targetCenterInParentY: targetCenterInParent.y
      };
    };

    var setSeatFacingAngle = function (seatData, angleDeg, centerInParentX, centerInParentY) {
      var $seat = $(seatData.seatNode);
      var transform = $seat.attr("transform") || "";
      var rotateRegex = /rotate\(\s*(-?[\d\.]+)(?:[\s,]+-?[\d\.]+[\s,]+-?[\d\.]+)?\s*\)/;
      var rotatePart = "rotate(" + angleDeg + "," + centerInParentX + "," + centerInParentY + ")";

      if (rotateRegex.test(transform)) {
        $seat.attr("transform", transform.replace(rotateRegex, rotatePart));
      } else {
        $seat.attr("transform", (transform ? transform + " " : "") + rotatePart);
      }
    };

    if (isRoundLikeShape) {
      if (!ellipseSeats || ellipseSeats.length === 0) return;

      ellipseSeats.sort(function (a, b) {
        return a.angle - b.angle;
      });

      var fixedFourSeatAngles = [-135, -45, 45, 135].map(function (deg) {
        return (deg * Math.PI) / 180;
      });
      var startAngle = ellipseSeats[0].angle;
      var step = (Math.PI * 2) / ellipseSeats.length;

      ellipseSeats.forEach(function (seatData, index) {
        var spreadAngle = ellipseSeats.length === 4 ? fixedFourSeatAngles[index] : startAngle + step * index;
        var cosA = Math.cos(spreadAngle);
        var sinA = Math.sin(spreadAngle);
        var boundaryX = borderCenterX + radiusX * cosA;
        var boundaryY = borderCenterY + radiusY * sinA;

        // Use the ellipse normal so chairs stay outside even on stretched circles.
        var nx = cosA / radiusX;
        var ny = sinA / radiusY;
        var nLen = Math.sqrt(nx * nx + ny * ny) || 1;
        nx /= nLen;
        ny /= nLen;

        var targetCenterInTableX = boundaryX + nx * seatData.outsideOffset;
        var targetCenterInTableY = boundaryY + ny * seatData.outsideOffset;
        var placed = applySeatTarget(seatData, targetCenterInTableX, targetCenterInTableY);
        if (placed) {
          var faceCenterDeg = (spreadAngle * 180) / Math.PI;
          setSeatFacingAngle(seatData, faceCenterDeg + 90, placed.targetCenterInParentX, placed.targetCenterInParentY);
        }
      });
      return;
    }

    ["left", "right", "top", "bottom"].forEach(function (edge) {
      var seats = seatsByEdge[edge];
      if (!seats || seats.length === 0) return;

      seats.sort(function (a, b) {
        return a.orderValue - b.orderValue;
      });

      var count = seats.length;
      var cornerMarginUnits = 0.5;
      var distributionDenominator = Math.max(1, (count - 1) + (2 * cornerMarginUnits));
      seats.forEach(function (seatData, index) {
        var ratio = (index + cornerMarginUnits) / distributionDenominator;
        var targetCenterInTableX = seatData.seatCenterX;
        var targetCenterInTableY = seatData.seatCenterY;

        if (edge === "left") {
          targetCenterInTableX = borderX - seatData.outsideOffsetX;
          targetCenterInTableY = borderY + borderH * ratio;
        } else if (edge === "right") {
          targetCenterInTableX = borderX + borderW + seatData.outsideOffsetX;
          targetCenterInTableY = borderY + borderH * ratio;
        } else if (edge === "top") {
          targetCenterInTableX = borderX + borderW * ratio;
          targetCenterInTableY = borderY - seatData.outsideOffsetY;
        } else {
          targetCenterInTableX = borderX + borderW * ratio;
          targetCenterInTableY = borderY + borderH + seatData.outsideOffsetY;
        }

        applySeatTarget(seatData, targetCenterInTableX, targetCenterInTableY);
      });
    });
  },

  refreshEditModeResizeCorners: function ($scope) {
    var containers = $scope && $scope.length > 0 ? $scope.find("g.eatwithme-table, g.eatwithme-room") : $("svg[visible='true'] g.eatwithme-table, svg[visible='true'] g.eatwithme-room");
    containers.each(function (_, containerNode) {
      var $container = $(containerNode);
      $container.find("circle.eatwithme-resize-corner").remove();

      if ($container.hasClass("eatwithme-table") && tableLayout.isPoolTableResizeLocked($container)) return;

      var $shapeCandidates = $container.find("rect, ellipse, path");
      // Person tables are composed from multiple paths; use all of them for corner bounds.
      if ($container.hasClass("eatwithme-table") && $container.find(".person").length > 0) {
        $shapeCandidates = $container.find(".person rect, .person ellipse, .person path");
      }

      var shape = $shapeCandidates.get(0);
      if (!shape) return;
      var shapeTag = (shape.tagName || "").toLowerCase();
      if (shapeTag === "ellipse") return;

      var bbox = null;
      if ($shapeCandidates.length <= 1) {
        bbox = tableLayout.getShapeBoundsInTableCoords($container, shape);
      } else {
        $shapeCandidates.each(function (_, shapeNode) {
          var shapeBounds = tableLayout.getShapeBoundsInTableCoords($container, shapeNode);
          if (!shapeBounds) return;
          if (!bbox) {
            bbox = {
              x: Number(shapeBounds.x || 0),
              y: Number(shapeBounds.y || 0),
              width: Number(shapeBounds.width || 0),
              height: Number(shapeBounds.height || 0)
            };
            return;
          }

          var minX = Math.min(bbox.x, Number(shapeBounds.x || 0));
          var minY = Math.min(bbox.y, Number(shapeBounds.y || 0));
          var maxX = Math.max(bbox.x + bbox.width, Number(shapeBounds.x || 0) + Number(shapeBounds.width || 0));
          var maxY = Math.max(bbox.y + bbox.height, Number(shapeBounds.y || 0) + Number(shapeBounds.height || 0));
          bbox.x = minX;
          bbox.y = minY;
          bbox.width = maxX - minX;
          bbox.height = maxY - minY;
        });
      }
      if (!bbox) return;
      var x = Number(bbox.x || 0);
      var y = Number(bbox.y || 0);
      var width = Number(bbox.width || 0);
      var height = Number(bbox.height || 0);
      if (width <= 0 || height <= 0) return;

      var r = tableLayout.editModeCornerRadius;
      var shapeCtm = shape.getScreenCTM();
      var rotationDeg = shapeCtm ? (Math.atan2(shapeCtm.b, shapeCtm.a) * (180 / Math.PI)) : 0;
      var corners = [
        { x: x, y: y, left: true, right: false, top: true, bottom: false },
        { x: x + width, y: y, left: false, right: true, top: true, bottom: false },
        { x: x, y: y + height, left: true, right: false, top: false, bottom: true },
        { x: x + width, y: y + height, left: false, right: true, top: false, bottom: true }
      ];

      corners.forEach(function (corner) {
        var cursor = tableLayout.getResizeCursorByEdges({
          left: corner.left,
          right: corner.right,
          top: corner.top,
          bottom: corner.bottom,
          rotationDeg: rotationDeg
        }) || "move";
        var cornerNode = tableLayout.makeSVG("circle", {
          class: "eatwithme-resize-corner",
          cx: corner.x,
          cy: corner.y,
          r: r,
          fill: tableLayout.editModeCornerFill,
          stroke: tableLayout.editModeCornerStroke,
          "stroke-width": 2,
          opacity: 1,
          "pointer-events": "all",
          cursor: cursor,
          "data-resize-left": corner.left ? "true" : "false",
          "data-resize-right": corner.right ? "true" : "false",
          "data-resize-top": corner.top ? "true" : "false",
          "data-resize-bottom": corner.bottom ? "true" : "false"
        });
        $container.append(cornerNode);
      });
    });
  },

  isPoolTableResizeLocked: function ($target) {
    if (!$target || $target.length === 0) return false;

    var $table = $target.hasClass("eatwithme-table") ? $target : $target.find("g.eatwithme-table").first();
    if ($table.length === 0) return false;

    var $personGroup = $table.find("g.person").first();
    if ($personGroup.length === 0) return false;

    var personTransform = ($personGroup.attr("transform") || "").replace(/\s+/g, "").toLowerCase();
    if (personTransform.indexOf("scale(.01,.01)") !== -1 || personTransform.indexOf("scale(0.01,0.01)") !== -1) {
      return true;
    }

    if ($personGroup.find('rect[x="480"][y="480"][width="11000"][height="5700"]').length > 0) {
      return true;
    }

    return false;
  },

  getResizeEdges: function (event, $target) {
    if (!$target || $target.length === 0) return null;
    if ($target.find("g.eatwithme-table, g.eatwithme-room").length === 0 && !$target.hasClass("eatwithme-table") && !$target.hasClass("eatwithme-room")) return null;
    if (event.originalEvent == null) return null;

    if (tableLayout.isPoolTableResizeLocked($target)) return null;

    var shape = $target.hasClass("eatwithme-table") ? $target.find("rect,ellipse,path").get(0) : $target.find(".eatwithme-table rect,.eatwithme-table ellipse,.eatwithme-table path, .eatwithme-room rect").get(0);

    var personPathNode = $target.find(".eatwithme-table .person path").first().get(0);
    if (personPathNode) {
      shape = personPathNode;
    }
    if (!shape) return null;
    var shapeTag = (shape.tagName || "").toLowerCase();
    if (shapeTag === "ellipse") return null;

    var eventTarget = event.originalEvent.target;
    if (eventTarget && eventTarget.classList && eventTarget.classList.contains("eatwithme-resize-corner") && ($target.is(eventTarget) || $target.has(eventTarget).length > 0)) {
      var $corner = $(eventTarget);
      var cornerShape = shape;
      var cornerRotationDeg = 0;
      if (cornerShape) {
        var cornerCtm = cornerShape.getScreenCTM();
        if (cornerCtm) {
          cornerRotationDeg = Math.atan2(cornerCtm.b, cornerCtm.a) * (180 / Math.PI);
        }
      }
      return {
        left: $corner.attr("data-resize-left") === "true",
        right: $corner.attr("data-resize-right") === "true",
        top: $corner.attr("data-resize-top") === "true",
        bottom: $corner.attr("data-resize-bottom") === "true",
        rotationDeg: cornerRotationDeg
      };
    }

    var clientX = event.originalEvent.clientX;
    var clientY = event.originalEvent.clientY;
    if (clientX == null || clientY == null) return null;

    var ctm = shape.getScreenCTM();
    if (!ctm || !ctm.inverse) return null;

    var svgRoot = shape.ownerSVGElement;
    if (!svgRoot || !svgRoot.createSVGPoint) return null;

    var point = svgRoot.createSVGPoint();
    point.x = clientX;
    point.y = clientY;
    var localPoint = point.matrixTransform(ctm.inverse());

    var bbox = shape.getBBox();
    var x = Number(bbox.x || 0);
    var y = Number(bbox.y || 0);
    var width = Number(bbox.width || 0);
    var height = Number(bbox.height || 0);
    if (width <= 0 || height <= 0) return null;

    var cornerHitPx = Number(tableLayout.editModeResizeCornerHitPx);
    if (Number.isNaN(cornerHitPx)) cornerHitPx = 6;

    var scaleX = Math.sqrt(ctm.a * ctm.a + ctm.b * ctm.b) || 1;
    var scaleY = Math.sqrt(ctm.c * ctm.c + ctm.d * ctm.d) || 1;
    // Keep the corner reaction area intentionally small so edges do not feel draggable.
    var toleranceX = Math.max(1, cornerHitPx / scaleX);
    var toleranceY = Math.max(1, cornerHitPx / scaleY);

    var minX = x - toleranceX;
    var maxX = x + width + toleranceX;
    var minY = y - toleranceY;
    var maxY = y + height + toleranceY;
    if (localPoint.x < minX || localPoint.x > maxX || localPoint.y < minY || localPoint.y > maxY) return null;

    var nearLeft = Math.abs(localPoint.x - x) <= toleranceX;
    var nearRight = Math.abs(localPoint.x - (x + width)) <= toleranceX;
    var nearTop = Math.abs(localPoint.y - y) <= toleranceY;
    var nearBottom = Math.abs(localPoint.y - (y + height)) <= toleranceY;

    // In edit mode only corner resize should be possible from shape hit-testing.
    // Side-only hits are ignored so users cannot resize from edges.
    var nearHorizontal = nearLeft || nearRight;
    var nearVertical = nearTop || nearBottom;
    if (!(nearHorizontal && nearVertical)) return null;

    var rotationDeg = Math.atan2(ctm.b, ctm.a) * (180 / Math.PI);

    return {
      left: nearLeft,
      right: nearRight,
      top: nearTop,
      bottom: nearBottom,
      rotationDeg: rotationDeg
    };
  },

  isResizeDragStart: function (event, $target) {
    return tableLayout.getResizeEdges(event, $target) != null;
  },

  editMode: function (active) {
    if (active && tableLayout.roomView) {
      return;
    }
    tableLayout.table_edit_mode = active;
    if (active) {
      document.onmousewheel = null;
      tableLayout.clearAnnotations(true);
      var seats = $(".eatwithme-seat");
      var rooms = $(".eatwithme-roomName");
      seats.addClass("selectable");
      rooms.addClass("selectable");
      var numbers = $(".eatwithme-tableNumber");
      numbers.addClass("selectable");
      numbers.attr("level", 3);
      tableLayout.originalOnKeyDown = document.onkeydown;
      document.onkeydown = tableLayout.keypressHandler;
      seats.on("click", this.clickSelectHandler);
      rooms.on("click", this.clickSelectHandler);
      numbers.on("click", this.clickSelectHandler);
      var s = $(".selectable");
      s.off("click", clickHandler123);
      s.on("click", this.clickSelectHandler);
      tableLayout.initTableDraggable();
      tableLayout.bindRoomActionButtons();
      tableLayout.applyEditModeTableHandles(true);
      tableLayout.enableTableMarqueeSelection();
      tableLayout.centralizeTables();
      tableLayout.renderLayoutModeControls();
      tableLayout.renderLayoutCreateControls();
    } else {
      tableLayout.hideTableActionButtons();
      tableLayout.hideSeatActionButtons();
      tableLayout.hideRoomActionButtons();
      tableLayout.applyEditModeTableHandles(false);
      tableLayout.disableTableMarqueeSelection();
      $("svg[visible='true'] g.eatwithme-table.ui-selected").removeClass("ui-selected");
      $("svg[visible='true'] g.eatwithme-room.ui-selected").removeClass("ui-selected");
      // eslint-disable-next-line no-restricted-globals
      //location.reload();
      var s = $(".selectable");
      var seats = $(".eatwithme-seat");
      var rooms = $(".eatwithme-roomName");
      var numbers = $(".eatwithme-tableNumber");
      seats.off("click", this.clickSelectHandler);
      rooms.off("click", this.clickSelectHandler);
      numbers.off("click", this.clickSelectHandler);
      s.off("click", this.clickSelectHandler);
      s.on("click", clickHandler123);

      tableLayout.reset();
      tableLayout.initialize();
      tableLayout.updateTableOccupations();
      document.onkeydown = tableLayout.originalOnKeyDown;
      tableLayout.renderLayoutModeControls();
      tableLayout.renderLayoutCreateControls();
    }
  },

  centralizeTables: function () {
    var svg = $($("svg[visible='true']")[0]);
    var viewport = svg.get(0).viewBox.baseVal;
    var svgRect = svg.get(0).getBoundingClientRect();
    /*
     * var w = svg.attr('width').replace('px', '') /
     * svg.css('width').replace('px', ''); var h =
     * svg.attr('height').replace('px', '') /
     * svg.css('height').replace('px', '');
     */
    var w = viewport.width / svgRect.width;
    var h = viewport.height / svgRect.height;
    var z = Math.max(w, h);

    /*
    $(tableLayout.SVG)
      .find("tspan.eatwithme-tableNumber")
      .each(function (int, tspan) {
        $(tspan).attr("x", 0);
        $(tspan).attr("y", 0);
      });
  */
    $($(tableLayout.SVG).find("> g > g")).each(function (int, g) {
      if ($(g).find(".eatwithme-table").length > 0) {
        var rect = $(g).get(0).getBBox();
        var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec($(g).attr("transform"));
        var translateX = matches == null ? 0 : Number(matches[1]);
        var translateY = matches == null ? 0 : Number(matches[2]);
        var centerX = translateX + rect.x + rect.width / 2;
        var centerY = translateY + rect.y + rect.height / 2;

        var rotate = 0;
        var $t = $(g).find("g.eatwithme-table");
        var transform = $t.attr("transform");
        while ($t.get(0).localName != "svg") {
          var regexp = /rotate\((-?[\d\.]+)\)/g;
          while ((matches = regexp.exec(transform))) {
            rotate += parseFloat(matches[1]);
          }
          $t = $t.parent();
          transform = $t.attr("transform");
        }
        var transform = $(g).attr("transform");

        var angle = rotate * (Math.PI / 180); // Convert to
        // radians
        /*
        var rotatedX = Math.round(Math.cos(angle) * shiftX - Math.sin(angle) * shiftY);
        var rotatedY = Math.round(Math.sin(angle) * shiftX + Math.cos(angle) * shiftY);
     
        let shiftX = rotatedX;
        let shiftY = rotatedY;
        */

        var matches = /translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(transform);
        var translateX = matches == null ? 0 : Number(matches[1]);
        var translateY = matches == null ? 0 : Number(matches[2]);
        var shiftX = centerX - translateX;
        var shiftY = centerY - translateY;

        $(g).attr("width", rect.width);
        $(g).attr("height", rect.height);

        var wh = function (child, scaleX, scaleY) {


          var transform = $(child).attr("transform");
          var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec(transform);
          if (matches != null) {
            scaleX = parseFloat(matches[1]) * scaleX;
            scaleY = parseFloat(matches[2]) * scaleY;
          }

          var rect = child.getBBox();
          $(child).attr("width", rect.width * scaleX);
          $(child).attr("height", rect.height * scaleY);
          $(child).attr("width1", rect.width);
          $(child).attr("height1", rect.height);
          $(child).attr("scaleX", scaleX);
          $(child).attr("scaleY", scaleY);

          $(child)
            .children("g")
            .each(function (ind, child) {
              wh(child, scaleX, scaleY);
            });
        };
        $(g)
          .children()
          .each(function (ind, child) {
            wh(child, 1, 1);
          });


        if (Math.abs(shiftX) < 1 && Math.abs(shiftY) < 1) return;


        var newTranslateX = translateX + shiftX;
        var newTranslateY = translateY + shiftY;
        newTranslateX += viewport.x;
        newTranslateY += viewport.y;
        newTranslateX = centerX;
        newTranslateY = centerY;
        var newTransform = transform.replace(/translate\((-?[\d\.]+),(-?[\d\.]+)\)/, "translate(" + newTranslateX + "," + newTranslateY + ")");
        $(g).attr("transform", newTransform);


        var shift = function (child, shiftX, shiftY) {


          var transform = $(child).attr("transform");
          var matchesTransform = /^translate\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(transform);
          var matches = /scale\((-?[\d\.]+),(-?[\d\.]+)\)/.exec(transform);
          if (matches == null) {
          } else {
            // shiftX = Number(matches[1])*shiftX;
            // shiftY = Number(matches[2])*shiftY;
          }
          var newTransform = null;
          if (matchesTransform == null) newTransform = "translate(" + shiftX + "," + shiftY + ") " + (transform ? transform : "");
          else {
            var X = Number(matchesTransform[1]) + shiftX;
            var Y = Number(matchesTransform[2]) + shiftY;
            newTransform = transform.replace(/^translate\((-?[\d\.]+),(-?[\d\.]+)\)/, "translate(" + X + "," + Y + ")");
          }
          if (newTransform.indexOf("undefined") != -1) {
            console.log(newTransform);
          }
          $(child).attr("transform", newTransform);

          /*
           * return; $(child).children().each(function(ind, child) {
           * shift(child, newShiftX, newShiftY); });
           */
        };
        $(g)
          .children()
          .each(function (ind, child) {
            shift(child, -shiftX, -shiftY);
          });
      }
    });
  },

  mousewheelHandler: function (event) {
    return;
  },

  getSelectedTableNumberTextTarget: function () {
    var $selectedNumber = $("svg tspan.eatwithme-tableNumber.selected").first();
    if ($selectedNumber.length) {
      return $selectedNumber.parent();
    }

    var $selectedText = $("svg text.selected").filter(function () {
      return $(this).find("tspan.eatwithme-tableNumber").length > 0;
    }).first();
    if ($selectedText.length) {
      return $selectedText;
    }

    return $();
  },

  scaleSvgTarget: function ($target, scale) {
    if (!$target || $target.length === 0) return;

    var $scaled = $target;
    var isTableNumberTextTarget = $scaled.is("text") && $scaled.find("tspan.eatwithme-tableNumber").length > 0;
    var isRoomNameTextTarget = $scaled.is("text") && $scaled.hasClass("eatwithme-roomName");
    if ($scaled.hasClass("eatwithme-table") || $scaled.hasClass("eatwithme-tableNumber") || $scaled.hasClass("eatwithme-room")) {
      $scaled = $scaled.parent();
    }
    if (!$scaled || $scaled.length === 0) return;

    if (isRoomNameTextTarget) {
      var roomBox = $scaled.get(0).getBBox ? $scaled.get(0).getBBox() : null;
      if (roomBox && Number.isFinite(roomBox.width) && Number.isFinite(roomBox.height) && roomBox.width > 0 && roomBox.height > 0) {
        var roomCenterX = Number(roomBox.x || 0) + Number(roomBox.width || 0) / 2;
        var roomCenterY = Number(roomBox.y || 0) + Number(roomBox.height || 0) / 2;
        var roomTransform = $scaled.attr("transform") || "";
        var roomScaleTransform = "translate(" + roomCenterX + "," + roomCenterY + ") scale(" + scale + "," + scale + ") translate(" + (-roomCenterX) + "," + (-roomCenterY) + ")";
        $scaled.attr("transform", (roomTransform ? roomTransform + " " : "") + roomScaleTransform);
        if (tableLayout.table_edit_mode) {
          var $roomContainer = $scaled.closest("g.ui-draggable").filter(function () {
            return $(this).find("g.eatwithme-room").length > 0;
          }).first();
          if ($roomContainer.length > 0) {
            tableLayout.refreshEditModeResizeCorners($roomContainer);
          }
        }
      }
      return;
    }

    var transform = $scaled.attr("transform") || "scale(1,1)";
    var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec(transform);
    if (matches != null) {
      var scaleX = parseFloat(matches[1]) * scale;
      var scaleY = parseFloat(matches[2]) * scale;
      transform = transform.replace(/scale\(([\d\.]+),([\d\.]+)\)/, "scale(" + scaleX + "," + scaleY + ")");
      $scaled.attr("transform", transform);
    } else {
      $scaled.attr("transform", transform + " scale(" + scale + "," + scale + ") ");
    }

    if (tableLayout.table_edit_mode && ($scaled.find("g.eatwithme-table").length > 0 || $scaled.find("g.eatwithme-room").length > 0)) {
      tableLayout.refreshEditModeResizeCorners($scaled);
    }

    if (isTableNumberTextTarget) {
      var $tableContainer = $scaled.closest("g.ui-draggable").filter(function () {
        return $(this).find("g.eatwithme-table").length > 0;
      }).first();
      if ($tableContainer.length > 0) {
        tableLayout.centerTableNumberAfterResize($tableContainer);
      }
    }
  },

  keypressHandler: function (event) {
    if (event.key === "+" || event.key === "-") {
      let $selectedNumberText = tableLayout.getSelectedTableNumberTextTarget();
      if ($selectedNumberText.length) {
        tableLayout.scaleSvgTarget($selectedNumberText, event.key === "+" ? 1.1 : 0.9);
        return;
      }

      let $selected = $($("svg[visible = 'true'] .selected").get(0));
      if ($selected.length) {
        tableLayout.scaleSvgTarget($selected, event.key === "+" ? 1.1 : 0.9);
      } else {
        if (event.key === "+") {
          tableLayout.zoomFloorplan("+");
        } else if (event.key === "-") {
          tableLayout.zoomFloorplan("-");
        }
      }
      return;
    }
    if (event.shiftKey == true) {
      let $selected = $("svg .selected");
      var $t = $selected;
      if ($t.hasClass("eatwithme-tableNumber")) $t = $t.parent();
      if ($t != undefined) {
        // if ($selected.hasClass('eatwithme-table'))
        // $selected = $($selected.find('g').get(0));
        var sX = event.key == "ArrowRight" ? 1.1 : event.key == "ArrowLeft" ? 0.9 : 1;
        var sY = event.key == "ArrowUp" ? 1.1 : event.key == "ArrowDown" ? 0.9 : 1;
        if (sX == 1 && sY == 1) return;
        var transform = $t.attr("transform");
        if (typeof transfrom != "undefined") transform = "";
        var matches = /scale\(([\d\.]+),([\d\.]+)\)/.exec(transform);
        if (matches != null) {
          var scaleX = parseFloat(matches[1]) * sX;
          var scaleY = parseFloat(matches[2]) * sY;
          transform = transform.replace(/scale\(([\d\.]+),([\d\.]+)\)/, "scale(" + scaleX + "," + scaleY + ")");
          $t.attr("transform", transform);
        } else {
          $t.attr("transform", "scale(" + sX + "," + sY + ") " + transform);
        }
      }
    }
  },

  zoomFloorplan: (key) => {
    const svg = $("svg[visible='true']");
    if (!svg || svg.length === 0) return;
    const box = svg.attr("viewBox").split(" ");
    const x = Number(box[0]);
    const y = Number(box[1]);
    const w = Number(box[2]);
    const h = Number(box[3]);

    var fitBounds = null;
    try {
      var root = svg.find("> g#svg-g").get(0);
      if (root && root.getBBox) {
        var bb = root.getBBox();
        if (bb && Number.isFinite(bb.width) && Number.isFinite(bb.height) && bb.width > 0 && bb.height > 0) {
          var fitPadding = 12;
          fitBounds = {
            x: Number(bb.x || 0) - fitPadding,
            y: Number(bb.y || 0) - fitPadding,
            w: Number(bb.width || 0) + fitPadding * 2,
            h: Number(bb.height || 0) + fitPadding * 2
          };
        }
      }
    } catch (ex) {
      fitBounds = null;
    }

    var x1 = x, y1 = y, w1 = w, h1 = h;
    if (key === "+") {
      x1 -= w / 20;
      y1 -= h / 20;
      w1 += w / 10;
      h1 += h / 10;
      svg.attr("viewBox", x1 + " " + y1 + " " + w1 + " " + h1);
    } else if (key === "-") {
      if (fitBounds && x >= fitBounds.x && y >= fitBounds.y && w <= fitBounds.w && h <= fitBounds.h) {
        return;
      }

      x1 += w / 20;
      y1 += h / 20;
      w1 -= w / 10;
      h1 -= h / 10;

      if (fitBounds && x1 >= fitBounds.x && y1 >= fitBounds.y && w1 <= fitBounds.w && h1 <= fitBounds.h) {
        x1 = fitBounds.x;
        y1 = fitBounds.y;
        w1 = fitBounds.w;
        h1 = fitBounds.h;
      }

      svg.attr("viewBox", x1 + " " + y1 + " " + w1 + " " + h1);
    }
  },

  clearTableAnnotations: function (tableNumber) {
    var tables = $("g#" + tableNumber + ".eatwithme-table");
    //tables.attr("tableOccupations", null);

    //tables.removeClass();
    //tables.addClass("eatwithme-table");
    //tables.addClass("selectable");
    tables.each(function (ind, table) {
      table = $(table);
      var tableNumber = table.attr("id");
      var t = getTable(tableNumber);
      table.find(".eatwithme-seat").each(function (ind, t) {
        $(t).attr("id", tableNumber + "-" + (ind + 1));
        //$(t).addClass("selectable");
        $(t).click(auth.clickHandler);
      });
      table.find(".eatwithme-tableNumber").attr("id", tableNumber + "-number");
      table.find("tspan.eatwithme-tableNumber").parent().attr("transform_old", null);
    });

    tables.attr("level", 2);

    $(".context-menu-active").removeClass("context-menu-active");
    tables.attr("transform_bk", null);
    //$("div#c svg .svgadded").remove();
    $("g[transform_bk]").attr("transform_bk", null);
    //var seats = $(".eatwithme-seat");
    //seats.removeClass("occupied");
    //seats.removeClass("selected");
  },
  clearAnnotations: function (full) {
    $("#homedelivery-switch").remove();
    $("#pickup-switch").remove();
    $("#homedelivery-auto-switch").remove();
    $("#pickup-auto-switch").remove();
    $("div#c svg .selectable").removeClass("selectable");
    $("div#c svg .selected").removeClass("selected");
    //$("div#c svg > g").addClass("selectable");
    $("div#c svg > g").attr("level", 1);
    $("div#c svg > g").attr("id", "svg-g");
    $("div#c svg").addClass("selectable");
    $("div#c svg").attr("level", 0);
    $("div#c svg > .table-connections").remove();
    $("div#c svg circle.eatwithme-resize-corner").remove();
    $(".eatwithme-table rect").removeClass("eatwithme-table");
    $("tspan.eatwithme-table").removeClass("eatwithme-table");
    var tables = $("g.eatwithme-table");
    tables.attr("tableOccupations", null);
    tables.removeClass();
    tables.addClass("eatwithme-table");
    tables.removeClass("pickup");
    tables.removeClass("homedelivery");
    tables.addClass("selectable");
    tables.each(function (ind, table) {
      table = $(table);
      var tableNumber = table.attr("id");
      var t = getTable(tableNumber);
      if (t) {
        if (!t.isActive) {
          table.addClass("inactive");
        }
      }
      table.find(".eatwithme-seat").each(function (ind, t) {
        $(t).attr("id", tableNumber + "-" + (ind + 1));
        $(t).addClass("selectable");
        $(t).click(auth.clickHandler);
      });
      table.find(".eatwithme-tableNumber").attr("id", tableNumber + "-number");
      table
        .find("tspan.eatwithme-tableNumber")
        .parent()
        .attr("transform_old", null);
    });


    tables.attr("level", 2);

    $(".context-menu-active").removeClass("context-menu-active");
    tables.attr("transform_bk", null);
    $("div#c svg .svgadded").remove();
    $("g[transform_bk]").attr("transform_bk", null);
    var seats = $(".eatwithme-seat");
    seats.removeClass("occupied");
    seats.removeClass("selected");
  },
  editTableHandler: null,
  editTable: function (data, trigger, handler) {
    const layout = trigger.parents("g.ui-draggable").attr("layout") || data.layout;
    tableLayout.editTableHandler = handler;
    tableLayout.editTableTrigger = trigger;
    var modal = $("div#editTableData.modal");

    const seats = data.seats || trigger.parents("g.ui-draggable").find(".eatwithme-seat").length;

    modal.find(".svg label.active").removeClass("active");
    modal.find(".svg input:checked").prop("checked", false);
    //modal.find(".svg label#" + layout).addClass("active");
    modal.find(".svg input[name='svgoptions']#" + layout).prop("checked", true);
    modal.show();
    modal.find("#id").val(data.id);
    modal.find("#number").val(data.number || findSmallestMissingPositiveNumber());
    modal.find("#name").val(data.name);
    modal.find("#type").val(data.type);
    modal.find("#seats").val(seats);
    modal.find(`#epd option`).prop("selected", false);
    modal.find(`#epd option[value = '${data.epdSerialNumber}']`).prop("selected", true);
    if (data.shareable == true) modal.find("#shareable").prop("checked", "true");
    else modal.find("#shareable").removeAttr("checked");
    if (data.visibleOnline == true) modal.find("#visibleOnline").prop("checked", "true");
    else modal.find("#visibleOnline").removeAttr("checked");
    if (data.bookOnline == true) modal.find("#bookOnline").prop("checked", "true");
    else modal.find("#bookOnline").removeAttr("checked");
    if (typeof data.isActive === "undefined") {
      modal.find("#active").prop("checked", true);
    } else if (data.isActive == true) {
      modal.find("#active").prop("checked", "true");
    } else {
      modal.find("#active").removeAttr("checked");
    }
    modal.find("#freeSeats").val(data.freeSeats);
    $("#freeSeatsFormGroup").show();
  },
  editRoomHandler: null,
  editRoom: function (data, handler) {
    tableLayout.editRoomHandler = handler;
    var modal = $("div#editRoom.modal");
  },

  saveTable: function () {

    var modal = $("div#editTableData.modal");
    var tableNumber = Number(modal.find("input#number").val());

    if (!tableNumber)
      return false;

    var existingTables = $('svg[visible = "true"] g#' + tableNumber + ".eatwithme-table").filter((ind, t) => {
      return !tableLayout.editTableTrigger.is($(t))
    });

    if (existingTables.length > 0) {
      messageDialog(I18n.t('local.information'), I18n.t('admin_local.there_already_exists_a_table_with_this_number'));
      return false;
    }

    var tableName = modal.find("input#name").val();
    var seats = modal.find("input#seats").val();
    var type = modal.find("input#type").val();
    var shareable = modal.find("input#shareable").prop("checked");
    var visibleOnline = modal.find("input#visibleOnline").prop("checked");
    var bookOnline = modal.find("input#bookOnline").prop("checked");
    var active = modal.find("input#active").prop("checked");
    var layout = modal.find(".svg input[name='svgoptions']:checked").prop("id");
    var epdSerialNumber = modal.find("select#epd option:selected").prop("value");
    var table = getTable(tableNumber);
    if (table == undefined || table == null) {
      table = {
        pos: false,
        forStore: null,
        room: null,
        extensions: ""
      };
    }
    if (Number(tableNumber) > 0 && Number(seats) > 0) {
      tableLayout.editTableHandler({
        tableNumber: tableNumber,
        room: table.room ? table.room : table.roomId ? { id: table.roomId } : undefined,
        seats: seats,
        type: type,
        name: tableName,
        shareable: shareable,
        visibleOnline: visibleOnline,
        bookOnline: bookOnline,
        active: active,
        pos: table.pos,
        kiosk: table.kiosk,
        forStore: table.forStore,
        extensions: table.extensions,
        layout: layout,
        epdSerialNumber
      });
      $("div#editTableData.modal").modal("hide");
      return true;
    } else return false;
  },

  saveRoom: function () {
    var modal = $("div#editRoom.modal");
    var room = String(modal.find("input#room").val() || "").trim();
    if (room.length === 0) {
      return false;
    }
    tableLayout.editRoomHandler({ room: room });
    $("div#editRoom.modal").modal("hide");
    return true;
  },

  reloadTables: function (reset = true, done) {
    ajaxCallStart("processing");
    admin.getTables(function (tableLayouts) {
      auth.myStatus.restaurant_tables = tableLayouts.restaurantTables;
      store.dispatch(EatWithMeActions.updateRestaurantTables(tableLayouts.restaurantTables));
      ajaxCallEnd("processing");

      if (reset) {
        tableLayout.reset();
        tableLayout.initialize();
      }

      tableLayout.tables = tableLayouts.restaurantTables;
      tableLayouts.restaurantTables.forEach(function (table) {
        tableLayout.tableMap.set(Number(table.number), table);
      });

      if (reset)
        tableLayout.updateTableOccupations();

      if (typeof done === "function") {
        done(tableLayouts);
      }

    });
  },
  initTemplates: () => {
    var normalizeTemplateSvgOrigin = function (templateSvg) {
      if (!templateSvg || typeof templateSvg !== "string" || typeof DOMParser === "undefined") return templateSvg;

      var parser = new DOMParser();
      var xmlDoc;
      try {
        xmlDoc = parser.parseFromString('<svg xmlns="http://www.w3.org/2000/svg">' + templateSvg + '</svg>', "image/svg+xml");
      } catch (ex) {
        return templateSvg;
      }

      var parsedSvg = xmlDoc && xmlDoc.documentElement;
      var rootNode = parsedSvg && parsedSvg.firstElementChild;
      if (!rootNode || !document || !document.body || !document.createElementNS) return templateSvg;

      var measureSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      measureSvg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      measureSvg.style.position = "absolute";
      measureSvg.style.left = "-99999px";
      measureSvg.style.top = "-99999px";
      measureSvg.style.width = "0";
      measureSvg.style.height = "0";
      measureSvg.style.opacity = "0";
      measureSvg.style.pointerEvents = "none";
      measureSvg.style.overflow = "visible";

      var cloned = rootNode.cloneNode(true);
      measureSvg.appendChild(cloned);
      document.body.appendChild(measureSvg);

      try {
        var bbox = cloned.getBBox ? cloned.getBBox() : null;
        if (!bbox || !Number.isFinite(bbox.x) || !Number.isFinite(bbox.y) || !Number.isFinite(bbox.width) || !Number.isFinite(bbox.height)) {
          return templateSvg;
        }

        var shiftX = -bbox.x;
        var shiftY = -bbox.y;
        var hasOffset = Math.abs(shiftX) > 0.001 || Math.abs(shiftY) > 0.001;
        if (hasOffset) {
          var existingTransform = cloned.getAttribute("transform") || "";
          cloned.setAttribute("transform", "translate(" + shiftX + "," + shiftY + ") " + existingTransform);
        }

        cloned.setAttribute("width", String(Math.max(1, bbox.width)));
        cloned.setAttribute("height", String(Math.max(1, bbox.height)));

        return new XMLSerializer().serializeToString(cloned);
      } catch (ex) {
        return templateSvg;
      } finally {
        if (measureSvg.parentNode) {
          measureSvg.parentNode.removeChild(measureSvg);
        }
      }
    };

    tableLayout.roomTemplates = {
      room: {
        name: I18n.t("admin_local.room"),
        svg:
          '<g width="128.667" height="75.667" transform="scale(1,1) translate(0,0)" class="eatwithme-room ui-draggable ui-draggable-handle">' +
          '<rect width="91.167" height="75.667" id="2" stroke="black" fill="transparent">' +
          '</rect>' +
          '<text width="85.33333333333333" height="24.999998092651367" transform="scale(1,1) translate(0,22.41666762034098)" xml:space="preserve" class="eatwithme-roomName ui-draggable ui-draggable-handle">' +
          '<tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="22.22222222222222" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="26.612" text-anchor="start" y="20" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="2" seatnumber="2">' +
          '</tspan>' +
          '</text>' +
          '</g>',
        icon: "add"
      }
    }
    tableLayout.tableTemplates = {
      new_rectangle_table_2: {
        name: I18n.t("admin_local.table_types.rectangle_two_seats"),
        svg:
          '<g width="128.667" height="75.667" transform="scale(1,1) translate(0,0)"><g width="128.667" height="34.333" transform="scale(1,1) translate(0,22.167)"><g width="128.667" height="34.333" transform="scale(1,1) translate(0,0)"><g width="22.833" height="34.167" transform="scale(1,1) translate(0,0.167)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="2" eatwithme-seat-number="1" style="position: relative;"><g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)"><g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)"><g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.5" height="34.333" transform="scale(1,1) translate(106.167,0)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="2" eatwithme-seat-number="2" style="position: relative;"><g width="22.5" height="34.333" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.5" transform="scale(1,1) translate(-5.667,5.833)"><g transform="rotate(90,16.833,11.25) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.093 a2.093,2.093 0 0,1 2.093,-2.093 l29.481,0 a2.093,2.093 0 0,1 2.093,2.093 l0,18.314 a2.093,2.093 0 0,1 -2.093,2.093 l-29.481,0 a2.093,2.093 0 0,1 -2.093,-2.093 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.167" transform="scale(1,1) translate(-8.5,8.5)"><g transform="rotate(90,17.083,8.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.675 a1.675,1.675 0 0,1 1.675,-1.675 l30.817,0 a1.675,1.675 0 0,1 1.675,1.675 l0,13.817 a1.675,1.675 0 0,1 -1.675,1.675 l-30.817,0 a1.675,1.675 0 0,1 -1.675,-1.675 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g></g></g><g width="91.167" height="75.667" transform="scale(1,1) translate(17.667,0)" class="eatwithme-table" id="2"><g stroke="#000000" opacity="1" stroke-width="1.8333333333333333" stroke-dasharray="none" width="91.167" height="75.667" transform="scale(1,1) translate(0,0)" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><rect width="91.167" height="75.667" class="eatwithme-table" id="2"></rect></g><g width="85.33333333333333" height="69.83333333333333" transform="scale(1,1) translate(2.917,2.917)"><text width="85.33333333333333" height="24.999998092651367" transform="scale(1,1) translate(0,22.41666762034098)" xml:space="preserve"><tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="22.22222222222222" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="26.612" text-anchor="start" y="20" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="2" seatnumber="2" class="eatwithme-tableNumber">2</tspan></text></g></g></g>',
        icon: "add",
        seats: 2
      },
      new_rectangle_table_4: {
        name: I18n.t("admin_local.table_types.rectangle_four_seats"),
        svg:
          '<g width="128.667" height="75.667" transform="scale(1,1) translate(0,0)"><g width="128.667" height="34.333" transform="scale(1,1) translate(0,22.167)"><g width="128.667" height="34.333" transform="scale(1,1) translate(0,0)"><g width="22.833" height="34.167" transform="scale(1,1) translate(58.828358004760986,-38.139837770542044) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="34-1" eatwithme-seat-number="1" style="position: relative;"><g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)"><g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)"><g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.5" height="34.333" transform="scale(1,1) translate(58.28345278682245,47.19949653870358) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="34-2" eatwithme-seat-number="2" style="position: relative;"><g width="22.5" height="34.333" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.5" transform="scale(1,1) translate(-5.667,5.833)"><g transform="rotate(90,16.833,11.25) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.093 a2.093,2.093 0 0,1 2.093,-2.093 l29.481,0 a2.093,2.093 0 0,1 2.093,2.093 l0,18.314 a2.093,2.093 0 0,1 -2.093,2.093 l-29.481,0 a2.093,2.093 0 0,1 -2.093,-2.093 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.167" transform="scale(1,1) translate(-8.5,8.5)"><g transform="rotate(90,17.083,8.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.675 a1.675,1.675 0 0,1 1.675,-1.675 l30.817,0 a1.675,1.675 0 0,1 1.675,1.675 l0,13.817 a1.675,1.675 0 0,1 -1.675,1.675 l-30.817,0 a1.675,1.675 0 0,1 -1.675,-1.675 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.833" height="34.167" transform="scale(1,1) translate(99.87139847319888,-37.45578709606808) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="34-3" eatwithme-seat-number="" style="position: relative;"><g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)"><g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)"><g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.833" height="34.167" transform="scale(1,1) translate(64.30076340055271,69.25611812187047) rotate(-90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="34-4" eatwithme-seat-number="" style="position: relative;"><g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)"><g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)"><g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g></g></g><g width="91.167" height="75.667" transform="scale(1,1) translate(17.667,0)" class="eatwithme-table selectable" id="34"><g stroke="#000000" opacity="1" stroke-width="1.8333333333333333" stroke-dasharray="none" width="91.167" height="75.667" transform="scale(1,1) translate(0,0)" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><rect width="91.167" height="75.667" class="eatwithme-table" id="34"></rect></g><g width="85.33333333333333" height="69.83333333333333" transform="scale(1,1) translate(2.917,2.917)"><text width="85.33333333333333" height="24.999998092651367" transform="scale(1,1) translate(0,22.41666762034098)" xml:space="preserve" class="ui-draggable ui-draggable-handle" style="position: relative;"><tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="22.22222222222222" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="26.612" text-anchor="start" y="20" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="2" seatnumber="2" class="eatwithme-tableNumber">34</tspan></text></g></g></g>',
        icon: "add",
        seats: 4
      },
      new_rectangle_table_6: {
        name: I18n.t("admin_local.table_types.rectangle_six_seats"),
        svg:
          '<g width="128.667" height="75.667" transform="scale(1,1) translate(0,0)"><g width="128.667" height="34.333" transform="scale(1,1) translate(0,22.167)"><g width="128.667" height="34.333" transform="scale(1,1) translate(0,0)"><g width="22.833" height="34.167" transform="scale(1,1) translate(65.66886474950064,-39.507939119489976) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="5-1" eatwithme-seat-number="1" style="position: relative;"><g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)"><g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)"><g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.5" height="34.333" transform="scale(1,1) translate(66.76642096635406,46.51544586422962) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="5-2" eatwithme-seat-number="2" style="position: relative;"><g width="22.5" height="34.333" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.5" transform="scale(1,1) translate(-5.667,5.833)"><g transform="rotate(90,16.833,11.25) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.093 a2.093,2.093 0 0,1 2.093,-2.093 l29.481,0 a2.093,2.093 0 0,1 2.093,2.093 l0,18.314 a2.093,2.093 0 0,1 -2.093,2.093 l-29.481,0 a2.093,2.093 0 0,1 -2.093,-2.093 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.167" transform="scale(1,1) translate(-8.5,8.5)"><g transform="rotate(90,17.083,8.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.675 a1.675,1.675 0 0,1 1.675,-1.675 l30.817,0 a1.675,1.675 0 0,1 1.675,1.675 l0,13.817 a1.675,1.675 0 0,1 -1.675,1.675 l-30.817,0 a1.675,1.675 0 0,1 -1.675,-1.675 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.833" height="34.167" transform="scale(1,1) translate(106.02785454346457,-39.507939119489976) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="5-3" eatwithme-seat-number="1" style="position: relative;"><g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)"><g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)"><g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.833" height="34.167" transform="scale(1,1) translate(146.38684433742853,-39.507939119489976) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="5-4" eatwithme-seat-number="1" style="position: relative;"><g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)"><g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)"><g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.5" height="34.333" transform="scale(1,1) translate(107.9448617315453,46.51544586422962) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="5-5" eatwithme-seat-number="2" style="position: relative;"><g width="22.5" height="34.333" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.5" transform="scale(1,1) translate(-5.667,5.833)"><g transform="rotate(90,16.833,11.25) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.093 a2.093,2.093 0 0,1 2.093,-2.093 l29.481,0 a2.093,2.093 0 0,1 2.093,2.093 l0,18.314 a2.093,2.093 0 0,1 -2.093,2.093 l-29.481,0 a2.093,2.093 0 0,1 -2.093,-2.093 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.167" transform="scale(1,1) translate(-8.5,8.5)"><g transform="rotate(90,17.083,8.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.675 a1.675,1.675 0 0,1 1.675,-1.675 l30.817,0 a1.675,1.675 0 0,1 1.675,1.675 l0,13.817 a1.675,1.675 0 0,1 -1.675,1.675 l-30.817,0 a1.675,1.675 0 0,1 -1.675,-1.675 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g><g width="22.5" height="34.333" transform="scale(1,1) translate(150.51918184470915,46.51544586422962) rotate(90)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="5-6" eatwithme-seat-number="2" style="position: relative;"><g width="22.5" height="34.333" transform="scale(1,1) translate(0,0)"><g width="33.667" height="22.5" transform="scale(1,1) translate(-5.667,5.833)"><g transform="rotate(90,16.833,11.25) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,2.093 a2.093,2.093 0 0,1 2.093,-2.093 l29.481,0 a2.093,2.093 0 0,1 2.093,2.093 l0,18.314 a2.093,2.093 0 0,1 -2.093,2.093 l-29.481,0 a2.093,2.093 0 0,1 -2.093,-2.093 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g><g width="34.167" height="17.167" transform="scale(1,1) translate(-8.5,8.5)"><g transform="rotate(90,17.083,8.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><path d="M0,1.675 a1.675,1.675 0 0,1 1.675,-1.675 l30.817,0 a1.675,1.675 0 0,1 1.675,1.675 l0,13.817 a1.675,1.675 0 0,1 -1.675,1.675 l-30.817,0 a1.675,1.675 0 0,1 -1.675,-1.675 z" stroke-width="1.833" stroke-dasharray="none"></path></g></g></g></g></g></g><g width="140.993" height="75.667" transform="scale(1,1) translate(17.667,0)" class="eatwithme-table selectable" id="5"><g stroke="#000000" opacity="1" stroke-width="1.8333333333333333" stroke-dasharray="none" width="140.993" height="75.667" transform="scale(1,1) translate(0,0)" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1"><rect width="140.993" height="75.667" class="eatwithme-table" id="5"></rect></g><g width="131.97" height="69.83333333333333" transform="scale(1,1) translate(4.51123,2.917)"><text width="131.97" height="24.999998092651367" transform="scale(1,1) translate(17.3818,22.41666762034098)" xml:space="preserve" class="ui-draggable ui-draggable-handle" style="position: relative;"><tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="22.22222222222222" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="26.612" text-anchor="start" y="20" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="5" seatnumber="2" class="eatwithme-tableNumber">5</tspan></text></g></g></g>',
        icon: "add",
        seats: 6
      },
      new_circle_table: {
        name: I18n.t("admin_local.table_types.circle_four_seats"),
        svg:
          '<g width="118.667" height="118.167" transform="scale(1,1) translate(0,0)">' +
          ' <g width="118.667" height="118.167" transform="scale(1,1) translate(0,0)">' +
          '  <g width="118.667" height="118.167" transform="scale(0.826945412311266,0.8263403263403263) translate(0,0)">' +
          '   <g width="48.5" height="49" transform="scale(1,1) translate(93.667,0.5)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="29" eatwithme-seat-number="1" style="position: relative;">' +
          '    <g width="48.5" height="49" transform="scale(1,1) translate(0,0)">' +
          '     <g width="41" height="27.167" transform="scale(1,1) translate(4,10.5)">' +
          '       <g transform="rotate(45,20.5,13.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '        <path d="M0,2.527 a2.527,2.527 0 0,1 2.527,-2.527 l35.946,0 a2.527,2.527 0 0,1 2.527,2.527 l0,22.112 a2.527,2.527 0 0,1 -2.527,2.527 l-35.946,0 a2.527,2.527 0 0,1 -2.527,-2.527 z" stroke-width="2.167" stroke-dasharray="none"></path>' +
          '      </g>' +
          '     </g>' +
          '    <g width="41.667" height="21.667" transform="scale(1,1) translate(1.5,15.667)">' +
          '     <g transform="rotate(45,20.833,10.833) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '      <path d="M0,2.114 a2.114,2.114 0 0,1 2.114,-2.114 l37.439,0 a2.114,2.114 0 0,1 2.114,2.114 l0,17.439 a2.114,2.114 0 0,1 -2.114,2.114 l-37.439,0 a2.114,2.114 0 0,1 -2.114,-2.114 z" stroke-width="2.167" stroke-dasharray="none"></path>' +
          '     </g>' +
          '    </g>' +
          '   </g>' +
          '  </g>' +
          '  <g width="48.833" height="48.667" transform="scale(1,1) translate(94.667,94.333)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="29" eatwithme-seat-number="2" style="position: relative;">' +
          '   <g width="48.833" height="48.667" transform="scale(1,1) translate(0,0)">' +
          '    <g width="41.333" height="27.167" transform="scale(1,1) translate(4,10.833)">' +
          '     <g transform="rotate(135,20.667,13.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '      <path d="M0,2.527 a2.527,2.527 0 0,1 2.527,-2.527 l36.279,0 a2.527,2.527 0 0,1 2.527,2.527 l0,22.112 a2.527,2.527 0 0,1 -2.527,2.527 l-36.279,0 a2.527,2.527 0 0,1 -2.527,-2.527 z" stroke-width="2.167" stroke-dasharray="none"></path>' +
          '     </g>' +
          '    </g>' +
          '    <g width="42.167" height="21" transform="scale(1,1) translate(1.167,11.833)">' +
          '     <g transform="rotate(135,21.083,10.5) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '      <path d="M0,2.049 a2.049,2.049 0 0,1 2.049,-2.049 l38.069,0 a2.049,2.049 0 0,1 2.049,2.049 l0,16.902 a2.049,2.049 0 0,1 -2.049,2.049 l-38.069,0 a2.049,2.049 0 0,1 -2.049,-2.049 z" stroke-width="2.167" stroke-dasharray="none"></path>' +
          '     </g>' +
          '    </g>' +
          '   </g>' +
          '  </g>' +
          '  <g width="48.667" height="49.167" transform="scale(1,1) translate(1.667,93.167)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="29" eatwithme-seat-number="3" style="position: relative;">' +
          '   <g width="48.667" height="49.167" transform="scale(1,1) translate(0,0)">' +
          '    <g width="41" height="27.5" transform="scale(1,1) translate(3.833,11.333)">' +
          '     <g transform="rotate(224,20.5,13.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '      <path d="M0,2.558 a2.558,2.558 0 0,1 2.558,-2.558 l35.884,0 a2.558,2.558 0 0,1 2.558,2.558 l0,22.384 a2.558,2.558 0 0,1 -2.558,2.558 l-35.884,0 a2.558,2.558 0 0,1 -2.558,-2.558 z" stroke-width="2.167" stroke-dasharray="none"></path>' +
          '     </g>' +
          '    </g>' +
          '    <g width="41.667" height="21.167" transform="scale(1,1) translate(5.667,11.667)">' +
          '     <g transform="rotate(225,20.833,10.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '      <path d="M0,2.065 a2.065,2.065 0 0,1 2.065,-2.065 l37.537,0 a2.065,2.065 0 0,1 2.065,2.065 l0,17.037 a2.065,2.065 0 0,1 -2.065,2.065 l-37.537,0 a2.065,2.065 0 0,1 -2.065,-2.065 z" stroke-width="2.167" stroke-dasharray="none"></path>' +
          '     </g>' +
          '    </g>' +
          '   </g>' +
          '  </g>' +
          '  <g width="49.667" height="47.833" transform="scale(1,1) translate(0,0)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="29" eatwithme-seat-number="4" style="position: relative;">' +
          '   <g width="49.667" height="47.833" transform="scale(1,1) translate(0,0)">' +
          '    <g width="41.333" height="27.167" transform="scale(1,1) translate(3.833,10.333)">' +
          '     <g transform="rotate(318.2,20.667,13.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '      <path d="M0,2.527 a2.527,2.527 0 0,1 2.527,-2.527 l36.279,0 a2.527,2.527 0 0,1 2.527,2.527 l0,22.112 a2.527,2.527 0 0,1 -2.527,2.527 l-36.279,0 a2.527,2.527 0 0,1 -2.527,-2.527 z" stroke-width="2.167" stroke-dasharray="none"></path>' +
          '     </g>' +
          '    </g>' +
          '    <g width="42.167" height="21" transform="scale(1,1) translate(5.833,15.5)">' +
          '     <g transform="rotate(319,21.083,10.5) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '      <path d="M0,2.049 a2.049,2.049 0 0,1 2.049,-2.049 l38.069,0 a2.049,2.049 0 0,1 2.049,2.049 l0,16.902 a2.049,2.049 0 0,1 -2.049,2.049 l-38.069,0 a2.049,2.049 0 0,1 -2.049,-2.049 z" stroke-width="2.167" stroke-dasharray="none"></path>' +
          '     </g>' +
          '    </g>' +
          '   </g>' +
          '  </g>' +
          ' </g>' +
          '</g>' +
          '<g width="98.667" height="101.333" transform="scale(1,1) translate(8.833,8.5)" class="eatwithme-table" id="29">' +
          ' <g width="98.667" height="101.333" transform="scale(1,1) translate(0,0)" stroke="#000000" stroke-width="1.8333333333333333" stroke-dasharray="none" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '  <ellipse rx="49.3335" ry="50.6665" cx="49.3335" cy="50.6665" class="eatwithme-table" id="29"></ellipse>' +
          ' </g>' +
          ' <g width="64.47150672366666" height="66.357124809" transform="scale(1,1) translate(17.098,17.488)">' +
          '  <text width="64.47150672366666" height="24.999998092651367" transform="scale(1,1) translate(0,20.678563358174316)" xml:space="preserve">' +
          '   <tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="22.22222222222222" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="10.003" text-anchor="start" y="20" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="29" seatnumber="4" class="eatwithme-tableNumber">29</tspan>' +
          '  </text>' +
          ' </g>' +
          '</g>',
        icon: "add",
        seats: 4
      },
      new_rounded_table_4: {
        name: I18n.t("admin_local.table_types.rounded_four_seats"),
        svg:
          '<g width="128.667" height="75.667" transform="translate(0,0) scale(1,1) translate(0,0)">' +
          '<g width="128.667" height="34.333" transform="scale(1,1) translate(0,22.167)">' +
          '<g width="128.667" height="34.333" transform="scale(1,1) translate(0,0)">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,-4.69590616762897)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="11-1" eatwithme-seat-number="1" style="position: relative;">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)">' +
          '<g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)">' +
          '<g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="22.5" height="34.333" transform="scale(1,1) translate(94.00973458092757,-4.86290616762897)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="11-2" eatwithme-seat-number="2" style="position: relative;">' +
          '<g width="22.5" height="34.333" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.5" transform="scale(1,1) translate(-5.667,5.833)">' +
          '<g transform="rotate(90,16.833,11.25) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.093 a2.093,2.093 0 0,1 2.093,-2.093 l29.481,0 a2.093,2.093 0 0,1 2.093,2.093 l0,18.314 a2.093,2.093 0 0,1 -2.093,2.093 l-29.481,0 a2.093,2.093 0 0,1 -2.093,-2.093 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.167" transform="scale(1,1) translate(-8.5,8.5)">' +
          '<g transform="rotate(90,17.083,8.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.675 a1.675,1.675 0 0,1 1.675,-1.675 l30.817,0 a1.675,1.675 0 0,1 1.675,1.675 l0,13.817 a1.675,1.675 0 0,1 -1.675,1.675 l-30.817,0 a1.675,1.675 0 0,1 -1.675,-1.675 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="22.5" height="34.333" transform="scale(1,1) translate(94.00973458092757,41.33470242484624)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="11-2" eatwithme-seat-number="2" style="position: relative;">' +
          '<g width="22.5" height="34.333" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.5" transform="scale(1,1) translate(-5.667,5.833)">' +
          '<g transform="rotate(90,16.833,11.25) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.093 a2.093,2.093 0 0,1 2.093,-2.093 l29.481,0 a2.093,2.093 0 0,1 2.093,2.093 l0,18.314 a2.093,2.093 0 0,1 -2.093,2.093 l-29.481,0 a2.093,2.093 0 0,1 -2.093,-2.093 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.167" transform="scale(1,1) translate(-8.5,8.5)">' +
          '<g transform="rotate(90,17.083,8.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.675 a1.675,1.675 0 0,1 1.675,-1.675 l30.817,0 a1.675,1.675 0 0,1 1.675,1.675 l0,13.817 a1.675,1.675 0 0,1 -1.675,1.675 l-30.817,0 a1.675,1.675 0 0,1 -1.675,-1.675 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,40.69121806357475)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="11-1" eatwithme-seat-number="1" style="position: relative;">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)">' +
          '<g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)">' +
          '<g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="91.167" height="75.667" transform="scale(1,1) translate(17.667,0)" class="eatwithme-table selectable" id="11" level="2">' +
          '<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#D8D8D8" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,16.442 a16.442,16.442 0 0,1 16.442,-16.442 l49.326,0 a16.442,16.442 0 0,1 16.442,16.442 l0,77.116 a16.442,16.442 0 0,1 -16.442,16.442 l-49.326,0 a16.442,16.442 0 0,1 -16.442,-16.442 z" stroke-width="0.321" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '<g width="85.33333333333333" height="69.83333333333333" transform="scale(1,1) translate(2.917,2.917)">' +
          '<text width="85.33333333333333" height="24.999998092651367" transform="scale(1,1) translate(25.125015199416342,58.88846387755825)" xml:space="preserve" class="ui-draggable ui-draggable-handle" style="position: relative;">' +
          '<tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="22.22222222222222" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="0" text-anchor="start" y="0" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="11-number" seatnumber="2" class="eatwithme-tableNumber" level="3">11</tspan>' +
          '</text>' +
          '</g>' +
          '</g>' +
          '</g>',
        icon: "add",
        seats: 4
      },
      new_rounded_table_6: {
        name: I18n.t("admin_local.table_types.rounded_six_seats"),
        svg:
          '<g width="101.206" height="110" transform="translate(0,0) scale(1,1) translate(0,0)">' +
          '<g width="128.667" height="34.333" transform="scale(1,1) translate(0,22.167)">' +
          '<g width="128.667" height="34.333" transform="scale(1,1) translate(0,0)">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(80.17067740909572,114.7911916675501)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="6-1" eatwithme-seat-number="1" style="position: relative;">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)">' +
          '<g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)">' +
          '<g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="22.5" height="34.333" transform="scale(1,1) translate(157.1847038057882,113.96162408565675)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="6-2" eatwithme-seat-number="2" style="position: relative;">' +
          '<g width="22.5" height="34.333" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.5" transform="scale(1,1) translate(-5.667,5.833)">' +
          '<g transform="rotate(90,16.833,11.25) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.093 a2.093,2.093 0 0,1 2.093,-2.093 l29.481,0 a2.093,2.093 0 0,1 2.093,2.093 l0,18.314 a2.093,2.093 0 0,1 -2.093,2.093 l-29.481,0 a2.093,2.093 0 0,1 -2.093,-2.093 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.167" transform="scale(1,1) translate(-8.5,8.5)">' +
          '<g transform="rotate(90,17.083,8.583) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.675 a1.675,1.675 0 0,1 1.675,-1.675 l30.817,0 a1.675,1.675 0 0,1 1.675,1.675 l0,13.817 a1.675,1.675 0 0,1 -1.675,1.675 l-30.817,0 a1.675,1.675 0 0,1 -1.675,-1.675 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(79.50810982720238,151.23240867168457)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="6-3" eatwithme-seat-number="" style="position: relative;">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)">' +
          '<g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)">' +
          '<g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(79.50810982720239,188.99876083960567)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="6-4" eatwithme-seat-number="" style="position: relative;">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)">' +
          '<g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)">' +
          '<g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(180.8809498568854,185.6859229301389) rotate(180)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="6-5" eatwithme-seat-number="" style="position: relative;">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)">' +
          '<g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)">' +
          '<g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(180.21838227499205,222.78970751616663) rotate(180)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="6-6" eatwithme-seat-number="" style="position: relative;">' +
          '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)">' +
          '<g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)">' +
          '<g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)">' +
          '<g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '</g>' +
          '<g width="91.167" height="75.667" transform="scale(1,1) translate(17.667,0)" class="eatwithme-table selectable" id="6">' +
          '<g width="66.659" height="125.066" transform="scale(1,1) translate(80.281,128.34)">' +
          '<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#D8D8D8" fill-opacity="1" stroke-opacity="1">' +
          '<path d="M13.397,0 L53.071,0 L53.136,0 L55.026,0.135 L55.802,0.269 L56.393,0.404 L56.888,0.538 L57.32,0.672 L57.707,0.807 L58.06,0.941 L58.386,1.075 L58.69,1.21 L58.975,1.344 L59.244,1.478 L59.498,1.613 L59.74,1.747 L59.971,1.882 L60.192,2.016 L60.403,2.15 L60.606,2.285 L60.802,2.419 L60.99,2.553 L61.171,2.688 L61.346,2.822 L61.516,2.956 L61.68,3.091 L61.839,3.225 L61.993,3.36 L62.142,3.494 L62.287,3.628 L62.427,3.763 L62.564,3.897 L62.697,4.031 L62.826,4.166 L62.951,4.3 L63.073,4.434 L63.192,4.569 L63.308,4.703 L63.42,4.838 L63.53,4.972 L63.637,5.106 L63.741,5.241 L63.842,5.375 L63.941,5.509 L64.037,5.644 L64.13,5.778 L64.222,5.912 L64.31,6.047 L64.397,6.181 L64.481,6.316 L64.563,6.45 L64.643,6.584 L64.721,6.719 L64.796,6.853 L64.87,6.987 L64.942,7.122 L65.011,7.256 L65.079,7.39 L65.145,7.525 L65.209,7.659 L65.271,7.794 L65.332,7.928 L65.39,8.062 L65.447,8.197 L65.502,8.331 L65.556,8.465 L65.607,8.6 L65.657,8.734 L65.706,8.869 L65.753,9.003 L65.798,9.137 L65.841,9.272 L65.883,9.406 L65.924,9.54 L65.963,9.675 L66,9.809 L66.036,9.943 L66.071,10.078 L66.104,10.212 L66.135,10.347 L66.165,10.481 L66.193,10.615 L66.22,10.75 L66.246,10.884 L66.27,11.018 L66.293,11.153 L66.314,11.287 L66.334,11.421 L66.353,11.556 L66.37,11.69 L66.386,11.825 L66.4,11.959 L66.413,12.093 L66.425,12.228 L66.435,12.362 L66.444,12.496 L66.451,12.631 L66.457,12.765 L66.462,12.899 L66.466,13.034 L66.468,13.168 L66.468,13.303 L66.403,13.302 L66.659,115.101 L66.725,115.101 L66.618,116.514 L66.512,117.094 L66.406,117.536 L66.299,117.905 L66.193,118.228 L66.087,118.518 L65.98,118.782 L65.874,119.026 L65.768,119.253 L65.662,119.466 L65.555,119.667 L65.449,119.857 L65.343,120.038 L65.236,120.21 L65.13,120.375 L65.024,120.533 L64.917,120.685 L64.811,120.831 L64.705,120.972 L64.598,121.107 L64.492,121.238 L64.386,121.365 L64.279,121.487 L64.173,121.606 L64.067,121.721 L63.961,121.833 L63.854,121.941 L63.748,122.046 L63.642,122.148 L63.535,122.247 L63.429,122.344 L63.323,122.438 L63.216,122.529 L63.11,122.618 L63.004,122.704 L62.897,122.788 L62.791,122.87 L62.685,122.95 L62.578,123.028 L62.472,123.104 L62.366,123.177 L62.26,123.249 L62.153,123.319 L62.047,123.387 L61.941,123.454 L61.834,123.518 L61.728,123.581 L61.622,123.643 L61.515,123.702 L61.409,123.76 L61.303,123.817 L61.196,123.872 L61.09,123.926 L60.984,123.978 L60.877,124.028 L60.771,124.078 L60.665,124.125 L60.559,124.172 L60.452,124.217 L60.346,124.261 L60.24,124.303 L60.133,124.344 L60.027,124.384 L59.921,124.423 L59.814,124.461 L59.708,124.497 L59.602,124.532 L59.495,124.565 L59.389,124.598 L59.283,124.629 L59.176,124.66 L59.07,124.689 L58.964,124.717 L58.858,124.744 L58.751,124.769 L58.645,124.794 L58.539,124.817 L58.432,124.84 L58.326,124.861 L58.22,124.881 L58.113,124.901 L58.007,124.919 L57.901,124.936 L57.794,124.952 L57.688,124.966 L57.582,124.98 L57.475,124.993 L57.369,125.005 L57.263,125.016 L57.156,125.025 L57.05,125.034 L56.944,125.042 L56.838,125.048 L56.731,125.054 L56.625,125.059 L56.519,125.062 L56.412,125.065 L56.306,125.066 L56.2,125.067 L56.134,125.066 L9.409,124.745 L9.475,124.746 L8.141,124.617 L7.593,124.488 L7.176,124.359 L6.827,124.231 L6.522,124.102 L6.249,123.973 L5.999,123.844 L5.769,123.715 L5.555,123.586 L5.354,123.458 L5.164,123.329 L4.984,123.2 L4.814,123.071 L4.651,122.942 L4.495,122.814 L4.346,122.685 L4.202,122.556 L4.065,122.427 L3.932,122.298 L3.804,122.17 L3.68,122.041 L3.56,121.912 L3.445,121.783 L3.333,121.654 L3.224,121.525 L3.119,121.397 L3.017,121.268 L2.917,121.139 L2.821,121.01 L2.727,120.881 L2.636,120.753 L2.547,120.624 L2.461,120.495 L2.377,120.366 L2.296,120.237 L2.216,120.108 L2.139,119.98 L2.064,119.851 L1.99,119.722 L1.919,119.593 L1.849,119.464 L1.781,119.336 L1.715,119.207 L1.651,119.078 L1.588,118.949 L1.527,118.82 L1.468,118.692 L1.41,118.563 L1.354,118.434 L1.299,118.305 L1.245,118.176 L1.193,118.047 L1.143,117.919 L1.093,117.79 L1.046,117.661 L0.999,117.532 L0.954,117.403 L0.91,117.275 L0.867,117.146 L0.826,117.017 L0.786,116.888 L0.747,116.759 L0.709,116.63 L0.673,116.502 L0.638,116.373 L0.603,116.244 L0.57,116.115 L0.538,115.986 L0.508,115.858 L0.478,115.729 L0.449,115.6 L0.422,115.471 L0.396,115.342 L0.37,115.213 L0.346,115.085 L0.323,114.956 L0.301,114.827 L0.279,114.698 L0.259,114.569 L0.24,114.441 L0.222,114.312 L0.205,114.183 L0.189,114.054 L0.174,113.925 L0.16,113.797 L0.147,113.668 L0.135,113.539 L0.124,113.41 L0.113,113.281 L0.104,113.152 L0.096,113.024 L0.089,112.895 L0.083,112.766 L0.077,112.637 L0.073,112.508 L0.07,112.38 L0.067,112.251 L0.066,112.122 L0.065,111.993 L0,111.993 L0.064,13.302 L0.13,13.303 L0.264,11.417 L0.399,10.642 L0.534,10.053 L0.668,9.56 L0.803,9.129 L0.938,8.742 L1.072,8.389 L1.207,8.064 L1.342,7.761 L1.476,7.477 L1.611,7.209 L1.746,6.955 L1.88,6.713 L2.015,6.483 L2.15,6.263 L2.284,6.052 L2.419,5.849 L2.554,5.654 L2.688,5.467 L2.823,5.286 L2.958,5.111 L3.092,4.942 L3.227,4.778 L3.362,4.62 L3.496,4.466 L3.631,4.317 L3.766,4.173 L3.9,4.032 L4.035,3.896 L4.17,3.764 L4.304,3.635 L4.439,3.51 L4.574,3.388 L4.708,3.269 L4.843,3.154 L4.978,3.041 L5.112,2.932 L5.247,2.826 L5.382,2.722 L5.516,2.621 L5.651,2.522 L5.786,2.426 L5.92,2.333 L6.055,2.242 L6.19,2.153 L6.324,2.067 L6.459,1.983 L6.594,1.901 L6.728,1.822 L6.863,1.744 L6.998,1.669 L7.132,1.595 L7.267,1.524 L7.402,1.454 L7.536,1.386 L7.671,1.321 L7.806,1.257 L7.941,1.195 L8.075,1.135 L8.21,1.076 L8.345,1.019 L8.479,0.964 L8.614,0.911 L8.749,0.859 L8.883,0.809 L9.018,0.761 L9.153,0.714 L9.287,0.669 L9.422,0.626 L9.557,0.584 L9.691,0.544 L9.826,0.505 L9.961,0.467 L10.095,0.432 L10.23,0.397 L10.365,0.364 L10.499,0.333 L10.634,0.303 L10.769,0.275 L10.903,0.248 L11.038,0.222 L11.173,0.198 L11.307,0.175 L11.442,0.154 L11.577,0.134 L11.711,0.116 L11.846,0.098 L11.981,0.083 L12.115,0.068 L12.25,0.055 L12.385,0.044 L12.519,0.034 L12.654,0.025 L12.789,0.017 L12.923,0.011 L13.058,0.007 L13.193,0.003 L13.327,0.001 L13.462,0 L13.397,0 z" stroke-width="0.321" stroke-dasharray="none">' +
          '</path>' +
          '</g>' +
          '</g>' +
          '<g width="85.33333333333333" height="69.83333333333333" transform="scale(1,1) translate(2.917,2.917)">' +
          '<text width="85.33333333333333" height="24.999998092651367" transform="scale(1,1) translate(76.19527191773561,178.12004936527896)" xml:space="preserve" class="ui-draggable ui-draggable-handle" style="position: relative;">' +
          '<tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="22.22222222222222" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="26.612" text-anchor="start" y="20" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="2" seatnumber="2" class="eatwithme-tableNumber">6</tspan>' +
          '</text>' +
          '</g>' +
          '</g>' +
          '</g>',
        icon: "add",
        seats: 6
      },
      person: {
        name: I18n.t("admin_local.table_types.person"),
        svg:
          '<g>' +
          '  <g class="eatwithme-table" style="" transform="translate(-35.5,-45) scale(1,1) translate(0,0)" >' +
          '   <g class="person">' +
          '    <path stroke-width="1.83" d="M 45 40.375 L 45 40.375 c -9.415 0 -17.118 -7.703 -17.118 -17.118 v -6.139 C 27.882 7.703 35.585 0 45 0 h 0 c 9.415 0 17.118 7.703 17.118 17.118 v 6.139 C 62.118 32.672 54.415 40.375 45 40.375 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '    <path stroke-width="1.83" d="M 54.639 42.727 C 51.743 44.226 48.47 45.09 45 45.09 s -6.743 -0.863 -9.639 -2.363 c -12.942 1.931 -22.952 13.162 -22.952 26.619 v 17.707 c 0 1.621 1.326 2.946 2.946 2.946 h 59.29 c 1.621 0 2.946 -1.326 2.946 -2.946 V 69.347 C 77.591 55.889 67.581 44.659 54.639 42.727 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '   </g>' +
          '   <g transform="scale(1,1) translate(0,10)">' +
          '    <text transform="scale(1,1) translate(34.79681465555955,63.407528927908515)" xml:space="preserve" class="ui-draggable ui-draggable-handle" style="position: relative;">' +
          '     <tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="20" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="0" text-anchor="start" y="0" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="" seatnumber="4" class="eatwithme-tableNumber" level="3">10</tspan>' +
          '    </text>' +
          '   </g>' +
          '  </g>' +
          '</g>'
        ,
        icon: "add",
        seats: 6
      },
      persons: {
        name: I18n.t("admin_local.table_types.persons"),
        svg:
          '<g>' +
          '  <g class="eatwithme-table" style="" transform="translate(-35.5,-45) scale(1,1) translate(0,0)" >' +
          '   <g class="person">' +
          '    <path d="M 62.993 75.484 H 27.007 c -0.904 0 -1.636 -0.733 -1.636 -1.636 V 57.642 c 0 -6.762 5.481 -12.243 12.243 -12.243 h 14.772 c 6.762 0 12.243 5.481 12.243 12.243 v 16.206 C 64.629 74.751 63.897 75.484 62.993 75.484 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '    <path d="M 45.531 40.146 h -1.062 c -5.737 0 -10.388 -4.651 -10.388 -10.388 v -4.853 c 0 -5.737 4.651 -10.388 10.388 -10.388 h 1.062 c 5.737 0 10.388 4.651 10.388 10.388 v 4.853 C 55.919 35.495 51.268 40.146 45.531 40.146 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '    <path d="M 74.555 35.243 h -0.859 c -4.64 0 -8.401 -3.761 -8.401 -8.401 v -3.925 c 0 -4.64 3.761 -8.401 8.401 -8.401 h 0.859 c 4.64 0 8.401 3.761 8.401 8.401 v 3.925 C 82.956 31.482 79.195 35.243 74.555 35.243 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '    <path d="M 15.445 35.243 h 0.859 c 4.64 0 8.401 -3.761 8.401 -8.401 v -3.925 c 0 -4.64 -3.761 -8.401 -8.401 -8.401 h -0.859 c -4.64 0 -8.401 3.761 -8.401 8.401 v 3.925 C 7.044 31.482 10.805 35.243 15.445 35.243 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '    <path d="M 62.993 75.484 H 27.007 c -0.904 0 -1.636 -0.733 -1.636 -1.636 V 57.642 c 0 -6.762 5.481 -12.243 12.243 -12.243 h 14.772 c 6.762 0 12.243 5.481 12.243 12.243 v 16.206 C 64.629 74.751 63.897 75.484 62.993 75.484 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '    <path d="M 80.099 39.291 h -0.695 H 68.152 h -0.695 c -2.785 0 -5.297 1.154 -7.095 3.006 c -0.525 0.541 -0.342 1.439 0.325 1.79 c 4.671 2.457 7.859 7.352 7.859 12.996 v 4.902 c 0 0.904 0.733 1.636 1.636 1.636 h 0.9 h 5.391 h 11.89 c 0.904 0 1.636 -0.733 1.636 -1.636 V 49.192 C 90 43.724 85.567 39.291 80.099 39.291 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '    <path d="M 21.453 57.083 c 0 -5.645 3.188 -10.539 7.859 -12.996 c 0.667 -0.351 0.85 -1.249 0.325 -1.79 c -1.798 -1.852 -4.31 -3.006 -7.095 -3.006 h -0.695 H 10.596 H 9.901 C 4.433 39.291 0 43.724 0 49.192 v 12.793 c 0 0.904 0.733 1.636 1.636 1.636 h 11.89 h 5.391 h 0.9 c 0.904 0 1.636 -0.733 1.636 -1.636 V 57.083 z" style="fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />' +
          '   </g>' +
          '   <g transform="scale(1,1) translate(0,10)">' +
          '    <text transform="scale(1,1) translate(34.79681465555955,63.407528927908515)" xml:space="preserve" class="ui-draggable ui-draggable-handle" style="position: relative;">' +
          '     <tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="20" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="0" text-anchor="start" y="0" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="" seatnumber="4" class="eatwithme-tableNumber" level="3">10</tspan>' +
          '    </text>' +
          '   </g>' +
          '  </g>' +
          '</g>'
        ,
        icon: "add",
        seats: 6
      },
      pooltable: {
        name: I18n.t("admin_local.table_types.pool_table"),
        svg:
          '<g>' +
          '  <g class="eatwithme-table" style="" transform="translate(-35.5,-45) scale(1,1) translate(0,0)" >' +
          '   <g class="person" transform="scale(.01,.01)">' +
          '    <rect x=480 y=480 width=11000 height=5700 fill="green" style="fill: #008000bd !important"/>' +
          '    <path d="M347 6568 c-39 -20 -287 -269 -288 -289 -1 -18 -1 -5911 0 -5923 1 ' +
          '-12 261 -275 285 -288 13 -7 1805 -10 5655 -10 3100 1 5642 1 5650 1 19 1 269 ' +
          '248 288 286 14 26 16 335 16 2975 0 2324 -3 2952 -13 2971 -17 34 -239 257 ' +
          '-274 276 -26 14 -612 15 -5658 17 -5236 1 -5631 0 -5661 -16z m1673 -263 c0 ' +
          '-5 -9 -21 -19 -34 l-18 -23 -21 30 -22 30 22 27 21 27 18 -23 c10 -13 19 -28 ' +
          '19 -34z m1308 -28 l-21 -29 -18 23 c-23 30 -23 38 -2 68 l16 24 23 -28 23 -29 ' +
          '-21 -29z m1325 54 c16 -28 16 -30 -5 -56 l-21 -27 -18 23 c-23 30 -23 34 -3 ' +
          '64 21 32 26 31 47 -4z m2750 4 c18 -25 17 -31 -12 -74 -8 -12 -13 -11 -30 10 ' +
          '-25 30 -25 34 -3 64 21 30 23 30 45 0z m1322 -2 c16 -24 16 -29 2 -52 -21 -35 ' +
          '-30 -36 -49 -3 -15 25 -15 29 0 55 21 34 25 34 47 0z m1330 -13 c3 -11 -2 -31 ' +
          '-11 -46 l-18 -26 -22 28 -23 28 21 28 c21 31 41 26 53 -12z m-9002 -197 c-18 ' +
          '-2 -48 -2 -65 0 -18 2 -4 4 32 4 36 0 50 -2 33 -4z m4640 0 c-13 -2 -33 -2 ' +
          '-45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m670 0 c-13 -2 -35 -2 -50 0 -16 2 ' +
          '-5 4 22 4 28 0 40 -2 28 -4z m4660 0 c-18 -2 -48 -2 -65 0 -18 2 -4 4 32 4 36 ' +
          '0 50 -2 33 -4z m-8841 -143 l1118 0 -2 -2662 -3 -2663 -1115 -2 -1114 -3 -63 ' +
          '-62 c-42 -42 -64 -57 -67 -47 -21 69 -62 171 -81 205 -45 77 -139 138 -267 ' +
          '174 -27 7 -48 15 -48 18 0 3 27 33 60 68 l60 62 0 2249 0 2249 -65 64 c-35 35 ' +
          '-62 67 -60 71 3 3 26 12 51 18 74 19 168 65 212 106 45 40 101 144 132 246 ' +
          'l11 37 61 -64 61 -64 1119 0z m8912 47 c33 -103 83 -186 133 -219 80 -53 89 ' +
          '-56 240 -103 7 -2 -17 -32 -52 -66 l-65 -62 0 -2256 0 -2257 60 -59 c33 -33 ' +
          '60 -62 60 -66 0 -4 -20 -12 -44 -18 -75 -19 -173 -68 -218 -110 -27 -24 -55 ' +
          '-64 -72 -103 -16 -35 -32 -70 -36 -79 -5 -9 -14 -36 -20 -59 l-12 -43 -62 62 ' +
          '-62 61 -2324 0 c-1278 0 -2325 -2 -2328 -4 -2 -2 -9 -25 -16 -51 l-11 -46 -39 ' +
          '30 c-45 36 -132 70 -197 78 -62 7 -170 -25 -239 -72 -58 -39 -60 -40 -60 -22 ' +
          '0 6 -5 29 -11 49 l-10 38 -1194 0 -1195 0 -2 2665 -3 2665 1192 0 c1130 0 ' +
          '1193 1 1202 18 5 9 12 34 16 55 4 21 10 37 14 35 3 -2 31 -20 62 -41 130 -88 ' +
          '275 -87 411 3 l56 37 7 -36 c4 -19 11 -44 16 -53 9 -17 121 -18 2327 -18 ' +
          'l2318 0 64 65 c35 36 65 65 66 65 1 0 14 -38 28 -83z m403 -499 c-2 -29 -3 -6 ' +
          '-3 52 0 58 1 81 3 53 2 -29 2 -77 0 -105z m-11133 -900 c-25 -20 -28 -20 -52 ' +
          '-5 -36 21 -37 30 -5 49 26 15 29 15 55 -4 l29 -20 -27 -20z m11338 41 l30 -22 ' +
          '-29 -18 c-35 -23 -35 -23 -64 0 l-24 19 25 21 c31 25 26 25 62 0z m-2 -1329 ' +
          'l25 -20 -24 -20 c-28 -24 -30 -24 -61 0 l-25 20 25 20 c31 24 29 24 60 0z ' +
          'm-11331 -1361 c-29 -23 -39 -23 -67 -3 -28 20 -28 26 5 46 26 15 29 15 56 -4 ' +
          'l29 -21 -23 -18z m11332 40 l30 -21 -26 -20 c-26 -21 -54 -18 -75 7 -10 12 -8 ' +
          '19 11 35 30 24 25 24 60 -1z m-204 -1002 c-2 -23 -3 -1 -3 48 0 50 1 68 3 42 ' +
          '2 -26 2 -67 0 -90z m-9477 -682 c0 -13 -29 -55 -38 -55 -4 0 -15 12 -24 27 ' +
          '-15 26 -15 29 4 56 l21 29 18 -23 c10 -13 19 -29 19 -34z m1308 26 l21 -29 ' +
          '-20 -26 c-23 -29 -42 -23 -54 14 -5 15 19 70 29 70 1 0 12 -13 24 -29z m1322 ' +
          '-1 c21 -29 21 -30 3 -55 -23 -31 -27 -31 -47 0 -16 24 -16 27 1 55 9 17 18 30 ' +
          '19 30 2 0 12 -13 24 -30z m4077 -48 c-21 -35 -29 -36 -50 -7 -18 25 -18 26 3 ' +
          '55 l22 31 20 -27 c20 -25 20 -28 5 -52z m1333 22 c0 -7 -8 -22 -18 -34 l-18 ' +
          '-23 -22 28 -21 27 22 29 21 30 18 -23 c10 -13 18 -28 18 -34z m-2655 22 c15 ' +
          '-23 15 -27 0 -50 -10 -14 -21 -26 -25 -26 -4 0 -15 12 -25 26 -15 23 -15 27 0 ' +
          '50 8 13 20 24 25 24 5 0 17 -11 25 -24z"/>' +
          '   </g>' +
          '   <g transform="scale(1,1) translate(0,10)">' +
          '    <text transform="scale(1,1) translate(44.79681465555955,23.407528927908515)" xml:space="preserve" class="ui-draggable ui-draggable-handle" style="position: relative;">' +
          '     <tspan xml:space="preserve" text-rendering="optimizeSpeed" font-size="20" font-weight="bold" font-style="normal" fill="#000000" opacity="1" x="0" text-anchor="start" y="0" style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;" id="" seatnumber="4" class="eatwithme-tableNumber" level="3">10</tspan>' +
          '    </text>' +
          '   </g>' +
          '  </g>' +
          '</g>'
        ,
        icon: "add",
        seats: 1
      }


    }

    if (tableLayout.tableTemplates && tableLayout.tableTemplates.new_rounded_table_6 && tableLayout.tableTemplates.new_rounded_table_6.svg) {
      //tableLayout.tableTemplates.new_rounded_table_6.svg = normalizeTemplateSvgOrigin(tableLayout.tableTemplates.new_rounded_table_6.svg);
    }
  },
  seatTemplates: {
    new_normal_seat: {
      name: I18n.t("admin_local.seat_types.normal_chair"),
      svg:
        '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0.167)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="7" eatwithme-seat-number="" style="position: relative;">' +
        '<g width="22.833" height="34.167" transform="scale(1,1) translate(0,0)">' +
        '<g width="33.667" height="22.833" transform="scale(1,1) translate(-5.333,5.667)">' +
        '<g transform="rotate(270,16.833,11.417) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
        '<path d="M0,2.124 a2.124,2.124 0 0,1 2.124,-2.124 l29.419,0 a2.124,2.124 0 0,1 2.124,2.124 l0,18.585 a2.124,2.124 0 0,1 -2.124,2.124 l-29.419,0 a2.124,2.124 0 0,1 -2.124,-2.124 z" stroke-width="1.833" stroke-dasharray="none">' +
        '</path>' +
        '</g>' +
        '</g>' +
        '<g width="34.167" height="17.5" transform="scale(1,1) translate(-3.333,8.333)">' +
        '<g transform="rotate(270,17.083,8.75) scale(1,1) translate(0,0)" stroke="#000000" fill="#FFFFFF" fill-opacity="1" stroke-opacity="1">' +
        '<path d="M0,1.707 a1.707,1.707 0 0,1 1.707,-1.707 l30.752,0 a1.707,1.707 0 0,1 1.707,1.707 l0,14.085 a1.707,1.707 0 0,1 -1.707,1.707 l-30.752,0 a1.707,1.707 0 0,1 -1.707,-1.707 z" stroke-width="1.833" stroke-dasharray="none">' +
        '</path>' +
        '</g>' +
        '</g>' +
        '</g>' +
        '</g>',
      icon: "add"
    },
    new_wooden_seat: {
      name: I18n.t("admin_local.seat_types.wooden_chair"),
      svg:
        '<g width="38" height="41" transform="scale(1,1) translate(157.48,125.24)" class="eatwithme-seat ui-draggable ui-draggable-handle" id="" eatwithme-seat-number="">	<g width="38" height="41">		<g transform="scale(0.3590562526888444,0.35860159509903217) translate(0,0)">			<g>				<g width="95.667" height="82.667" transform="scale(1,1) translate(5.167,31.167)">					<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#F2F2F2"						fill-opacity="1" stroke-opacity="1">						<path							d="M23.59,2.833 L23.59,2.833 L24.084,2.72 L24.578,2.609 L25.072,2.5 L25.566,2.394 L26.06,2.29 L26.554,2.188 L27.048,2.088 L27.542,1.991 L28.037,1.896 L28.531,1.804 L29.025,1.714 L29.519,1.626 L30.013,1.54 L30.507,1.457 L31.001,1.376 L31.495,1.297 L31.989,1.221 L32.483,1.147 L32.977,1.075 L33.472,1.006 L33.966,0.939 L34.46,0.874 L34.954,0.812 L35.448,0.752 L35.942,0.694 L36.436,0.638 L36.93,0.585 L37.424,0.534 L37.918,0.486 L38.412,0.439 L38.906,0.395 L39.401,0.354 L39.895,0.315 L40.389,0.278 L40.883,0.243 L41.377,0.21 L41.871,0.18 L42.365,0.153 L42.859,0.127 L43.353,0.104 L43.847,0.083 L44.341,0.065 L44.836,0.049 L45.33,0.035 L45.824,0.023 L46.318,0.014 L46.812,0.007 L47.306,0.002 L47.8,0 L48.294,0 L48.788,0.002 L49.282,0.007 L49.776,0.014 L50.271,0.023 L50.765,0.035 L51.259,0.049 L51.753,0.065 L52.247,0.083 L52.741,0.104 L53.235,0.127 L53.729,0.153 L54.223,0.18 L54.717,0.21 L55.211,0.243 L55.706,0.278 L56.2,0.315 L56.694,0.354 L57.188,0.395 L57.682,0.439 L58.176,0.486 L58.67,0.534 L59.164,0.585 L59.658,0.638 L60.152,0.694 L60.646,0.752 L61.14,0.812 L61.635,0.874 L62.129,0.939 L62.623,1.006 L63.117,1.075 L63.611,1.147 L64.105,1.221 L64.599,1.297 L65.093,1.376 L65.587,1.457 L66.081,1.54 L66.575,1.626 L67.07,1.714 L67.564,1.804 L68.058,1.896 L68.552,1.991 L69.046,2.088 L69.54,2.188 L70.034,2.29 L70.528,2.394 L71.022,2.5 L71.516,2.609 L72.01,2.72 L72.505,2.833 L72.505,2.833 L72.505,2.833 L72.998,3.028 L73.485,3.225 L73.965,3.423 L74.437,3.624 L74.903,3.826 L75.362,4.03 L75.814,4.236 L76.259,4.444 L76.697,4.654 L77.128,4.865 L77.552,5.079 L77.969,5.294 L78.38,5.511 L78.783,5.73 L79.179,5.951 L79.568,6.174 L79.951,6.399 L80.326,6.625 L80.695,6.854 L81.056,7.084 L81.411,7.316 L81.758,7.55 L82.099,7.786 L82.433,8.024 L82.76,8.263 L83.079,8.505 L83.392,8.748 L83.698,8.993 L83.997,9.24 L84.289,9.489 L84.574,9.74 L84.852,9.992 L85.123,10.247 L85.388,10.503 L85.645,10.761 L85.895,11.022 L86.138,11.284 L86.375,11.547 L86.604,11.813 L86.827,12.081 L87.042,12.35 L87.251,12.621 L87.452,12.894 L87.647,13.169 L87.835,13.446 L88.015,13.725 L88.189,14.006 L88.356,14.288 L88.516,14.572 L88.669,14.859 L88.815,15.147 L88.954,15.437 L89.086,15.728 L89.211,16.022 L89.329,16.318 L89.44,16.615 L89.545,16.914 L89.642,17.215 L89.732,17.518 L89.816,17.823 L89.892,18.13 L89.962,18.438 L90.024,18.749 L90.08,19.061 L90.129,19.375 L90.17,19.691 L90.205,20.009 L90.233,20.329 L90.254,20.651 L90.267,20.974 L90.274,21.299 L90.274,21.627 L90.267,21.956 L90.253,22.287 L90.232,22.62 L90.205,22.954 L90.17,23.291 L90.128,23.629 L90.079,23.969 L90.024,24.312 L89.961,24.656 L89.891,25.001 L89.815,25.349 L89.731,25.699 L89.641,26.05 L89.544,26.404 L89.439,26.759 L89.328,27.116 L89.21,27.475 L89.085,27.835 L88.952,28.198 L88.813,28.563 L88.667,28.929 L88.514,29.297 L88.354,29.667 L88.187,30.039 L88.013,30.413 L87.833,30.789 L87.645,31.166 L87.645,31.166 L87.645,31.166 L87.567,31.34 L87.491,31.515 L87.418,31.69 L87.348,31.866 L87.281,32.043 L87.216,32.221 L87.154,32.399 L87.095,32.578 L87.038,32.757 L86.984,32.938 L86.933,33.119 L86.884,33.3 L86.839,33.483 L86.795,33.666 L86.755,33.85 L86.717,34.034 L86.682,34.22 L86.65,34.406 L86.62,34.592 L86.593,34.78 L86.569,34.968 L86.547,35.157 L86.528,35.346 L86.512,35.537 L86.498,35.728 L86.487,35.919 L86.479,36.112 L86.474,36.305 L86.471,36.499 L86.471,36.693 L86.473,36.888 L86.479,37.084 L86.487,37.281 L86.497,37.478 L86.511,37.676 L86.527,37.875 L86.546,38.075 L86.567,38.275 L86.591,38.476 L86.618,38.678 L86.648,38.88 L86.68,39.083 L86.715,39.287 L86.752,39.491 L86.793,39.696 L86.836,39.902 L86.881,40.109 L86.93,40.316 L86.981,40.524 L87.035,40.733 L87.091,40.943 L87.15,41.153 L87.212,41.364 L87.277,41.575 L87.344,41.787 L87.414,42.001 L87.487,42.214 L87.562,42.429 L87.64,42.644 L87.721,42.86 L87.804,43.076 L87.89,43.294 L87.979,43.512 L88.07,43.73 L88.165,43.95 L88.261,44.17 L88.361,44.391 L88.463,44.612 L88.568,44.834 L88.676,45.057 L88.786,45.281 L88.899,45.506 L89.015,45.731 L89.133,45.956 L89.254,46.183 L89.378,46.41 L89.505,46.638 L89.634,46.867 L89.766,47.096 L89.9,47.326 L90.038,47.557 L90.178,47.789 L90.32,48.021 L90.466,48.254 L90.614,48.487 L90.764,48.722 L90.918,48.957 L91.074,49.193 L91.233,49.429 L91.394,49.666 L91.558,49.904 L91.725,50.143 L91.895,50.382 L92.067,50.622 L92.242,50.863 L92.42,51.104 L92.6,51.347 L92.783,51.589 L92.969,51.833 L92.969,51.833 L92.969,51.833 L93.18,52.37 L93.383,52.903 L93.578,53.431 L93.766,53.954 L93.946,54.473 L94.117,54.987 L94.282,55.496 L94.438,56.001 L94.586,56.501 L94.727,56.997 L94.86,57.488 L94.985,57.974 L95.102,58.456 L95.212,58.933 L95.314,59.406 L95.407,59.874 L95.494,60.338 L95.572,60.796 L95.642,61.251 L95.705,61.7 L95.76,62.145 L95.807,62.586 L95.846,63.021 L95.878,63.453 L95.901,63.879 L95.917,64.301 L95.925,64.719 L95.925,65.131 L95.918,65.539 L95.903,65.943 L95.879,66.342 L95.848,66.736 L95.81,67.126 L95.763,67.511 L95.709,67.892 L95.647,68.268 L95.577,68.639 L95.499,69.006 L95.413,69.368 L95.32,69.725 L95.219,70.078 L95.11,70.426 L94.993,70.77 L94.868,71.109 L94.736,71.444 L94.596,71.774 L94.448,72.099 L94.292,72.419 L94.128,72.736 L93.957,73.047 L93.778,73.354 L93.59,73.656 L93.396,73.954 L93.193,74.247 L92.983,74.535 L92.764,74.819 L92.538,75.098 L92.304,75.373 L92.063,75.643 L91.813,75.908 L91.556,76.169 L91.291,76.425 L91.018,76.677 L90.738,76.924 L90.449,77.166 L90.153,77.404 L89.849,77.637 L89.537,77.866 L89.217,78.089 L88.89,78.309 L88.554,78.524 L88.211,78.734 L87.86,78.939 L87.502,79.14 L87.135,79.336 L86.761,79.528 L86.379,79.715 L85.989,79.898 L85.591,80.076 L85.186,80.249 L84.772,80.418 L84.351,80.582 L83.922,80.741 L83.486,80.896 L83.041,81.046 L82.589,81.192 L82.129,81.333 L81.661,81.469 L81.185,81.601 L80.701,81.729 L80.21,81.851 L79.711,81.969 L79.204,82.083 L78.689,82.191 L78.167,82.296 L77.636,82.395 L77.098,82.49 L76.552,82.581 L75.998,82.666 L75.998,82.666 L75.998,82.666 L17.267,82.666 L17.267,82.666 L17.267,82.666 L16.774,82.56 L16.287,82.45 L15.808,82.336 L15.336,82.219 L14.871,82.098 L14.413,81.973 L13.962,81.844 L13.518,81.712 L13.082,81.576 L12.653,81.436 L12.231,81.293 L11.816,81.146 L11.408,80.995 L11.007,80.84 L10.614,80.682 L10.227,80.52 L9.848,80.355 L9.476,80.185 L9.112,80.012 L8.754,79.836 L8.403,79.655 L8.06,79.471 L7.724,79.283 L7.395,79.092 L7.073,78.896 L6.758,78.697 L6.451,78.495 L6.15,78.288 L5.857,78.078 L5.571,77.865 L5.292,77.647 L5.02,77.426 L4.756,77.201 L4.498,76.972 L4.248,76.74 L4.005,76.504 L3.769,76.264 L3.54,76.021 L3.319,75.774 L3.104,75.523 L2.897,75.268 L2.697,75.01 L2.504,74.748 L2.318,74.483 L2.14,74.213 L1.968,73.94 L1.804,73.663 L1.647,73.383 L1.497,73.099 L1.354,72.811 L1.218,72.519 L1.089,72.224 L0.968,71.925 L0.854,71.622 L0.747,71.316 L0.647,71.006 L0.554,70.692 L0.469,70.374 L0.39,70.053 L0.319,69.728 L0.255,69.4 L0.198,69.067 L0.148,68.731 L0.106,68.392 L0.07,68.048 L0.042,67.701 L0.021,67.35 L0.007,66.996 L0,66.637 L0,66.275 L0.008,65.91 L0.023,65.54 L0.044,65.167 L0.073,64.79 L0.11,64.41 L0.153,64.026 L0.203,63.638 L0.261,63.246 L0.326,62.851 L0.398,62.452 L0.477,62.049 L0.563,61.643 L0.657,61.232 L0.757,60.819 L0.865,60.401 L0.98,59.98 L1.102,59.555 L1.231,59.126 L1.368,58.694 L1.511,58.258 L1.662,57.818 L1.82,57.374 L1.985,56.927 L2.157,56.476 L2.336,56.022 L2.523,55.564 L2.717,55.102 L2.917,54.636 L3.125,54.166 L3.125,54.166 L3.125,54.166 L3.308,53.845 L3.488,53.526 L3.665,53.208 L3.839,52.891 L4.009,52.577 L4.176,52.263 L4.341,51.951 L4.502,51.641 L4.66,51.332 L4.815,51.025 L4.967,50.72 L5.115,50.415 L5.261,50.113 L5.403,49.812 L5.543,49.512 L5.679,49.214 L5.812,48.918 L5.942,48.623 L6.069,48.329 L6.192,48.038 L6.313,47.747 L6.431,47.459 L6.545,47.171 L6.656,46.886 L6.764,46.601 L6.87,46.319 L6.971,46.038 L7.07,45.758 L7.166,45.48 L7.259,45.204 L7.348,44.929 L7.434,44.655 L7.518,44.383 L7.598,44.113 L7.675,43.844 L7.749,43.577 L7.819,43.311 L7.887,43.047 L7.952,42.784 L8.013,42.523 L8.071,42.263 L8.126,42.005 L8.178,41.749 L8.227,41.494 L8.273,41.24 L8.316,40.988 L8.356,40.738 L8.392,40.489 L8.425,40.242 L8.456,39.996 L8.483,39.752 L8.507,39.509 L8.528,39.268 L8.546,39.028 L8.56,38.79 L8.572,38.553 L8.58,38.318 L8.585,38.085 L8.588,37.853 L8.587,37.623 L8.583,37.394 L8.576,37.166 L8.565,36.94 L8.552,36.716 L8.535,36.493 L8.516,36.272 L8.493,36.052 L8.467,35.834 L8.438,35.618 L8.406,35.403 L8.371,35.189 L8.333,34.977 L8.291,34.767 L8.247,34.558 L8.199,34.35 L8.148,34.144 L8.094,33.94 L8.037,33.737 L7.977,33.536 L7.914,33.336 L7.848,33.138 L7.778,32.941 L7.706,32.746 L7.63,32.553 L7.551,32.361 L7.469,32.17 L7.384,31.981 L7.296,31.794 L7.205,31.608 L7.11,31.423 L7.013,31.24 L6.912,31.059 L6.808,30.879 L6.701,30.701 L6.591,30.524 L6.478,30.349 L6.362,30.176 L6.243,30.004 L6.12,29.833 L6.12,29.833 L6.12,29.833 L6.003,29.442 L5.892,29.053 L5.788,28.667 L5.689,28.283 L5.596,27.902 L5.509,27.523 L5.428,27.146 L5.353,26.772 L5.284,26.4 L5.221,26.031 L5.164,25.664 L5.113,25.3 L5.068,24.938 L5.029,24.578 L4.996,24.221 L4.969,23.866 L4.948,23.513 L4.932,23.163 L4.923,22.816 L4.92,22.471 L4.923,22.128 L4.932,21.788 L4.947,21.45 L4.968,21.114 L4.994,20.781 L5.027,20.45 L5.066,20.122 L5.111,19.796 L5.161,19.473 L5.218,19.152 L5.281,18.833 L5.35,18.517 L5.424,18.203 L5.505,17.892 L5.592,17.583 L5.684,17.276 L5.783,16.972 L5.888,16.67 L5.998,16.371 L6.115,16.074 L6.237,15.78 L6.366,15.488 L6.5,15.198 L6.641,14.911 L6.787,14.626 L6.94,14.344 L7.099,14.064 L7.263,13.786 L7.433,13.511 L7.61,13.238 L7.792,12.968 L7.981,12.7 L8.175,12.435 L8.376,12.172 L8.582,11.911 L8.794,11.653 L9.013,11.397 L9.237,11.143 L9.467,10.892 L9.704,10.644 L9.946,10.398 L10.194,10.154 L10.449,9.913 L10.709,9.674 L10.975,9.437 L11.247,9.203 L11.526,8.971 L11.81,8.742 L12.1,8.515 L12.396,8.291 L12.698,8.069 L13.007,7.849 L13.321,7.632 L13.641,7.417 L13.967,7.205 L14.299,6.995 L14.637,6.788 L14.981,6.582 L15.331,6.38 L15.687,6.179 L16.049,5.982 L16.417,5.786 L16.791,5.593 L17.171,5.403 L17.557,5.214 L17.949,5.029 L18.347,4.845 L18.751,4.664 L19.161,4.486 L19.577,4.31 L19.999,4.136 L20.427,3.965 L20.861,3.796 L21.301,3.629 L21.746,3.465 L22.198,3.303 L22.656,3.144 L23.12,2.987 L23.59,2.833 L23.59,2.833 z"							stroke-width="1" stroke-dasharray="none" />					</g>				</g>				<g width="22" height="18" transform="scale(1,1) translate(67.5,23.333)">					<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#F2F2F2"						fill-opacity="1" stroke-opacity="1">						<path							d="M10,0 L0,12.667 L0.046,12.855 L0.093,13.041 L0.141,13.222 L0.19,13.401 L0.241,13.576 L0.292,13.748 L0.344,13.917 L0.397,14.082 L0.451,14.244 L0.507,14.403 L0.563,14.558 L0.62,14.71 L0.678,14.858 L0.738,15.004 L0.798,15.146 L0.859,15.284 L0.922,15.419 L0.985,15.551 L1.05,15.68 L1.115,15.805 L1.181,15.927 L1.249,16.046 L1.317,16.161 L1.387,16.273 L1.457,16.382 L1.529,16.487 L1.601,16.589 L1.675,16.687 L1.75,16.783 L1.825,16.875 L1.902,16.963 L1.979,17.048 L2.058,17.13 L2.138,17.209 L2.218,17.284 L2.3,17.356 L2.383,17.425 L2.467,17.49 L2.551,17.552 L2.637,17.61 L2.724,17.666 L2.812,17.718 L2.901,17.766 L2.991,17.811 L3.081,17.853 L3.173,17.892 L3.266,17.927 L3.36,17.959 L3.455,17.988 L3.551,18.013 L3.648,18.035 L3.746,18.053 L3.845,18.069 L3.945,18.081 L4.046,18.089 L4.148,18.094 L4.251,18.096 L4.355,18.095 L4.46,18.09 L4.567,18.082 L4.674,18.071 L4.782,18.056 L4.891,18.038 L5.001,18.016 L5.113,17.992 L5.225,17.964 L5.338,17.932 L5.452,17.897 L5.568,17.859 L5.684,17.818 L5.801,17.773 L5.92,17.725 L6.039,17.674 L6.159,17.619 L6.281,17.561 L6.403,17.499 L6.527,17.435 L6.651,17.367 L6.777,17.295 L6.903,17.22 L7.031,17.142 L7.159,17.061 L7.289,16.976 L7.419,16.888 L7.551,16.797 L7.683,16.702 L7.817,16.604 L7.952,16.502 L8.087,16.398 L8.224,16.29 L8.362,16.178 L8.501,16.063 L8.64,15.945 L8.781,15.824 L8.923,15.699 L9.066,15.571 L9.209,15.44 L9.354,15.305 L9.5,15.167 L9.5,15.167 L22,1.667 L10,0 z"							stroke-width="1" stroke-dasharray="none" />					</g>				</g>				<g width="22" height="18" transform="scale(1,1) translate(14.667,23.167)">					<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#F2F2F2"						fill-opacity="1" stroke-opacity="1">						<path							d="M11.5,0 L22,13.075 L21.929,13.241 L21.857,13.403 L21.785,13.563 L21.712,13.72 L21.639,13.874 L21.565,14.026 L21.49,14.175 L21.414,14.321 L21.338,14.464 L21.261,14.604 L21.184,14.742 L21.106,14.876 L21.027,15.008 L20.948,15.138 L20.868,15.264 L20.787,15.388 L20.706,15.509 L20.624,15.627 L20.541,15.742 L20.458,15.855 L20.374,15.964 L20.289,16.071 L20.204,16.175 L20.118,16.277 L20.032,16.376 L19.945,16.471 L19.857,16.565 L19.769,16.655 L19.679,16.742 L19.59,16.827 L19.499,16.909 L19.408,16.988 L19.317,17.065 L19.224,17.138 L19.131,17.209 L19.038,17.277 L18.943,17.343 L18.848,17.405 L18.753,17.465 L18.657,17.522 L18.56,17.576 L18.462,17.627 L18.364,17.676 L18.265,17.722 L18.166,17.765 L18.066,17.805 L17.965,17.843 L17.864,17.877 L17.762,17.909 L17.659,17.938 L17.556,17.965 L17.452,17.988 L17.347,18.009 L17.242,18.027 L17.136,18.043 L17.029,18.055 L16.922,18.065 L16.814,18.072 L16.706,18.076 L16.596,18.077 L16.487,18.076 L16.376,18.072 L16.265,18.065 L16.153,18.055 L16.041,18.042 L15.928,18.027 L15.814,18.009 L15.7,17.988 L15.585,17.964 L15.469,17.938 L15.353,17.909 L15.236,17.877 L15.118,17.842 L15,17.804 L14.881,17.764 L14.761,17.721 L14.641,17.675 L14.52,17.626 L14.399,17.575 L14.277,17.521 L14.154,17.464 L14.031,17.404 L13.907,17.341 L13.782,17.276 L13.657,17.208 L13.53,17.137 L13.404,17.063 L13.277,16.987 L13.149,16.908 L13.02,16.826 L12.891,16.741 L12.761,16.653 L12.63,16.563 L12.499,16.47 L12.367,16.374 L12.235,16.275 L12.102,16.174 L11.968,16.069 L11.833,15.962 L11.833,15.962 L0,1.698 L11.5,0 z"							stroke-width="1" stroke-dasharray="none" />					</g>				</g>				<g width="7" height="14.333" transform="scale(1,1) translate(41.333,22.5)">					<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#F2F2F2"						fill-opacity="1" stroke-opacity="1">						<path							d="M7,10.667 L6,0 L0,0 L1.667,11.5 L1.721,11.622 L1.775,11.74 L1.828,11.857 L1.882,11.97 L1.936,12.081 L1.99,12.19 L2.044,12.295 L2.098,12.398 L2.152,12.499 L2.206,12.596 L2.26,12.691 L2.314,12.784 L2.368,12.873 L2.422,12.96 L2.476,13.045 L2.53,13.127 L2.583,13.206 L2.637,13.282 L2.691,13.356 L2.745,13.427 L2.799,13.496 L2.853,13.562 L2.907,13.625 L2.961,13.685 L3.015,13.743 L3.069,13.798 L3.123,13.851 L3.176,13.901 L3.23,13.948 L3.284,13.993 L3.338,14.035 L3.392,14.074 L3.446,14.111 L3.5,14.145 L3.554,14.176 L3.608,14.205 L3.662,14.231 L3.715,14.254 L3.769,14.275 L3.823,14.293 L3.877,14.309 L3.931,14.322 L3.985,14.332 L4.039,14.339 L4.093,14.344 L4.146,14.346 L4.2,14.346 L4.254,14.343 L4.308,14.337 L4.362,14.329 L4.416,14.317 L4.47,14.304 L4.524,14.287 L4.577,14.268 L4.631,14.247 L4.685,14.222 L4.739,14.195 L4.793,14.166 L4.847,14.133 L4.901,14.098 L4.954,14.061 L5.008,14.021 L5.062,13.978 L5.116,13.932 L5.17,13.884 L5.224,13.833 L5.278,13.78 L5.331,13.723 L5.385,13.665 L5.439,13.603 L5.493,13.539 L5.547,13.472 L5.601,13.403 L5.654,13.331 L5.708,13.256 L5.762,13.179 L5.816,13.099 L5.87,13.016 L5.924,12.931 L5.977,12.843 L6.031,12.752 L6.085,12.659 L6.139,12.563 L6.193,12.464 L6.247,12.363 L6.3,12.259 L6.354,12.152 L6.408,12.043 L6.462,11.931 L6.516,11.817 L6.57,11.7 L6.623,11.58 L6.677,11.457 L6.731,11.332 L6.785,11.204 L6.839,11.074 L6.892,10.941 L6.946,10.805 L7,10.667 L7,10.667 z"							stroke-width="1" stroke-dasharray="none" />					</g>				</g>				<g width="7.167" height="14.167" transform="scale(1,1) translate(55.833,22.5)">					<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#F2F2F2"						fill-opacity="1" stroke-opacity="1">						<path							d="M0,10.582 L0,10.582 L0.5,0 L0.5,0 L0.5,0 L7.167,0 L7.167,0 L7.167,0 L4.833,11.436 L4.833,11.436 L4.833,11.436 L4.756,11.551 L4.679,11.663 L4.603,11.773 L4.527,11.88 L4.452,11.985 L4.378,12.087 L4.304,12.187 L4.23,12.284 L4.158,12.379 L4.086,12.471 L4.014,12.561 L3.943,12.648 L3.873,12.733 L3.803,12.815 L3.734,12.895 L3.665,12.972 L3.597,13.046 L3.529,13.118 L3.462,13.188 L3.396,13.255 L3.33,13.32 L3.265,13.382 L3.201,13.441 L3.137,13.498 L3.073,13.552 L3.01,13.604 L2.948,13.654 L2.887,13.7 L2.825,13.745 L2.765,13.787 L2.705,13.826 L2.646,13.863 L2.587,13.897 L2.529,13.929 L2.471,13.958 L2.414,13.984 L2.358,14.009 L2.302,14.03 L2.247,14.049 L2.192,14.066 L2.138,14.08 L2.085,14.092 L2.032,14.101 L1.979,14.107 L1.928,14.111 L1.876,14.112 L1.826,14.111 L1.776,14.108 L1.727,14.102 L1.678,14.093 L1.629,14.082 L1.582,14.068 L1.535,14.052 L1.488,14.033 L1.442,14.012 L1.397,13.988 L1.352,13.962 L1.308,13.933 L1.265,13.902 L1.222,13.868 L1.179,13.832 L1.137,13.793 L1.096,13.752 L1.055,13.708 L1.015,13.661 L0.976,13.612 L0.937,13.561 L0.899,13.507 L0.861,13.45 L0.824,13.391 L0.787,13.33 L0.751,13.266 L0.716,13.199 L0.681,13.13 L0.647,13.058 L0.613,12.984 L0.58,12.907 L0.548,12.828 L0.516,12.746 L0.484,12.662 L0.454,12.575 L0.423,12.486 L0.394,12.394 L0.365,12.3 L0.336,12.203 L0.309,12.104 L0.281,12.002 L0.255,11.897 L0.229,11.79 L0.203,11.681 L0.178,11.569 L0.154,11.454 L0.13,11.337 L0.107,11.218 L0.084,11.096 L0.062,10.971 L0.041,10.844 L0.02,10.714 L0,10.582 L0,10.582 z"							stroke-width="1" stroke-dasharray="none" />					</g>				</g>				<g width="104.833" height="28.5" transform="scale(1,1) translate(0.5,0.5)">					<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#F2F2F2"						fill-opacity="1" stroke-opacity="1">						<path							d="M10.803,3.664 L8.803,4.071 L6.802,4.479 L5.202,5.7 L3.601,6.921 L2.001,8.55 L1.2,10.586 L0.4,13.029 L0,15.064 L0,17.1 L0.4,19.543 L1.2,21.579 L2.001,23.207 L3.601,24.836 L5.202,26.464 L6.802,27.279 L8.803,28.093 L10.803,28.5 L13.604,28.5 L16.005,28.093 L18.806,28.093 L21.207,27.686 L24.008,27.279 L26.408,26.871 L28.809,26.464 L31.61,26.057 L34.011,25.65 L36.812,25.243 L39.212,24.836 L42.013,24.836 L44.414,24.429 L47.215,24.021 L49.616,24.021 L52.417,24.021 L55.218,24.021 L57.618,24.021 L60.419,24.429 L62.82,24.836 L65.621,24.836 L68.022,25.243 L70.823,25.65 L73.223,26.057 L76.024,26.464 L78.825,26.871 L81.226,27.279 L84.027,27.686 L86.427,28.093 L89.228,28.093 L91.629,28.5 L94.43,28.5 L96.431,28.093 L98.431,27.279 L100.032,26.464 L101.632,24.836 L103.233,23.207 L104.033,21.579 L104.833,19.543 L104.833,17.1 L104.833,15.064 L104.833,13.029 L104.033,10.586 L103.233,8.55 L102.032,6.921 L100.432,5.7 L98.831,4.479 L96.831,4.071 L94.83,3.664 L92.029,3.664 L89.628,3.664 L86.828,3.257 L84.027,3.257 L81.226,2.85 L78.825,2.443 L76.024,2.443 L73.223,2.036 L70.823,2.036 L68.022,1.629 L65.221,1.221 L62.82,0.814 L59.619,0.814 L57.218,0.814 L54.417,0 L51.616,0 L49.216,0 L46.815,0.814 L44.014,0.814 L41.613,0.814 L39.212,1.221 L36.412,1.629 L34.011,2.036 L31.21,2.036 L28.809,2.443 L26.008,2.443 L23.608,2.85 L20.807,3.257 L18.806,3.257 L16.005,3.664 L13.604,3.664 L10.803,3.664 z"							stroke-width="1" stroke-dasharray="none" />					</g>				</g>				<g width="102.667" height="17.5" transform="scale(1,1) translate(1.333,11.5)">					<g transform="scale(1,1) translate(0,0)" stroke="#000000" fill="#F2F2F2"						fill-opacity="1" stroke-opacity="1">						<path							d="M10.58,2.25 L8.621,2.5 L6.662,2.75 L5.094,3.5 L3.527,4.25 L1.959,5.25 L1.176,6.5 L0.392,8 L0,9.25 L0,10.5 L0.392,12 L1.176,13.25 L1.959,14.25 L3.527,15.25 L5.094,16.25 L6.662,16.75 L8.621,17.25 L10.58,17.5 L13.323,17.5 L15.674,17.25 L18.417,17.25 L20.768,17 L23.511,16.75 L25.863,16.5 L28.214,16.25 L30.957,16 L33.308,15.75 L36.051,15.5 L38.402,15.25 L41.145,15.25 L43.496,15 L46.239,14.75 L48.59,14.75 L51.333,14.75 L54.076,14.75 L56.427,14.75 L59.17,15 L61.522,15.25 L64.265,15.25 L66.616,15.5 L69.359,15.75 L71.71,16 L74.453,16.25 L77.196,16.5 L79.547,16.75 L82.29,17 L84.641,17.25 L87.384,17.25 L89.735,17.5 L92.478,17.5 L94.438,17.25 L96.397,16.75 L97.964,16.25 L99.532,15.25 L101.099,14.25 L101.883,13.25 L102.667,12 L102.667,10.5 L102.667,9.25 L102.667,8 L101.883,6.5 L101.099,5.25 L99.924,4.25 L98.356,3.5 L96.789,2.75 L94.83,2.5 L92.87,2.25 L90.127,2.25 L87.776,2.25 L85.033,2 L82.29,2 L79.547,1.75 L77.196,1.5 L74.453,1.5 L71.71,1.25 L69.359,1.25 L66.616,1 L63.873,0.75 L61.522,0.5 L58.387,0.5 L56.036,0.5 L53.293,0 L50.55,0 L48.198,0 L45.847,0.5 L43.104,0.5 L40.753,0.5 L38.402,0.75 L35.659,1 L33.308,1.25 L30.565,1.25 L28.214,1.5 L25.471,1.5 L23.12,1.75 L20.377,2 L18.417,2 L15.674,2.25 L13.323,2.25 L10.58,2.25 z"							stroke-width="1" stroke-dasharray="none" />					</g>				</g>			</g>		</g>	</g>	<g fill="#9999FF" stroke="#9999FF" stroke-opacity="1"		transform="scale(1,1) translate(0,0)" opacity="0">		<path fill="none" stroke-width="1" stroke-dasharray="none" d="M0,0" />	</g>	<g width="27.02094841003418" height="15.833333015441895"		transform="scale(1,1) translate(5.49,-21.833)" opacity="0">		<text width="27.02094841003418" height="15.833333015441895"			transform="scale(1,1) translate(0,0)" xml:space="preserve"><tspan			xml:space="preserve" text-rendering="optimizeSpeed" font-size="13.88888888888889"			font-weight="normal" font-style="normal" fill="#000" opacity="1" x="0"			text-anchor="start" y="12.5" textLength="27.02094841003418"			style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;">0.48</tspan></text>	</g>	<g transform="scale(1,1) translate(0,0)" fill="black" opacity="0">		<path d="M1.531,-17.875 L1.531,-9.958 L-6.385,-13.917 L1.531,-17.875 z" />	</g>	<g transform="scale(1,1) translate(0,0)" fill="black" opacity="0">		<path			d="M36.469,-17.875 L36.469,-9.958 L44.385,-13.917 L36.469,-17.875 z" />	</g>	<g width="27.02094841003418" height="15.833333015441895"		transform="rotate(270,44,34.01) scale(1,1) translate(44,34.01)"		opacity="0">		<text width="27.02094841003418" height="15.833333015441895"			transform="scale(1,1) translate(0,0)" xml:space="preserve"><tspan			xml:space="preserve" text-rendering="optimizeSpeed" font-size="13.88888888888889"			font-weight="normal" font-style="normal" fill="#000" opacity="1" x="0"			text-anchor="start" y="12.5" textLength="27.02094841003418"			style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif;">0.52</tspan></text>	</g>	<g transform="scale(1,1) translate(0,0)" fill="black" opacity="0">		<path d="M55.875,3.031 L47.958,3.031 L51.917,-4.885 L55.875,3.031 z" />	</g>	<g transform="scale(1,1) translate(0,0)" fill="black" opacity="0">		<path d="M55.875,37.969 L47.958,37.969 L51.917,45.885 L55.875,37.969 z" />	</g></g>',
      icon: "add"
    }
  },
  tableMainTemplate: '<g width="118.667" height="118.167" transform="scale(1,1) translate(XXX,YYY)" class="ui-draggable ui-draggable-handle" style="position: relative;"></g>',

  used: false,
  initTableLayout: () => {
    tableLayout.used = true;
  }
};

export default tableLayout;

function findSmallestMissingPositiveNumber() {

  const arr = $('svg[visible = "true"] g.eatwithme-table').map((ind, t) => Number(t.id));

  // Create a Set from the array to enable O(1) lookups
  const numSet = new Set(arr);

  // Start checking from the smallest positive number 1
  let i = 1;

  // Keep checking for the smallest missing positive number
  while (numSet.has(i)) {
    i++;
  }

  // Return the first missing positive number
  return i;
}
